var xr = Object.defineProperty;
var Cr = (e, t, n) => t in e ? xr(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var de = (e, t, n) => Cr(e, typeof t != "symbol" ? t + "" : t, n);
import { defineComponent as Q, ref as B, openBlock as y, createElementBlock as I, mergeProps as Re, Comment as Tr, Text as kr, Fragment as bt, useSlots as Pe, computed as k, createBlock as H, resolveDynamicComponent as tt, withCtx as G, createElementVNode as V, normalizeClass as P, createVNode as oe, unref as F, renderSlot as R, createCommentVNode as z, createTextVNode as bo, withModifiers as Dn, toDisplayString as Z, resolveComponent as Sr, getCurrentInstance as pn, onMounted as mn, nextTick as Ar, watch as ae, getCurrentScope as wo, onScopeDispose as go, hasInjectionContext as yo, inject as Ir, isRef as Er, toValue as W, toRef as vn, readonly as Mr, customRef as Fr, shallowRef as Ce, watchEffect as zr, useAttrs as bn, shallowReadonly as Ee, useTemplateRef as Oe, withDirectives as nt, Transition as xo, normalizeStyle as Ln, useId as ot, useModel as He, vModelCheckbox as Or, mergeModels as Te, vModelText as Co, createSlots as To, onBeforeUnmount as Nr, Teleport as Dr, withKeys as qt, renderList as $n, vShow as Lr } from "vue";
const $r = "groover", _r = 1742310275, Rr = {
  charts: {
    body: '<path fill="currentColor" d="M14.968 7.08q0-.215.093-.413.094-.198.265-.35.173-.152.397-.235c.148-.054.307-.082.468-.082h5.587c.324 0 .635.114.864.316.23.203.358.478.358.764s-.129.562-.358.764c-.23.203-.54.317-.864.317H16.19c-.16 0-.32-.028-.468-.082a1.2 1.2 0 01-.397-.235c-.113-.1-.203-.22-.265-.35a1 1 0 01-.093-.414m6.81 7.563H12a1.3 1.3 0 00-.864.316c-.23.203-.358.478-.358.764s.129.562.358.764c.229.203.54.317.864.317h9.778c.324 0 .635-.114.864-.317.23-.202.358-.477.358-.764 0-.286-.129-.561-.358-.764a1.3 1.3 0 00-.864-.316m0-4.36H12a1.3 1.3 0 00-.864.316c-.23.203-.358.478-.358.764s.129.562.358.764c.229.203.54.317.864.317h9.778c.324 0 .635-.114.864-.317.23-.202.358-.477.358-.764 0-.286-.129-.561-.358-.764a1.3 1.3 0 00-.864-.316M10.603 8.16H7.635v6.907c0 .58-.194 1.147-.559 1.629a3.26 3.26 0 01-1.489 1.08 3.7 3.7 0 01-1.917.167 3.47 3.47 0 01-1.698-.803 2.85 2.85 0 01-.908-1.501 2.62 2.62 0 01.189-1.695 3.04 3.04 0 011.221-1.316 3.64 3.64 0 011.844-.494c.295.004.589.043.873.116V7.08c0-.287.128-.562.358-.765S6.089 6 6.413 6h4.19c.324 0 .635.114.864.316.23.203.358.478.358.764s-.129.562-.358.764c-.229.203-.54.317-.864.317"/>',
    width: 24,
    height: 24
  },
  logo: {
    body: '<path xmlns="http://www.w3.org/2000/svg" fill="currentColor" d="M101.447 30.545c0 13.948-6.004 25.907-14.596 31.045a3 3 0 01-1.539.41h-15.73a3.03 3.03 0 01-1.539-.41c-4.795-2.869-8.789-7.881-11.375-14.162a.35.35 0 00-.67.056c-1.407 5.836-3.529 10.54-6.08 13.472a3.05 3.05 0 01-2.299 1.04H40.04a3.03 3.03 0 01-2.309-1.05c-3.224-3.73-5.765-10.33-7.052-18.411-.066-.42-.658-.4-.703.02-.815 7.662-2.41 13.995-4.431 17.792-.538 1.008-1.574 1.65-2.704 1.65h-3.499a3.05 3.05 0 01-2.697-1.626c-1.803-3.366-3.266-8.725-4.136-15.234-.056-.43-.673-.41-.714.021-.552 6.235-1.443 11.392-2.552 14.782C8.837 61.18 7.66 62 6.362 62h-.264c-1.352 0-2.53-.82-2.936-2.07C1.266 54.14 0 43.155 0 30.545c-.01-11.9 1.11-22.341 2.826-28.352A3.05 3.05 0 015.752 0h.87a3.06 3.06 0 012.937 2.203c.956 3.366 1.726 8.116 2.222 13.717.031.431.659.442.714.021.78-5.835 2.035-10.75 3.585-14.127C16.597.708 17.675 0 18.874 0h4.424c1.2 0 2.278.697 2.784 1.793 1.772 3.875 3.159 9.756 3.904 16.74.045.42.638.431.704.021 1.165-7.341 3.377-13.475 6.181-17.328A3.01 3.01 0 0139.323 0h9.042c.967 0 1.879.441 2.45 1.23 2.147 2.945 3.96 7.24 5.19 12.378a.353.353 0 00.673.056c2.299-5.58 5.697-10.15 9.791-13.121A3 3 0 0168.22 0H86.7c.627 0 1.245.179 1.75.553 7.722 5.612 13.002 16.93 13.002 29.992"/>',
    width: 101.45,
    height: 62
  },
  "opportunity-advice": {
    body: '<g fill="currentColor"><path d="M25.386 25.526a2.49 2.49 0 002.489-2.489v-9.55a2.49 2.49 0 00-2.489-2.49H12.492a2.49 2.49 0 00-2.49 2.49v9.55a2.49 2.49 0 002.49 2.49h.375v3.262c0 .23.139.444.358.53a.57.57 0 00.63-.12l3.672-3.673zm-11.358-.577a.58.58 0 00-.578-.578h-.952c-.734 0-1.334-.6-1.334-1.334v-9.55c0-.734.6-1.335 1.334-1.335h12.894c.734 0 1.334.601 1.334 1.334v9.551c0 .734-.6 1.334-1.334 1.334h-8.095a.6.6 0 00-.22.046.6.6 0 00-.19.127l-2.853 2.853v-2.442z"/><path d="M33.505 18.643H29.21a.58.58 0 00-.578.577c0 .318.26.578.578.578h4.296c.733 0 1.334.6 1.334 1.334v9.55c0 .734-.6 1.335-1.334 1.335h-.953a.58.58 0 00-.577.577v2.443l-2.853-2.853a.55.55 0 00-.19-.127.6.6 0 00-.22-.046h-8.095c-.734 0-1.334-.6-1.334-1.334v-3.823a.58.58 0 00-.578-.577.58.58 0 00-.577.577v3.823a2.49 2.49 0 002.489 2.489h7.859l3.672 3.672a.581.581 0 00.988-.41v-3.262h.375A2.49 2.49 0 0036 30.677v-9.551a2.49 2.49 0 00-2.489-2.489z"/><path d="M32.553 27.715H21.09a.58.58 0 00-.577.577c0 .318.26.578.577.578h11.463a.58.58 0 00.577-.578.58.58 0 00-.578-.577m-3.343-1.235h3.343a.58.58 0 00.578-.578.58.58 0 00-.578-.578H29.21a.58.58 0 00-.577.578c0 .317.26.577.577.577m-.001-2.385h3.343a.58.58 0 00.578-.577.58.58 0 00-.578-.578H29.21a.58.58 0 00-.577.578c0 .317.26.577.577.577M12.273 9.549a.58.58 0 00.577-.578V6.39a.58.58 0 00-.577-.577.58.58 0 00-.578.577v2.58c0 .318.26.578.578.578M7.815 7.995a.575.575 0 10-.814.814l1.825 1.825a.59.59 0 00.82 0 .575.575 0 000-.814L7.82 7.995zm.155 4.701H5.39a.58.58 0 00-.578.577c0 .318.26.578.577.578h2.582a.58.58 0 00.577-.578.58.58 0 00-.577-.577m10.971 8.748 2.223 1.172a.6.6 0 00.272.064.578.578 0 00.572-.676l-.428-2.477 1.802-1.756a.58.58 0 00-.324-.987l-2.489-.364-1.114-2.252c-.196-.393-.843-.393-1.034 0l-1.114 2.252-2.489.364a.58.58 0 00-.468.393.58.58 0 00.145.594l1.801 1.756-.427 2.477a.58.58 0 00.231.566.59.59 0 00.606.046l2.224-1.172zm-2.795-3.684 1.629-.237a.56.56 0 00.433-.318l.727-1.478.728 1.478a.58.58 0 00.433.318l1.628.237-1.178 1.149a.58.58 0 00-.167.514l.277 1.622-1.455-.768a.59.59 0 00-.537 0l-1.455.768.277-1.622a.57.57 0 00-.167-.514l-1.178-1.15z"/></g>'
  },
  "opportunity-article": {
    body: '<g fill="currentColor"><path d="M33.848 5.839H8.155A3.156 3.156 0 005.004 8.99v24.202a3.156 3.156 0 003.152 3.151h25.692A3.156 3.156 0 0037 33.194V8.99a3.16 3.16 0 00-3.152-3.152M8.155 6.899h25.691c1.153 0 2.091.94 2.091 2.092v1.48H6.064v-1.48c0-1.154.938-2.092 2.09-2.092m25.693 28.387H8.155a2.093 2.093 0 01-2.092-2.092V11.531H35.94v21.662a2.094 2.094 0 01-2.091 2.093"/><path d="M8.677 9.423h1.862a.53.53 0 100-1.06H8.677a.53.53 0 100 1.06m4.535 0h1.861a.53.53 0 100-1.06h-1.86a.53.53 0 100 1.06m4.537 0h1.861a.53.53 0 100-1.06h-1.86a.53.53 0 100 1.06m15.791 4.025H8.46a.53.53 0 00-.53.53v5.77c0 .293.238.53.53.53h25.084a.53.53 0 00.53-.53V13.98a.53.53 0 00-.532-.531m-.528 5.77H8.99v-4.71h24.022zm.528 6.017h-7.165a.53.53 0 00-.53.53v7.164c0 .293.237.53.53.53h7.165a.53.53 0 00.53-.53l.001-7.164a.53.53 0 00-.531-.53m-.529 7.166H26.91v-6.105h6.105zm.529-9.984H8.46a.53.53 0 100 1.06h25.084a.53.53 0 10-.002-1.06M22.84 25.617H8.46a.53.53 0 100 1.06h14.38a.53.53 0 100-1.06m0 3.203H8.46a.53.53 0 100 1.06h14.38a.53.53 0 100-1.06m0 3.199H8.46a.53.53 0 100 1.06h14.38a.53.53 0 100-1.06"/></g>'
  },
  "opportunity-audio-interview": {
    body: '<g fill="currentColor"><path d="M12.886 17.76a.66.66 0 00.065-.931 3.9 3.9 0 01-.953-2.567c0-.948.339-1.86.953-2.567a.66.66 0 10-.996-.865 5.23 5.23 0 00-1.275 3.432c0 1.267.452 2.485 1.275 3.432a.656.656 0 00.93.064zm17.203-6.93a.66.66 0 00-.995.866c.614.707.953 1.619.953 2.567s-.34 1.86-.953 2.567a.66.66 0 00.996.866 5.23 5.23 0 001.276-3.432 5.23 5.23 0 00-1.276-3.432z"/><path d="M32.094 9.114a.66.66 0 10-1.001.859 6.58 6.58 0 011.588 4.29 6.58 6.58 0 01-1.588 4.29.66.66 0 001.001.86 7.906 7.906 0 000-10.298M9.361 14.263c0-1.576.564-3.098 1.587-4.29a.66.66 0 00-1-.859 7.9 7.9 0 00-1.906 5.149c0 1.89.678 3.719 1.906 5.149a.659.659 0 101-.86 6.58 6.58 0 01-1.587-4.29zm19.571 6.952a.66.66 0 00-.659.66 4.813 4.813 0 01-4.808 4.807H18.58a4.813 4.813 0 01-4.808-4.808.659.659 0 10-1.317 0A6.133 6.133 0 0018.579 28h1.784v2.637h-3.296a1.98 1.98 0 00-1.977 1.977 1.98 1.98 0 001.977 1.978h7.91a1.98 1.98 0 001.977-1.978 1.98 1.98 0 00-1.977-1.977h-3.296V28h1.783a6.133 6.133 0 006.127-6.126.66.66 0 00-.66-.659m-3.296 11.399a.66.66 0 01-.66.659h-7.91a.66.66 0 010-1.318h7.91a.66.66 0 01.66.659"/><path d="M18.579 25.363h4.886a3.493 3.493 0 003.489-3.49V10.397a3.493 3.493 0 00-3.489-3.489h-4.887a3.493 3.493 0 00-3.488 3.49v11.477a3.493 3.493 0 003.488 3.489m0-17.139h4.886c1.198 0 2.172.974 2.172 2.17v1.125h-1.978a.659.659 0 100 1.318h1.978v2.636h-1.978a.658.658 0 100 1.317h1.978v2.637h-1.978a.659.659 0 100 1.317h1.978v1.125a2.174 2.174 0 01-2.172 2.171h-4.887a2.173 2.173 0 01-2.17-2.171v-1.125h1.978a.66.66 0 000-1.317h-1.978V16.79h1.978a.66.66 0 000-1.317h-1.978v-2.636h1.978a.66.66 0 000-1.318h-1.978v-1.124c0-1.198.974-2.17 2.17-2.17"/></g>'
  },
  "opportunity-channel": {
    body: '<g fill="currentColor" stroke="currentColor" stroke-width=".1"><path d="M6.526 29.012H35.78l.003.004h.02c.56 0 1.011-.455 1.011-1.011V8.019c0-.56-.455-1.01-1.01-1.01H6.526c-.56 0-1.01.455-1.01 1.01v19.982c0 .56.454 1.011 1.01 1.011Zm29.12-20.84v19.677H6.68V8.172z"/><path d="M17.614 22.685h.05v-.005a.6.6 0 00.24-.076l7.094-4.094a.584.584 0 000-1.008l-7.093-4.094a.584.584 0 00-.873.504v8.192c0 .21.113.4.29.504h.001a.6.6 0 00.29.077Zm.581-7.769 5.349 3.09-5.349 3.09zm-4.763 19.549H36.23a.581.581 0 100-1.163H13.432a.581.581 0 100 1.163Zm-7.335 0h3.215a.581.581 0 100-1.163H6.097a.581.581 0 100 1.163Z"/><path d="M8.734 33.883a2.64 2.64 0 002.638 2.637 2.643 2.643 0 002.638-2.637 2.643 2.643 0 00-2.638-2.638 2.643 2.643 0 00-2.638 2.638Zm1.164-.004c0-.812.661-1.474 1.474-1.474s1.474.662 1.474 1.474c0 .813-.662 1.474-1.474 1.474a1.476 1.476 0 01-1.474-1.474Z"/></g>'
  },
  "opportunity-detailed-feedback": {
    body: '<g fill="none"><rect/><path fill="currentColor" d="M33.011 24.616A1.397 1.397 0 0034.4 23.22v-7.905a1.396 1.396 0 00-1.388-1.397H19.573a1.397 1.397 0 00-1.388 1.397V25.96c.32-.043.961-.37 1.575-.682.662-.338 1.295-.66 1.64-.66zm-5.049-5.349-3.64-2.115v4.23zm.75-.261a.303.303 0 010 .522l-4.521 2.627a.3.3 0 01-.169.052.3.3 0 01-.3-.302v-5.276a.3.3 0 01.041-.15.3.3 0 01.41-.11zm-2.12 6.215v7.275A1.503 1.503 0 0125.1 34H10.67a1.505 1.505 0 01-1.494-1.504V7.384a1.503 1.503 0 011.494-1.503h14.429a1.505 1.505 0 011.494 1.504v5.927h6.418c.546 0 1.043.225 1.403.588.362.365.586.865.586 1.414v7.906c0 .549-.224 1.049-.584 1.412a1.98 1.98 0 01-1.405.59zm-.6-11.909V7.384a.9.9 0 00-.893-.898H10.67a.9.9 0 00-.893.899v25.111a.9.9 0 00.893.9h14.429a.9.9 0 00.893-.899V25.22H21.4c-.206 0-.776.29-1.372.594-.72.368-1.476.753-1.908.753-.337 0-.537-.15-.537-.516V15.314a2 2 0 01.584-1.412c.362-.365.86-.59 1.405-.59zM15.748 9.014a.302.302 0 010-.605h4.27a.302.302 0 010 .605z"/><path fill="currentColor" fill-rule="evenodd" d="M33.778 23.995c.199-.2.32-.474.32-.776v-7.905a1.096 1.096 0 00-1.087-1.097H19.573a1.1 1.1 0 00-1.088 1.097v10.241q.113-.045.253-.109c.27-.123.577-.28.885-.436l.008-.004c.326-.167.656-.335.949-.461.282-.122.579-.229.82-.229h11.611c.299 0 .57-.123.767-.32m-15.293 1.881a1.5 1.5 0 01-.3.082V15.315a1.397 1.397 0 011.388-1.397H33.01a1.396 1.396 0 011.388 1.397v7.906a1.397 1.397 0 01-1.388 1.396H21.4c-.345 0-.978.323-1.64.66h-.001c-.458.234-.931.476-1.275.6m7.244 7.256a.9.9 0 01-.63.263H10.67a.9.9 0 01-.893-.899V7.384a.9.9 0 01.893-.898h14.429a.9.9 0 01.893.899v5.927h-6.42c-.544 0-1.042.225-1.404.59a2 2 0 00-.584 1.412v10.738c0 .366.2.516.537.516.432 0 1.187-.385 1.907-.752h.001c.596-.304 1.166-.595 1.372-.595h4.59v7.275a.9.9 0 01-.262.636m-.038-7.61v6.974a.6.6 0 01-.592.6H10.67a.6.6 0 01-.593-.599V7.383a.6.6 0 01.593-.598h14.429a.6.6 0 01.593.599v5.627h-6.12c-.629 0-1.201.26-1.617.678a2.3 2.3 0 00-.671 1.624v10.738c0 .236.066.46.24.618.17.153.39.198.597.198.284 0 .631-.12.964-.263.342-.146.718-.337 1.074-.519l.007-.003c.299-.153.584-.298.82-.406a4 4 0 01.296-.122c.076-.027.11-.032.117-.034h4.292m-1.368-9.413c.088.051 4.703 2.763 4.758 2.857a.603.603 0 01-.219.821L24.35 22.41a.602.602 0 01-.927-.505v-5.282a.6.6 0 01.08-.294m.689 5.826 4.52-2.627a.303.303 0 000-.522l-4.538-2.638a.3.3 0 00-.41.11.3.3 0 00-.041.151v5.276a.302.302 0 00.469.25m.132-6.046a.6.6 0 00-.82.22ZM9.616 33.559a1.5 1.5 0 01-.44-1.063V7.384a1.503 1.503 0 011.494-1.503h14.429a1.505 1.505 0 011.494 1.504v5.927h6.418c.546 0 1.043.225 1.403.588.362.365.586.865.586 1.414v7.906c0 .549-.224 1.049-.584 1.412a1.98 1.98 0 01-1.405.59h-6.419v7.274A1.503 1.503 0 0125.1 34H10.67c-.41 0-.783-.169-1.054-.441m17.276-8.038v6.975c0 .496-.201.947-.525 1.273a1.8 1.8 0 01-1.268.531H10.67a1.806 1.806 0 01-1.794-1.804V7.384a1.803 1.803 0 011.794-1.803h14.429a1.806 1.806 0 011.794 1.804v5.627h6.118c.63 0 1.203.26 1.616.677.415.418.673.993.673 1.625v7.906a2.3 2.3 0 01-.671 1.623 2.28 2.28 0 01-1.618.678zm-2.57-8.369v4.23l3.64-2.115zm.3.521 2.743 1.594-2.742 1.593zM15.75 9.315a.602.602 0 010-1.205h4.27a.602.602 0 010 1.205zm-.3-.602c0 .167.135.302.3.302h4.27a.302.302 0 000-.605h-4.27c-.165 0-.3.136-.3.303" clip-rule="evenodd"/><path fill="currentColor" d="M19 31a1 1 0 11-2 0 1 1 0 012 0"/></g>'
  },
  "opportunity-dj-set": {
    body: '<g fill="currentColor"><path d="M18.616 13.769a7.23 7.23 0 107.23 7.23 7.243 7.243 0 00-7.23-7.23m0 13.184a5.954 5.954 0 115.953-5.954 5.96 5.96 0 01-5.953 5.954"/><path d="M18.616 18.447a2.553 2.553 0 100 5.105 2.553 2.553 0 000-5.105m0 3.829a1.276 1.276 0 110-2.553 1.276 1.276 0 010 2.553"/><path d="M34.92 7.478h-1.972a2.086 2.086 0 00-2.08 2.086v4.352a2.08 2.08 0 002.08 2.08h.344v1.06a2.73 2.73 0 01-1.276 2.22A13.438 13.438 0 1032.138 21v-.293l.638-.383a3.83 3.83 0 001.831-3.267v-1.06h.351A2.08 2.08 0 0037 13.916V9.564a2.087 2.087 0 00-2.08-2.086M18.616 33.245A12.245 12.245 0 1130.804 20.01l-1.276.779a2.074 2.074 0 10.65 1.097l.639-.395a12.25 12.25 0 01-12.201 11.754M28.96 22.339a.804.804 0 11-1.608 0 .804.804 0 011.608 0m6.764-8.423a.81.81 0 01-.804.804h-1.972a.804.804 0 01-.804-.804V9.564a.804.804 0 01.804-.81h1.972a.81.81 0 01.804.81z"/><path d="M21.213 12.149a.639.639 0 10-.364 1.225c.602.179 1.18.427 1.723.74a.64.64 0 00.32.083.64.64 0 00.555-.32.64.64 0 00-.236-.867 9.4 9.4 0 00-1.998-.861"/><path d="M13.339 12.48a.64.64 0 00.319-.083 9.93 9.93 0 019.91 0 .64.64 0 00.867-.236.64.64 0 00-.197-.867 11.3 11.3 0 00-8.462-1.143c-.964.257-1.891.639-2.756 1.136a.638.638 0 00.319 1.187zm5.277 17.74a.638.638 0 000-1.276 7.9 7.9 0 01-3.95-1.06.639.639 0 10-.638 1.104 9.17 9.17 0 004.588 1.232"/><path d="M23.6 29.601a9.93 9.93 0 01-9.91 0 .638.638 0 00-.639 1.104c.855.497 1.771.881 2.725 1.142a11.2 11.2 0 008.462-1.142.638.638 0 00-.639-1.104"/></g>'
  },
  "opportunity-live-events": {
    body: '<g fill="none"><rect/><path fill="currentColor" d="M35.878 22.982a.32.32 0 00.322-.323V18.1a.32.32 0 00-.322-.323h-3.223l-.334-.718c-.072-.168-.263-.227-.43-.156a1.627 1.627 0 01-2.148-.801 1.64 1.64 0 01-.048-1.256c.155-.407.442-.718.836-.898a.28.28 0 00.167-.18.3.3 0 00-.012-.25L28.764 9.39a.31.31 0 00-.43-.155L23.048 11.7h-.012L5.383 19.907a.33.33 0 00-.155.431l1.91 4.127c.071.168.262.228.43.156a1.624 1.624 0 012.147.802c.18.394.203.837.06 1.244-.143.406-.441.73-.835.92a.33.33 0 00-.155.432l1.91 4.14c.035.07.095.143.178.167.036.011.072.023.108.023a.24.24 0 00.13-.035l1.875-.874h22.892a.32.32 0 00.322-.323V26.56a.32.32 0 00-.322-.323c-.895 0-1.611-.73-1.611-1.627s.727-1.627 1.61-1.627m-24.742 8.602L9.488 28.02a2.24 2.24 0 00.883-1.125 2.3 2.3 0 00-.072-1.735 2.25 2.25 0 00-2.697-1.22l-1.647-3.565 17.067-7.956.43.921c.06.12.167.192.287.192a.24.24 0 00.13-.036c.156-.072.228-.263.156-.431l-.43-.921 4.727-2.202 1.659 3.566a2.23 2.23 0 00-.883 1.1 2.25 2.25 0 00.071 1.759 2.284 2.284 0 002.697 1.22l1.66 3.566-4.727 2.2-.43-.92a.32.32 0 00-.43-.156c-.154.072-.226.263-.154.43l.43.922zm22.486-6.975a2.27 2.27 0 001.934 2.25v3.935H14.37l14.394-6.7h.012l.012-.011 5.3-2.465c.071-.036.143-.096.166-.18a.37.37 0 00-.011-.25l-1.29-2.764h2.602v3.936a2.27 2.27 0 00-1.933 2.249"/><path fill="currentColor" d="M24.695 14.5a.31.31 0 00-.43-.155.33.33 0 00-.155.43l.56 1.22c.06.12.168.192.287.192a.24.24 0 00.131-.036.33.33 0 00.156-.43zm1.23 2.656a.31.31 0 00-.43-.156.33.33 0 00-.155.43l.56 1.221c.06.12.168.192.287.192a.24.24 0 00.131-.036.33.33 0 00.155-.431zm1.215 2.643a.32.32 0 00-.429-.156.33.33 0 00-.155.43l.56 1.221c.06.12.168.191.287.191a.24.24 0 00.132-.035.33.33 0 00.155-.431zm-7.196 2.058 1.456-2.62a.31.31 0 00-.048-.37.31.31 0 00-.37-.072l-2.71 1.256-2.04-2.201a.31.31 0 00-.37-.072.306.306 0 00-.18.335l.359 2.979-2.71 1.268a.306.306 0 00-.178.335.304.304 0 00.262.275l2.936.574.358 2.98c.012.143.12.25.263.274h.06c.119 0 .226-.06.286-.167l1.456-2.62 2.936.574a.33.33 0 00.346-.155.31.31 0 00-.047-.371zM18.63 23.33a.33.33 0 00-.346.155l-1.086 1.962-.263-2.225a.305.305 0 00-.262-.275l-2.197-.43 2.03-.946a.306.306 0 00.178-.335l-.262-2.225 1.528 1.64c.095.107.25.13.37.07l2.029-.944-1.087 1.962a.31.31 0 00.048.37l1.516 1.64z"/><path fill="currentColor" fill-rule="evenodd" d="M31.891 16.904c.167-.071.358-.012.43.156l.334.718h3.223a.32.32 0 01.322.323v4.558a.32.32 0 01-.322.323c-.883 0-1.611.73-1.611 1.627s.716 1.627 1.61 1.627c.18 0 .323.144.323.323v4.558a.32.32 0 01-.322.323H12.986l-1.874.874a.24.24 0 01-.131.035.4.4 0 01-.108-.023c-.083-.024-.143-.096-.179-.168l-1.91-4.14a.33.33 0 01.156-.43 1.624 1.624 0 00.775-2.166 1.624 1.624 0 00-2.148-.801c-.167.072-.358.012-.43-.156l-1.91-4.127a.33.33 0 01.156-.43L23.035 11.7h.012l5.288-2.464a.31.31 0 01.43.155l1.92 4.128a.3.3 0 01.013.25.28.28 0 01-.167.18c-.394.18-.68.49-.836.898-.155.406-.131.861.048 1.256a1.627 1.627 0 002.148.801m-1.966-.885a1.43 1.43 0 001.883.703l.005-.002c.25-.108.567-.025.69.258l.28.6h3.095a.52.52 0 01.522.523v4.558c0 .29-.233.523-.522.523-.772 0-1.411.64-1.411 1.427 0 .788.628 1.427 1.41 1.427.29 0 .523.233.523.523v4.558c0 .29-.233.524-.522.524H13.03l-1.822.85a.45.45 0 01-.227.059.5.5 0 01-.165-.032l-.003-.001a.5.5 0 01-.298-.27l-.003-.005-1.911-4.144a.53.53 0 01.253-.691c.348-.17.608-.453.733-.807a1.46 1.46 0 00-.054-1.094 1.424 1.424 0 00-1.883-.703l-.004.002c-.251.108-.568.025-.691-.258l-1.911-4.13a.53.53 0 01.255-.692m24.625-3.706a1.44 1.44 0 01-.042-1.1c.137-.36.386-.63.73-.786a.48.48 0 00.274-.296.5.5 0 00-.016-.397l-1.923-4.131a.51.51 0 00-.699-.254L23.003 11.5h-.012L5.3 19.725m5.073 7.17a2.23 2.23 0 01-.883 1.124l1.647 3.565 17.08-7.956-.43-.921a.33.33 0 01.155-.43.32.32 0 01.43.155l.43.92 4.726-2.2-1.66-3.566a2.284 2.284 0 01-2.697-1.22 2.25 2.25 0 01-.072-1.759c.168-.454.478-.837.884-1.1l-1.66-3.566-4.726 2.202.43.921a.33.33 0 01-.155.43.24.24 0 01-.131.037.32.32 0 01-.287-.192l-.43-.921-17.067 7.956 1.647 3.565a2.25 2.25 0 012.697 1.22 2.3 2.3 0 01.072 1.735m-2.658-3.193a2.45 2.45 0 012.768 1.374 2.5 2.5 0 01.079 1.885c-.162.45-.447.842-.82 1.125l1.492 3.231L27.95 23.53l-.347-.745a.53.53 0 01.252-.69.52.52 0 01.698.25l.345.74 4.364-2.032-1.505-3.232a2.49 2.49 0 01-2.766-1.37l-.001-.001a2.45 2.45 0 01-.078-1.914c.162-.44.447-.819.818-1.098l-1.503-3.231-4.364 2.032.348.745a.53.53 0 01-.242.685.44.44 0 01-.229.061.52.52 0 01-.465-.302l-.002-.005-.345-.74L6.22 20.471zm21.062.393h-.012l-14.394 6.7h21.186v-3.937a2.27 2.27 0 01-1.934-2.249 2.27 2.27 0 011.934-2.25v-3.935h-2.602l1.289 2.763a.37.37 0 01.011.252c-.023.083-.095.143-.167.18l-5.299 2.464zm.129.154c-.022.01-.229.122-.229.122l-13.4 6.223h20.08v-3.568a2.47 2.47 0 01-1.934-2.417c0-1.188.834-2.177 1.934-2.417v-3.568h-2.088l1.159 2.484m.02.386a.5.5 0 01-.27.303l-.005.003-5.267 2.45m-4.795-9.475a.33.33 0 01.155-.43.31.31 0 01.43.155l.549 1.22a.33.33 0 01-.156.431.24.24 0 01-.13.036.32.32 0 01-.287-.191zm1.075 1.552a.44.44 0 01-.228.06.52.52 0 01-.465-.302l-.003-.005-.563-1.226a.53.53 0 01.252-.69.51.51 0 01.7.255l.55 1.223a.53.53 0 01-.243.685m.716 2.324-.561-1.22a.33.33 0 01.155-.43.31.31 0 01.43.155l.549 1.22a.33.33 0 01-.156.43.24.24 0 01-.13.037.32.32 0 01-.287-.192m.514.331a.53.53 0 00.242-.685l-.55-1.222a.51.51 0 00-.699-.256.53.53 0 00-.252.69l.563 1.226.003.006c.088.177.26.302.465.302a.44.44 0 00.228-.06m.907.733.001.001.55 1.224a.53.53 0 01-.242.685.44.44 0 01-.228.06.52.52 0 01-.465-.301l-.003-.006-.563-1.225a.53.53 0 01.252-.69.52.52 0 01.698.252m-.611-.072a.32.32 0 01.43.155l.549 1.22a.33.33 0 01-.155.431.24.24 0 01-.132.036.32.32 0 01-.286-.191l-.561-1.22a.33.33 0 01.155-.431m-5.729-.848a.31.31 0 01.37.071c.096.096.12.252.048.371l-1.456 2.62 2.065 2.202a.306.306 0 01.047.37.33.33 0 01-.346.156l-2.936-.574-1.456 2.62a.32.32 0 01-.286.168h-.06a.305.305 0 01-.263-.276l-.358-2.979-2.936-.574a.305.305 0 01-.262-.275.306.306 0 01.179-.335l2.709-1.268-.358-2.98a.306.306 0 01.179-.334.31.31 0 01.37.072l2.04 2.2zm-2.661 1.013-1.941-2.093a.51.51 0 00-.6-.12m2.54 2.213 2.58-1.196a.51.51 0 01.598.117.51.51 0 01.075.608l-1.383 2.49 1.962 2.092a.51.51 0 01.076.614.53.53 0 01-.55.25l-.006-.001-2.794-.547-1.385 2.493a.52.52 0 01-.461.27h-.077l-.016-.002a.505.505 0 01-.429-.452l-.34-2.83-2.79-.547a.505.505 0 01-.426-.447.506.506 0 01.294-.542l2.577-1.206-.34-2.831a.506.506 0 01.294-.546m2.89 5.537 1.598.305-1.1-1.19a.51.51 0 01-.077-.61l.787-1.42-1.47.685a.51.51 0 01-.604-.118l-1.11-1.19.19 1.614a.506.506 0 01-.293.544l-1.47.685 1.59.312a.505.505 0 01.425.452l.19 1.605.788-1.425a.53.53 0 01.55-.25zm-1.47 2.314-.263-2.225a.305.305 0 00-.262-.275l-2.197-.43 2.03-.946a.306.306 0 00.178-.335l-.262-2.225 1.528 1.64c.095.107.25.13.37.07l2.029-.944-1.087 1.962a.31.31 0 00.048.37l1.516 1.64-2.196-.419a.33.33 0 00-.346.155z" clip-rule="evenodd"/><path fill="currentColor" d="M34.204 21.818c.352-.198.293-.558.22-.714l-2.388.714-3.486 2.607c1.738-.786 5.303-2.41 5.654-2.607"/></g>'
  },
  "opportunity-management-deal": {
    body: '<g fill="currentColor"><path d="M14.14 35.264h-3.533a1.735 1.735 0 01-1.767-1.766V8.767C8.84 7.765 9.606 7 10.607 7h14.132c1 0 1.766.765 1.766 1.767V12.3c0 .353-.235.588-.589.588-.353 0-.588-.235-.588-.588V8.767c0-.354-.236-.59-.59-.59h-14.13c-.354 0-.59.236-.59.59v24.73c0 .354.236.59.59.59h3.533c.353 0 .588.235.588.588 0 .354-.235.59-.588.59"/><path d="M22.972 36.442a11.183 11.183 0 01-11.188-11.188 11.183 11.183 0 0111.188-11.188A11.183 11.183 0 0134.16 25.254a11.183 11.183 0 01-11.188 11.188m0-21.198a10 10 0 00-10.01 10.01c0 5.535 4.475 10.01 10.01 10.01s10.01-4.475 10.01-10.01-4.475-10.01-10.01-10.01m-2.709-4.711h-5.24c-.825 0-1.531-.53-1.708-1.354L12.785 7h9.775l-.53 2.179c-.236.824-.942 1.354-1.767 1.354m-5.947-2.355.177.706c.059.236.294.471.589.471h5.24c.295 0 .53-.176.59-.47l.117-.707z"/><path d="M19.145 33.203a2.916 2.916 0 01-2.945-2.944 2.916 2.916 0 012.945-2.945 2.916 2.916 0 012.944 2.945 2.916 2.916 0 01-2.944 2.944m0-4.71a1.735 1.735 0 00-1.767 1.766c0 1 .766 1.766 1.767 1.766a1.735 1.735 0 001.766-1.766 1.735 1.735 0 00-1.766-1.767m7.655 1.767a2.916 2.916 0 01-2.945-2.944A2.916 2.916 0 0126.8 24.37a2.916 2.916 0 012.945 2.944 2.916 2.916 0 01-2.945 2.944m0-4.71a1.735 1.735 0 00-1.767 1.766c0 1 .765 1.766 1.766 1.766a1.735 1.735 0 001.767-1.766 1.735 1.735 0 00-1.767-1.767"/><path d="M22.089 30.259H20.91v-9.245l8.833-2.767v9.068h-1.178v-7.42l-6.477 1.944z"/></g>'
  },
  "opportunity-permanent-social-media-share": {
    body: '<g fill="currentColor"><path d="M13.089 14.625a.62.62 0 00.62-.621v-1.76c0-.932.76-1.69 1.69-1.69h4.935a.62.62 0 00.622-.622.62.62 0 00-.622-.621h-4.968a2.915 2.915 0 00-2.897 2.897v1.76c.033.38.274.657.62.657m15.045 6.52a.62.62 0 00-.621.621v9.524H13.71v-2.38a.62.62 0 00-.62-.622.62.62 0 00-.622.621v5.14a2.915 2.915 0 002.897 2.898H25.82a2.915 2.915 0 002.898-2.897l.001-12.284c0-.345-.241-.621-.586-.621M25.856 35.74H15.368c-.931 0-1.69-.76-1.69-1.69v-1.553h13.835v1.553c0 .93-.76 1.69-1.657 1.69"/><path d="M21.924 33.496H19.3a.62.62 0 00-.621.621c0 .346.276.622.621.622h2.623a.62.62 0 00.621-.622.62.62 0 00-.621-.62M34.377 5.895h-9.522a2.62 2.62 0 00-2.623 2.623v7.314a2.63 2.63 0 002.553 2.623v2.38c0 .241.138.448.38.552a.6.6 0 00.241.035c.138 0 .31-.068.414-.172l3.037-2.83h5.52A2.62 2.62 0 0037 15.799v-7.28a2.62 2.62 0 00-2.623-2.623m1.415 9.937a1.4 1.4 0 01-1.415 1.415l-5.761-.001a.64.64 0 00-.414.172l-2.208 2.035v-1.587a.62.62 0 00-.621-.622h-.553a1.4 1.4 0 01-1.415-1.415l.002-7.311a1.4 1.4 0 011.415-1.415h9.523a1.4 1.4 0 011.415 1.415l-.002 7.314zM15.816 28.527a.7.7 0 00.241-.07.61.61 0 00.346-.552v-2.139a2.63 2.63 0 002.552-2.622v-4.59a2.62 2.62 0 00-2.623-2.622l-9.487.001a2.62 2.62 0 00-2.622 2.623v4.588a2.62 2.62 0 002.622 2.622h5.556l3.037 2.623c.102.103.24.138.378.138m-.587-3.348v1.449L13.02 24.73a.52.52 0 00-.38-.137l-5.796-.002c-.793-.033-1.415-.654-1.415-1.448v-4.59a1.4 1.4 0 011.415-1.415h9.524a1.4 1.4 0 011.415 1.415l-.001 4.59a1.4 1.4 0 01-1.416 1.415h-.552c-.31 0-.586.275-.586.62"/><path d="M32.825 8.862c-.931-.655-2.347-.553-3.243.276a2.47 2.47 0 00-1.966-.725c-.725.068-1.415.449-1.83 1.035-.654.931-.517 2.45.346 3.313l3.037 3.036a.64.64 0 00.413.173.64.64 0 00.414-.173l3.14-3.14a2.47 2.47 0 00.725-1.966c-.035-.726-.415-1.382-1.036-1.83m-.518 2.966-2.725 2.692-2.623-2.623c-.448-.45-.552-1.277-.207-1.725a1.4 1.4 0 01.966-.553h.104c.345 0 .655.137.931.38l.45.449a.64.64 0 00.413.172.57.57 0 00.414-.172l.38-.38c.449-.449 1.276-.553 1.725-.208.31.242.517.553.553.967 0 .346-.138.725-.38 1.001m-24.703 8.25h8.004a.62.62 0 00.621-.622.62.62 0 00-.621-.621H7.605a.62.62 0 00-.622.621c.035.345.277.622.622.622m8.591 2.173a.62.62 0 00-.622-.621l-7.97.001a.62.62 0 00-.62.622c0 .345.276.62.62.62h8.005c.31-.034.586-.31.586-.622"/></g>'
  },
  "opportunity-publishing-deal": {
    body: '<g fill="currentColor"><path d="M21.22 33.364a6.203 6.203 0 006.199-6.199 6.203 6.203 0 00-6.199-6.199 6.203 6.203 0 00-6.199 6.2 6.2 6.2 0 006.199 6.198m0-11.27a5.08 5.08 0 015.072 5.071 5.08 5.08 0 01-5.072 5.072 5.08 5.08 0 01-5.072-5.072 5.08 5.08 0 015.072-5.071"/><path d="M9.386 19.84v15.604L8 37.163c-.276.338-.327.8-.14 1.195.185.394.58.642 1.013.642H33.58a1.12 1.12 0 001.014-.637c.192-.394.14-.85-.13-1.189l-1.408-1.78V19.84c0-.93-.761-1.69-1.691-1.69H11.077c-.93 0-1.69.76-1.69 1.69m24.198 18.033H8.874l1.363-1.69h22l1.342 1.69zM31.928 19.84v15.215H10.513V19.84c0-.31.254-.564.564-.564h20.287c.31 0 .564.254.564.564"/><path d="M19.23 29.9a.56.56 0 00.553.022l4.508-2.254a.563.563 0 000-1.003l-4.508-2.255a.57.57 0 00-.547.023.56.56 0 00-.265.479v4.508c0 .197.102.378.265.48zm.863-4.075 2.682 1.341-2.682 1.341zm1.69-11.057V6.315l.677.901.901-.676-1.69-2.254c-.215-.282-.688-.282-.902 0l-1.69 2.254.901.676.676-.901v8.453zm4.582.327 3.601-7.016.192 1.11 1.11-.191-.474-2.779a.56.56 0 00-.298-.405.54.54 0 00-.502 0l-2.536 1.234.496 1.014 1.015-.496-3.601 7.016 1.003.513zm9.991-4.255-2.79.39.159 1.115 1.115-.158-3.595 3.579.795.8 3.595-3.579-.163 1.116 1.115.164.406-2.79a.56.56 0 00-.158-.479.58.58 0 00-.479-.163zM14.982 7.042l-2.536-1.234a.555.555 0 00-.8.406l-.474 2.778 1.11.191.192-1.11 3.6 7.016 1.004-.513-3.601-7.016 1.014.496.496-1.014zm-9.378 3.956a.56.56 0 00-.157.479l.405 2.79 1.116-.164-.163-1.116 3.595 3.579.795-.8-3.596-3.579 1.116.158.158-1.116-2.79-.389a.55.55 0 00-.479.164zm24.069 21.803H30.8v1.127h-1.127zm-2.254 0h1.127v1.127h-1.127zm-15.779 0h3.381v1.127H11.64z"/></g>'
  },
  "opportunity-radio-broadcast": {
    body: '<path fill="currentColor" fill-rule="evenodd" d="M8.518 31.872A1.73 1.73 0 017 30.152V19.089a14.43 14.43 0 014.237-10.214 14.48 14.48 0 0110.23-4.231h.066c3.837 0 7.517 1.521 10.23 4.231A14.43 14.43 0 0136 19.09v11.065c0 .882-.66 1.611-1.518 1.72v2.03a.58.58 0 01-.578.576h-2.033v2.03c0 .318-.26.577-.578.577h-4.066a1.734 1.734 0 01-1.735-1.734v-8.117c0-.958.776-1.734 1.735-1.734h4.066c.319 0 .578.259.578.577v2.03h2.033c.32 0 .578.258.578.58v2a.58.58 0 00.362-.535V19.089c0-3.524-1.403-6.904-3.9-9.398a13.33 13.33 0 00-9.411-3.893h-.066c-3.53 0-6.914 1.402-9.411 3.893a13.28 13.28 0 00-3.9 9.398v11.063c0 .243.15.45.362.537v-2c0-.322.259-.58.578-.58h2.033v-2.03c0-.318.26-.577.578-.577h4.066c.959 0 1.735.776 1.735 1.734v8.117c0 .958-.776 1.734-1.735 1.734h-4.066a.58.58 0 01-.578-.577v-2.03H9.096a.58.58 0 01-.578-.577zm23.353 1.452h1.454v-4.059H31.87zm-1.158 2.609v-9.274h-3.486c-.32 0-.58.258-.58.577v8.117c0 .321.26.58.58.58zM11.13 29.265H9.675v4.059h1.454zm1.158 4.638v2.03h3.486a.58.58 0 00.58-.58v-8.117a.58.58 0 00-.58-.577h-3.486zm8.635-11.7a5.784 5.784 0 01-5.209-5.75.578.578 0 011.158 0 4.63 4.63 0 004.629 4.624 4.63 4.63 0 004.63-4.623.578.578 0 011.157 0 5.784 5.784 0 01-5.209 5.75v1.377a7.3 7.3 0 012.412.604.577.577 0 11-.465 1.059c-1.584-.692-3.273-.699-5.07.009a.579.579 0 01-.425-1.077 8.7 8.7 0 012.392-.584zm4.527-10.646v4.899a3.944 3.944 0 01-3.948 3.942H21.5a3.944 3.944 0 01-3.948-3.942v-4.899a3.944 3.944 0 013.948-3.94h.002a3.944 3.944 0 013.948 3.94m-1.158 0a2.787 2.787 0 00-2.79-2.786H21.5a2.787 2.787 0 00-2.79 2.786v4.899a2.787 2.787 0 002.79 2.786h.002a2.787 2.787 0 002.79-2.786zm-3.949 5.169a.578.578 0 110-1.156h2.327a.578.578 0 110 1.156zm.02-2.753a.579.579 0 010-1.156h2.328a.578.578 0 010 1.156zm-.02-2.754a.578.578 0 110-1.154h2.327c.32 0 .58.258.58.577s-.26.577-.58.577z" clip-rule="evenodd"/>'
  },
  "opportunity-record-deal": {
    body: '<path fill="currentColor" fill-rule="evenodd" d="m15.09 23.218 9.334-2.075v6.583a3.501 3.501 0 00-5.833 2.608c0 1.931 1.567 3.5 3.5 3.5 1.931 0 3.5-1.569 3.5-3.5v-14a.584.584 0 00-.71-.57l-10.5 2.333a.584.584 0 00-.457.57v10.225A3.501 3.501 0 008.09 31.5a3.5 3.5 0 007 0zM13.924 31.5a2.334 2.334 0 10-4.669.002 2.334 2.334 0 004.669-.002m10.5-1.167a2.334 2.334 0 10-4.669.002 2.334 2.334 0 004.669-.002m0-10.384V17.06l-9.334 2.075v2.888zm.583-11.782a7.59 7.59 0 017.583 7.583.584.584 0 001.167 0c0-4.829-3.921-8.75-8.75-8.75a.584.584 0 000 1.167m0 2.916a4.67 4.67 0 014.667 4.667.583.583 0 001.166 0 5.835 5.835 0 00-5.833-5.833.584.584 0 000 1.166m0 2.917c.966 0 1.75.784 1.75 1.75a.583.583 0 001.167 0 2.92 2.92 0 00-2.917-2.917.584.584 0 000 1.167" clip-rule="evenodd"/>'
  },
  "opportunity-share-to-my-team": {
    body: '<path fill="currentColor" d="M35.218 21.003c-.642 0-1.263.227-1.76.64a2.85 2.85 0 00-.968 1.626h-4.743c.28-.993.31-2.042.089-3.05a6.2 6.2 0 00-1.354-2.723l3.369-5.388a4.1 4.1 0 003.06.175 4.2 4.2 0 002.353-2 4.32 4.32 0 00.377-3.097 4.25 4.25 0 00-1.803-2.523 4.1 4.1 0 00-3.01-.59 4.17 4.17 0 00-2.595 1.663 4.306 4.306 0 00.677 5.764l-3.247 5.197a6.02 6.02 0 00-4.071-1.352 6.04 6.04 0 00-3.94 1.71l-3.34-3.4a3.4 3.4 0 00.844-2.286 3.4 3.4 0 00-.899-2.265 3.266 3.266 0 00-4.46-.331 3.38 3.38 0 00-1.211 2.107c-.13.833.05 1.685.508 2.387a3.3 3.3 0 001.96 1.409 3.26 3.26 0 002.38-.313l3.484 3.547a6.3 6.3 0 00-1.18 3.636 6.3 6.3 0 001.136 3.65l-6.012 3.569a4.15 4.15 0 00-2.935-.958 4.17 4.17 0 00-2.788 1.34A4.32 4.32 0 004 32.063a4.32 4.32 0 001.124 2.922 4.17 4.17 0 002.78 1.355 4.15 4.15 0 002.941-.943 4.3 4.3 0 001.517-2.732 4.34 4.34 0 00-.724-3.05l5.978-3.55a6.1 6.1 0 002.016 1.309v4.964a1.7 1.7 0 00-1.123.049c-.36.142-.661.403-.86.74a1.79 1.79 0 00.258 2.15l1.725 1.816v.34c0 .15.059.295.163.401a.55.55 0 00.394.166h8.906c.147 0 .289-.06.393-.166a.57.57 0 00.163-.4v-9.632c0-.328-.093-.65-.269-.924a1.7 1.7 0 00-.72-.627 1.64 1.64 0 00-1.794.285 1.65 1.65 0 00-.838-.408 6.2 6.2 0 001.279-1.726h5.181a2.85 2.85 0 00.72 1.396c.364.387.83.66 1.34.788a2.74 2.74 0 001.548-.063c.5-.17.941-.48 1.275-.895a2.88 2.88 0 00.359-3.006 2.8 2.8 0 00-1.027-1.18 2.75 2.75 0 00-1.487-.439m-6.68-12.748c0-.616.18-1.219.516-1.731a3.07 3.07 0 011.374-1.148 3 3 0 011.769-.177c.594.12 1.14.417 1.567.853s.72.99.838 1.595a3.17 3.17 0 01-.174 1.8 3.1 3.1 0 01-1.128 1.4 3 3 0 01-1.7.524c-.812 0-1.59-.33-2.164-.913a3.15 3.15 0 01-.898-2.203M11.84 13.638a2.2 2.2 0 01-1.237-.382 2.26 2.26 0 01-.82-1.017 2.3 2.3 0 01-.127-1.31 2.3 2.3 0 01.61-1.16 2.2 2.2 0 011.14-.62 2.2 2.2 0 011.286.129c.407.171.754.462 1 .834a2.296 2.296 0 01-.278 2.862 2.2 2.2 0 01-1.574.664m-3.618 21.53a3 3 0 01-1.7-.526 3.1 3.1 0 01-1.128-1.399 3.17 3.17 0 01-.175-1.8c.118-.604.41-1.16.838-1.595a3.05 3.05 0 011.568-.853 3 3 0 011.768.177c.56.236 1.038.635 1.374 1.148a3.156 3.156 0 01-.381 3.934 3.04 3.04 0 01-2.164.913m18.09-7.366v1.7c0 .15.058.294.163.4a.55.55 0 00.787 0 .57.57 0 00.163-.4v-1.7a.57.57 0 01.163-.4.55.55 0 01.787 0c.105.105.163.25.163.4v9.065h-7.792a.57.57 0 00-.157-.393l-1.887-1.99a.64.64 0 01-.006-.882.62.62 0 01.865-.04l.184.248a.56.56 0 00.621.194.56.56 0 00.275-.206.57.57 0 00.105-.33v-9.066a.56.56 0 01.062-.248l.588-.299c.128.02.245.087.33.188.084.1.132.227.133.36v5.099c0 .15.058.294.163.4a.55.55 0 00.787 0 .57.57 0 00.163-.4v-1.7a.57.57 0 01.163-.4.55.55 0 01.787 0c.105.105.163.25.163.4v1.7c0 .15.059.294.163.4a.55.55 0 00.787 0 .57.57 0 00.163-.4v-1.7c0-.15.06-.295.163-.4a.55.55 0 01.788 0 .57.57 0 01.163.4m-5.566-4.995V20.22l2.651 1.35-2.262 1.15a1.6 1.6 0 00-.39.087m3.228 3.379a1.66 1.66 0 00-1.002.013v-1.797a1.7 1.7 0 00-.431-1.13l2.35-1.192a.56.56 0 00.308-.508.57.57 0 00-.308-.507L20.438 18.8a.55.55 0 00-.734.23.6.6 0 00-.072.274v4.533q.002.105.042.2-.04.18-.042.366v1.737a5.07 5.07 0 01-2.322-2.41 5.2 5.2 0 01-.34-3.357 5.12 5.12 0 011.793-2.84 4.96 4.96 0 013.142-1.081 4.96 4.96 0 013.118 1.149 5.12 5.12 0 011.733 2.878 5.2 5.2 0 01-.41 3.35 5.06 5.06 0 01-2.372 2.358m11.244-.65c-.33 0-.654-.1-.928-.287a1.7 1.7 0 01-.615-.763 1.73 1.73 0 01.362-1.852 1.64 1.64 0 011.82-.368c.305.128.565.346.749.625a1.72 1.72 0 01-.208 2.147 1.66 1.66 0 01-1.18.497"/>'
  },
  "opportunity-spotify-playlist": {
    body: '<g fill="currentColor"><path d="M7.236 22.068a.6.6 0 01-.596-.545 5 5 0 01-.016-.42c0-6.516 5.3-11.816 11.816-11.816a.6.6 0 110 1.2c-5.852 0-10.616 4.76-10.616 10.617q-.002.154.008.308a.6.6 0 01-.54.652h-.056zM18.44 23.79a2.683 2.683 0 01-2.68-2.68 2.685 2.685 0 012.68-2.68 2.685 2.685 0 012.68 2.68 2.685 2.685 0 01-2.68 2.68m0-4.16c-.816 0-1.48.664-1.48 1.48s.664 1.48 1.48 1.48 1.48-.664 1.48-1.48-.664-1.48-1.48-1.48"/><path d="M18.446 27.374a6.276 6.276 0 01-6.268-6.268 6.276 6.276 0 016.268-6.268 6.276 6.276 0 016.268 6.268 6.276 6.276 0 01-6.268 6.268m0-11.332a5.075 5.075 0 00-5.068 5.068 5.07 5.07 0 005.068 5.068 5.07 5.07 0 005.068-5.068 5.07 5.07 0 00-5.068-5.068m7.31 18.12a.6.6 0 01-.268-1.136 13.85 13.85 0 006.604-9.588.6.6 0 01.692-.493.6.6 0 01.492.692 15.05 15.05 0 01-6.928 10.273c-.088.06-.204.132-.316.188a.6.6 0 01-.268.064z"/><path d="M18.447 36.157c-8.296 0-15.049-6.748-15.049-15.048S10.151 6.061 18.447 6.061c7.388 0 13.78 5.504 14.872 12.8a.603.603 0 01-.504.684.603.603 0 01-.684-.504c-1.004-6.716-6.888-11.78-13.684-11.78-7.636 0-13.849 6.212-13.849 13.848s6.213 13.848 13.849 13.848c1.008 0 1.992-.104 2.928-.312a.6.6 0 11.26 1.172c-1.02.228-2.096.34-3.188.34"/><path d="M26.03 34.43a.6.6 0 01-.6-.6V20.434c0-.28.196-.524.472-.584l11.976-2.64c.18-.04.364.004.504.12s.224.284.224.468v12.924a.6.6 0 11-1.2 0V18.546L26.63 20.922v12.912a.6.6 0 01-.6.6z"/><path d="M23.73 37.54c-1.6 0-2.9-1.3-2.9-2.9s1.3-2.9 2.9-2.9 2.9 1.3 2.9 2.9-1.3 2.9-2.9 2.9m0-4.6c-.936 0-1.7.764-1.7 1.7s.764 1.7 1.7 1.7 1.7-.764 1.7-1.7-.764-1.7-1.7-1.7m11.979 1.49c-1.6 0-2.9-1.301-2.9-2.901s1.3-2.9 2.9-2.9 2.9 1.3 2.9 2.9-1.3 2.9-2.9 2.9m0-4.601c-.936 0-1.7.764-1.7 1.7s.764 1.7 1.7 1.7 1.7-.764 1.7-1.7-.764-1.7-1.7-1.7m-9.679-4.331a.6.6 0 01-.12-1.188l11.977-2.436a.6.6 0 01.24 1.176L26.15 25.485a.6.6 0 01-.12.012"/></g>'
  },
  "opportunity-springboard-selection": {
    body: '<g fill="currentColor"><path d="M16.468 32.811a2.461 2.461 0 01-1.74-4.197 2.459 2.459 0 111.74 4.197m0-3.851a1.39 1.39 0 00-.985 2.376 1.39 1.39 0 002.377-.985 1.394 1.394 0 00-1.392-1.391"/><path d="M18.393 30.885a.533.533 0 01-.533-.533v-8.298a.533.533 0 111.066 0v8.298a.533.533 0 01-.533.533m5.717-.45a2.458 2.458 0 110-4.916 2.458 2.458 0 010 4.916m0-3.85a1.392 1.392 0 100 2.783 1.392 1.392 0 000-2.783"/><path d="M26.035 28.51a.534.534 0 01-.534-.534v-8.298a.534.534 0 011.067 0v8.299a.533.533 0 01-.533.533"/><path d="M18.393 22.588a.534.534 0 01-.158-1.043l7.642-2.375a.534.534 0 11.316 1.018l-7.642 2.376a.5.5 0 01-.158.024m0 2.994a.532.532 0 01-.158-1.043l7.642-2.375a.533.533 0 11.316 1.018l-7.642 2.377a.6.6 0 01-.158.023m-6.104-12.049h-1.067a1.96 1.96 0 01-1.955-1.955V6.956A1.96 1.96 0 0111.222 5h1.067a1.96 1.96 0 011.955 1.956v4.622a1.96 1.96 0 01-1.955 1.955m-1.067-7.466a.89.89 0 00-.889.889v4.622a.89.89 0 00.89.889h1.066a.89.89 0 00.889-.89v-4.62a.89.89 0 00-.89-.89zm10.312 7.466h-1.067a1.96 1.96 0 01-1.956-1.955V6.956A1.96 1.96 0 0120.467 5h1.067a1.96 1.96 0 011.955 1.956v4.622a1.96 1.96 0 01-1.956 1.955m-1.067-7.466a.89.89 0 00-.89.889v4.622a.89.89 0 00.89.889h1.066a.89.89 0 00.89-.89v-4.62a.89.89 0 00-.89-.89zm10.312 7.466H29.71a1.96 1.96 0 01-1.956-1.955V6.956A1.96 1.96 0 0129.711 5h1.067a1.96 1.96 0 011.955 1.956v4.622a1.96 1.96 0 01-1.955 1.955M29.71 6.067a.89.89 0 00-.889.889v4.622a.89.89 0 00.889.889h1.067a.89.89 0 00.889-.89v-4.62a.89.89 0 00-.89-.89z"/><path d="M19.044 10.334h-5.333a.534.534 0 010-1.067h5.333a.533.533 0 010 1.067"/><path d="M35.044 37H6.956A1.96 1.96 0 015 35.045V11.223a1.96 1.96 0 011.956-1.956H9.8a.533.533 0 010 1.067H6.956a.89.89 0 00-.89.889v23.822a.89.89 0 00.89.889h28.088a.89.89 0 00.89-.89v-23.82a.89.89 0 00-.89-.89H32.2a.534.534 0 010-1.066h2.844A1.96 1.96 0 0137 11.223v23.822A1.96 1.96 0 0135.044 37"/><path d="M28.289 10.334h-5.334a.534.534 0 010-1.067h5.334a.533.533 0 010 1.067m8.178 6.222H5.533a.533.533 0 010-1.067h30.934a.533.533 0 010 1.067"/></g>'
  },
  "opportunity-sync-deal": {
    body: '<g fill="currentColor"><path d="M32.49 10.656H22.138l3.642-3.641a.594.594 0 10-.84-.84l-4.09 4.085-4.087-4.087a.594.594 0 10-.84.84l3.641 3.642H9.51c-2.95 0-5.349 2.4-5.349 5.349V32.15c0 2.95 2.4 5.35 5.35 5.35h22.98c2.95 0 5.35-2.4 5.35-5.35V16.005c0-2.95-2.4-5.35-5.35-5.35m4.161 21.495a4.165 4.165 0 01-4.16 4.16H9.509a4.165 4.165 0 01-4.16-4.16V16.005a4.165 4.165 0 014.16-4.16h22.982a4.165 4.165 0 014.16 4.16z"/><path d="M28.231 14.222H9.212c-.983 0-1.783.813-1.783 1.813v15.987c0 1 .8 1.813 1.783 1.813h19.019c.983 0 1.783-.813 1.783-1.813V16.035c0-1-.8-1.813-1.783-1.813m.594 17.8c0 .344-.266.624-.594.624H9.212c-.328 0-.594-.28-.594-.624V16.035c0-.344.266-.624.594-.624h19.019c.328 0 .594.28.594.624zm4.427-4.823c-1.148 0-2.08.933-2.08 2.08s.933 2.08 2.08 2.08 2.08-.933 2.08-2.08-.933-2.08-2.08-2.08m0 2.971a.892.892 0 11.001-1.784.892.892 0 01-.001 1.785m1.486-7.034h-2.972a.594.594 0 100 1.189h2.971a.594.594 0 100-1.189m.001-2.774h-2.972a.594.594 0 100 1.189h2.971a.594.594 0 100-1.189m.001-2.773h-2.972a.594.594 0 100 1.189h2.971a.594.594 0 100-1.19"/><path d="M17.788 26.982a.604.604 0 01-.602-.602v-4.32a.601.601 0 01.952-.49l3.026 2.16a.603.603 0 010 .978l-3.026 2.162a.6.6 0 01-.35.113m.602-3.755v1.983l1.389-.99z"/></g>'
  },
  "opportunity-temporary-social-media-share": {
    body: '<g fill="none"><rect/><path fill="currentColor" d="m24.369 20.283-4.474-3.217a.37.37 0 00-.378-.03.36.36 0 00-.2.319v6.433a.357.357 0 00.364.358q.116 0 .214-.069l4.474-3.216a.356.356 0 000-.578m-4.325 2.801V18.06l3.495 2.513z"/><path fill="currentColor" d="M27.853 7.19H14.147c-1.077 0-1.954.864-1.954 1.925v24.77c0 1.061.877 1.925 1.954 1.925h13.706c1.077 0 1.954-.864 1.954-1.925V9.115c0-1.061-.877-1.925-1.954-1.925m-14.934 4.324h16.162v17.914H12.919zm1.228-3.608h13.706a1.22 1.22 0 011.228 1.21v1.682H12.919V9.115c0-.667.551-1.21 1.228-1.21m13.706 27.188H14.147a1.22 1.22 0 01-1.228-1.21v-3.74h16.162v3.74a1.22 1.22 0 01-1.228 1.21"/><path fill="currentColor" d="M21 30.926c-.994 0-1.803.79-1.803 1.761s.809 1.761 1.803 1.761 1.803-.79 1.803-1.76c0-.972-.809-1.762-1.803-1.762m0 2.807c-.594 0-1.077-.47-1.077-1.046s.483-1.045 1.077-1.045 1.077.469 1.077 1.045c0 .577-.483 1.046-1.077 1.046m0-19.209c-3.397 0-6.16 2.723-6.16 6.07s2.763 6.07 6.16 6.07 6.162-2.723 6.162-6.07-2.764-6.07-6.162-6.07m0 11.425c-2.997 0-5.435-2.402-5.435-5.355 0-2.952 2.438-5.354 5.435-5.354s5.436 2.402 5.436 5.354S23.997 25.95 21 25.95"/><path fill="currentColor" fill-rule="evenodd" d="M19.517 17.036a.37.37 0 01.378.03l4.474 3.217a.356.356 0 010 .578l-4.474 3.216a.37.37 0 01-.378.03.36.36 0 01-.2-.319v-6.433a.36.36 0 01.2-.32m-.088 7.24a.55.55 0 01-.304-.488v-6.433c0-.206.117-.395.304-.489a.56.56 0 01.58.046l4.473 3.217m-4.473 4.102 4.473-3.217Zm-.58.046a.56.56 0 00.58-.046m.035-1.147 3.495-2.512-3.495-2.513zm.193-.374 2.974-2.138-2.974-2.139zM14.147 7h13.706C29.037 7 30 7.949 30 9.115v24.77C30 35.05 29.037 36 27.853 36H14.147C12.963 36 12 35.051 12 33.885V9.115C12 7.95 12.963 7 14.147 7m14.74 4.704H13.113v17.534h15.776zm-1.034-3.608H14.147c-.57 0-1.035.457-1.035 1.02v1.492h15.776V9.115a1.03 1.03 0 00-1.035-1.02M14.147 34.904h13.706c.57 0 1.035-.457 1.035-1.02v-3.55H13.112v3.55c0 .563.465 1.02 1.035 1.02m4.857-2.217c0-1.077.897-1.95 1.996-1.95 1.1 0 1.996.873 1.996 1.95 0 1.078-.897 1.951-1.996 1.951s-1.996-.873-1.996-1.95m1.112 0c0 .47.394.856.884.856s.884-.387.884-.856-.394-.855-.884-.855-.884.386-.884.855m-5.47-12.093c0-3.452 2.85-6.26 6.354-6.26s6.355 2.808 6.355 6.26-2.85 6.26-6.355 6.26c-3.504 0-6.354-2.808-6.354-6.26m1.112 0c0 2.848 2.352 5.165 5.242 5.165s5.243-2.317 5.243-5.165S23.89 15.43 21 15.43s-5.242 2.317-5.242 5.164M14.147 7.19h13.706c1.077 0 1.954.864 1.954 1.925v24.77c0 1.061-.877 1.925-1.954 1.925H14.147c-1.077 0-1.954-.864-1.954-1.925V9.115c0-1.061.877-1.925 1.954-1.925m-1.228 4.324v17.914h16.162V11.514zm14.934-3.608H14.147a1.22 1.22 0 00-1.228 1.21v1.682h16.162V9.115a1.22 1.22 0 00-1.228-1.21M14.147 35.094h13.706a1.22 1.22 0 001.228-1.21v-3.74H12.919v3.74c0 .668.551 1.21 1.228 1.21M21 30.926c-.994 0-1.803.79-1.803 1.761s.809 1.761 1.803 1.761 1.803-.79 1.803-1.76c0-.972-.809-1.762-1.803-1.762m0 2.807c-.594 0-1.077-.47-1.077-1.046s.483-1.045 1.077-1.045 1.077.469 1.077 1.045c0 .577-.483 1.046-1.077 1.046m-6.16-13.139c0-3.347 2.763-6.07 6.16-6.07s6.162 2.723 6.162 6.07-2.764 6.07-6.162 6.07c-3.397 0-6.16-2.723-6.16-6.07m.725 0c0 2.953 2.438 5.355 5.435 5.355s5.436-2.402 5.436-5.355c0-2.952-2.439-5.354-5.436-5.354s-5.435 2.402-5.435 5.354" clip-rule="evenodd"/><path fill="currentColor" d="M24.709 20.772c.18-.412-.299-.706-.478-.824-.18-.118-4.603 4.004-4.603 4.004l-.21.324.569-.03c1.415-1.03 4.423-2.973 4.722-3.474"/></g>'
  },
  "smile-meter-0": {
    body: '<path fill="currentColor" d="M12.813 15.89c-.391.352-.977.352-1.329-.038A1.97 1.97 0 0010 15.187c-.742 0-1.25.352-1.523.665-.352.39-.938.39-1.329.039-.39-.352-.39-.938-.039-1.328A3.94 3.94 0 0110 13.313c1.328 0 2.305.664 2.852 1.25.351.39.351.976-.04 1.328M5.625 9.876c0-.312.117-.625.352-.86l-1.211-.39c-.313-.117-.47-.469-.391-.82a.654.654 0 01.82-.39l3.75 1.25c.313.116.47.468.39.82-.116.312-.468.468-.82.39l-.39-.156v.156c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25m8.75 0c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25V9.72l-.43.156c-.351.078-.703-.078-.82-.39-.078-.352.078-.704.39-.82l3.75-1.25a.654.654 0 01.82.39c.08.351-.077.703-.39.82l-1.21.39c.234.196.39.547.39.86M0 10.5C0 4.992 4.453.5 10 .5c5.508 0 10 4.492 10 10 0 5.547-4.492 10-10 10a9.97 9.97 0 01-10-10m10 8.125c4.453 0 8.125-3.633 8.125-8.125 0-4.453-3.672-8.125-8.125-8.125-4.492 0-8.125 3.672-8.125 8.125A8.12 8.12 0 0010 18.625"/>',
    width: 20,
    height: 21
  },
  "smile-meter-1": {
    body: '<path fill="currentColor" d="M5.586 16.086c-.469-.156-.742-.703-.547-1.211C5.703 13 7.734 11.75 10 11.75c2.227 0 4.258 1.25 4.922 3.125.195.508-.078 1.055-.547 1.21-.508.196-1.055-.077-1.21-.546-.352-1.016-1.563-1.914-3.165-1.914-1.64 0-2.852.898-3.203 1.914-.156.469-.703.742-1.211.547m2.539-7.461c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25c0-.664.547-1.25 1.25-1.25s1.25.586 1.25 1.25m3.75 0c0-.664.547-1.25 1.25-1.25s1.25.586 1.25 1.25c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25M20 10.5c0 5.547-4.492 10-10 10a9.97 9.97 0 01-10-10C0 4.992 4.453.5 10 .5c5.508 0 10 4.492 10 10M10 2.375c-4.492 0-8.125 3.672-8.125 8.125A8.12 8.12 0 0010 18.625c4.453 0 8.125-3.633 8.125-8.125 0-4.453-3.672-8.125-8.125-8.125"/>',
    width: 20,
    height: 21
  },
  "smile-meter-2": {
    body: '<path fill="currentColor" d="M5.625 8.625c0-.664.547-1.25 1.25-1.25s1.25.586 1.25 1.25c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25m8.75 0c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25c0-.664.547-1.25 1.25-1.25s1.25.586 1.25 1.25m-1.562 4.688a.95.95 0 01.937.937c0 .547-.43.938-.937.938H7.187c-.546 0-.937-.391-.937-.938 0-.508.39-.937.938-.937zM20 10.5c0 5.547-4.492 10-10 10a9.97 9.97 0 01-10-10C0 4.992 4.453.5 10 .5c5.508 0 10 4.492 10 10m-10 8.125c4.453 0 8.125-3.633 8.125-8.125 0-4.453-3.672-8.125-8.125-8.125-4.492 0-8.125 3.672-8.125 8.125A8.12 8.12 0 0010 18.625"/>',
    width: 20,
    height: 21
  },
  "smile-meter-3": {
    body: '<path fill="currentColor" d="M10 14.25c1.445 0 2.46-.664 3.047-1.29a.933.933 0 011.328-.077c.39.351.39.937.04 1.328A5.93 5.93 0 0110 16.125c-2.11 0-3.594-.977-4.453-1.914-.352-.39-.352-.977.039-1.328a.933.933 0 011.328.078C7.5 13.586 8.516 14.25 10 14.25M8.125 8.625c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25c0-.664.547-1.25 1.25-1.25s1.25.586 1.25 1.25m3.75 0c0-.664.547-1.25 1.25-1.25s1.25.586 1.25 1.25c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25M20 10.5c0 5.547-4.492 10-10 10a9.97 9.97 0 01-10-10C0 4.992 4.453.5 10 .5c5.508 0 10 4.492 10 10M10 2.375c-4.492 0-8.125 3.672-8.125 8.125A8.12 8.12 0 0010 18.625c4.453 0 8.125-3.633 8.125-8.125 0-4.453-3.672-8.125-8.125-8.125"/>',
    width: 20,
    height: 21
  },
  "smile-meter-4": {
    body: '<path fill="currentColor" d="M13.633 12.57c.742-.195 1.406.47.976 1.094-.937 1.484-2.656 2.461-4.648 2.461-1.953 0-3.672-.977-4.648-2.46-.391-.626.273-1.29 1.015-1.095 1.133.274 2.344.39 3.633.39 1.328 0 2.539-.116 3.672-.39M8.477 9.445s0-.039-.04-.039q0-.058-.117-.117c-.078-.117-.234-.273-.39-.43-.352-.273-.742-.546-1.055-.546-.352 0-.742.273-1.094.546-.156.157-.312.313-.39.43q-.118.06-.118.117c-.039 0-.039.04-.039.04a.315.315 0 01-.351.117c-.117-.04-.195-.157-.195-.313 0-.664.234-1.367.625-1.875.39-.508.937-.937 1.562-.937.586 0 1.133.43 1.523.937.391.508.665 1.21.665 1.875a.34.34 0 01-.235.313.315.315 0 01-.351-.118m6.25 0s0-.039-.04-.039q0-.058-.117-.117c-.078-.117-.234-.273-.39-.43-.352-.273-.742-.546-1.055-.546-.352 0-.742.273-1.094.546-.156.157-.312.313-.39.43q-.118.06-.118.117c-.039 0-.039.04-.039.04a.315.315 0 01-.351.117c-.117-.04-.195-.157-.195-.313 0-.664.234-1.367.624-1.875.391-.508.938-.937 1.563-.937.586 0 1.133.43 1.523.937.391.508.665 1.21.665 1.875a.34.34 0 01-.235.313.315.315 0 01-.351-.118M20 10.5c0 5.547-4.492 10-10 10a9.97 9.97 0 01-10-10C0 4.992 4.453.5 10 .5c5.508 0 10 4.492 10 10M10 2.375c-4.492 0-8.125 3.672-8.125 8.125A8.12 8.12 0 0010 18.625c4.453 0 8.125-3.633 8.125-8.125 0-4.453-3.672-8.125-8.125-8.125"/>',
    width: 20,
    height: 21
  }
}, Pr = 42, Hr = 42, Vr = {
  prefix: $r,
  lastModified: _r,
  icons: Rr,
  width: Pr,
  height: Hr
};
/**
* (c) Iconify
*
* For the full copyright and license information, please view the license.txt
* files at https://github.com/iconify/iconify
*
* Licensed under MIT.
*
* @license MIT
* @version 2.1.0
*/
const ko = Object.freeze(
  {
    left: 0,
    top: 0,
    width: 16,
    height: 16
  }
), wt = Object.freeze({
  rotate: 0,
  vFlip: !1,
  hFlip: !1
}), rt = Object.freeze({
  ...ko,
  ...wt
}), Gt = Object.freeze({
  ...rt,
  body: "",
  hidden: !1
}), Br = Object.freeze({
  width: null,
  height: null
}), So = Object.freeze({
  // Dimensions
  ...Br,
  // Transformations
  ...wt
});
function jr(e, t = 0) {
  const n = e.replace(/^-?[0-9.]*/, "");
  function o(r) {
    for (; r < 0; )
      r += 4;
    return r % 4;
  }
  if (n === "") {
    const r = parseInt(e);
    return isNaN(r) ? 0 : o(r);
  } else if (n !== e) {
    let r = 0;
    switch (n) {
      case "%":
        r = 25;
        break;
      case "deg":
        r = 90;
    }
    if (r) {
      let a = parseFloat(e.slice(0, e.length - n.length));
      return isNaN(a) ? 0 : (a = a / r, a % 1 === 0 ? o(a) : 0);
    }
  }
  return t;
}
const Ur = /[\s,]+/;
function Wr(e, t) {
  t.split(Ur).forEach((n) => {
    switch (n.trim()) {
      case "horizontal":
        e.hFlip = !0;
        break;
      case "vertical":
        e.vFlip = !0;
        break;
    }
  });
}
const Ao = {
  ...So,
  preserveAspectRatio: ""
};
function _n(e) {
  const t = {
    ...Ao
  }, n = (o, r) => e.getAttribute(o) || r;
  return t.width = n("width", null), t.height = n("height", null), t.rotate = jr(n("rotate", "")), Wr(t, n("flip", "")), t.preserveAspectRatio = n("preserveAspectRatio", n("preserveaspectratio", "")), t;
}
function Kr(e, t) {
  for (const n in Ao)
    if (e[n] !== t[n])
      return !0;
  return !1;
}
const Ge = /^[a-z0-9]+(-[a-z0-9]+)*$/, it = (e, t, n, o = "") => {
  const r = e.split(":");
  if (e.slice(0, 1) === "@") {
    if (r.length < 2 || r.length > 3)
      return null;
    o = r.shift().slice(1);
  }
  if (r.length > 3 || !r.length)
    return null;
  if (r.length > 1) {
    const l = r.pop(), s = r.pop(), c = {
      // Allow provider without '@': "provider:prefix:name"
      provider: r.length > 0 ? r[0] : o,
      prefix: s,
      name: l
    };
    return t && !mt(c) ? null : c;
  }
  const a = r[0], i = a.split("-");
  if (i.length > 1) {
    const l = {
      provider: o,
      prefix: i.shift(),
      name: i.join("-")
    };
    return t && !mt(l) ? null : l;
  }
  if (n && o === "") {
    const l = {
      provider: o,
      prefix: "",
      name: a
    };
    return t && !mt(l, n) ? null : l;
  }
  return null;
}, mt = (e, t) => e ? !!((e.provider === "" || e.provider.match(Ge)) && (t && e.prefix === "" || e.prefix.match(Ge)) && e.name.match(Ge)) : !1;
function qr(e, t) {
  const n = {};
  !e.hFlip != !t.hFlip && (n.hFlip = !0), !e.vFlip != !t.vFlip && (n.vFlip = !0);
  const o = ((e.rotate || 0) + (t.rotate || 0)) % 4;
  return o && (n.rotate = o), n;
}
function Rn(e, t) {
  const n = qr(e, t);
  for (const o in Gt)
    o in wt ? o in e && !(o in n) && (n[o] = wt[o]) : o in t ? n[o] = t[o] : o in e && (n[o] = e[o]);
  return n;
}
function Gr(e, t) {
  const n = e.icons, o = e.aliases || /* @__PURE__ */ Object.create(null), r = /* @__PURE__ */ Object.create(null);
  function a(i) {
    if (n[i])
      return r[i] = [];
    if (!(i in r)) {
      r[i] = null;
      const l = o[i] && o[i].parent, s = l && a(l);
      s && (r[i] = [l].concat(s));
    }
    return r[i];
  }
  return Object.keys(n).concat(Object.keys(o)).forEach(a), r;
}
function Qr(e, t, n) {
  const o = e.icons, r = e.aliases || /* @__PURE__ */ Object.create(null);
  let a = {};
  function i(l) {
    a = Rn(
      o[l] || r[l],
      a
    );
  }
  return i(t), n.forEach(i), Rn(e, a);
}
function Io(e, t) {
  const n = [];
  if (typeof e != "object" || typeof e.icons != "object")
    return n;
  e.not_found instanceof Array && e.not_found.forEach((r) => {
    t(r, null), n.push(r);
  });
  const o = Gr(e);
  for (const r in o) {
    const a = o[r];
    a && (t(r, Qr(e, r, a)), n.push(r));
  }
  return n;
}
const Yr = {
  provider: "",
  aliases: {},
  not_found: {},
  ...ko
};
function _t(e, t) {
  for (const n in t)
    if (n in e && typeof e[n] != typeof t[n])
      return !1;
  return !0;
}
function Eo(e) {
  if (typeof e != "object" || e === null)
    return null;
  const t = e;
  if (typeof t.prefix != "string" || !e.icons || typeof e.icons != "object" || !_t(e, Yr))
    return null;
  const n = t.icons;
  for (const r in n) {
    const a = n[r];
    if (!r.match(Ge) || typeof a.body != "string" || !_t(
      a,
      Gt
    ))
      return null;
  }
  const o = t.aliases || /* @__PURE__ */ Object.create(null);
  for (const r in o) {
    const a = o[r], i = a.parent;
    if (!r.match(Ge) || typeof i != "string" || !n[i] && !o[i] || !_t(
      a,
      Gt
    ))
      return null;
  }
  return t;
}
const gt = /* @__PURE__ */ Object.create(null);
function Xr(e, t) {
  return {
    provider: e,
    prefix: t,
    icons: /* @__PURE__ */ Object.create(null),
    missing: /* @__PURE__ */ new Set()
  };
}
function he(e, t) {
  const n = gt[e] || (gt[e] = /* @__PURE__ */ Object.create(null));
  return n[t] || (n[t] = Xr(e, t));
}
function wn(e, t) {
  return Eo(t) ? Io(t, (n, o) => {
    o ? e.icons[n] = o : e.missing.add(n);
  }) : [];
}
function Zr(e, t, n) {
  try {
    if (typeof n.body == "string")
      return e.icons[t] = { ...n }, !0;
  } catch {
  }
  return !1;
}
function Jr(e, t) {
  let n = [];
  return (typeof e == "string" ? [e] : Object.keys(gt)).forEach((r) => {
    (typeof r == "string" && typeof t == "string" ? [t] : Object.keys(gt[r] || {})).forEach((i) => {
      const l = he(r, i);
      n = n.concat(
        Object.keys(l.icons).map(
          (s) => (r !== "" ? "@" + r + ":" : "") + i + ":" + s
        )
      );
    });
  }), n;
}
let Xe = !1;
function Mo(e) {
  return typeof e == "boolean" && (Xe = e), Xe;
}
function Ze(e) {
  const t = typeof e == "string" ? it(e, !0, Xe) : e;
  if (t) {
    const n = he(t.provider, t.prefix), o = t.name;
    return n.icons[o] || (n.missing.has(o) ? null : void 0);
  }
}
function Fo(e, t) {
  const n = it(e, !0, Xe);
  if (!n)
    return !1;
  const o = he(n.provider, n.prefix);
  return Zr(o, n.name, t);
}
function Pn(e, t) {
  if (typeof e != "object")
    return !1;
  if (typeof t != "string" && (t = e.provider || ""), Xe && !t && !e.prefix) {
    let r = !1;
    return Eo(e) && (e.prefix = "", Io(e, (a, i) => {
      i && Fo(a, i) && (r = !0);
    })), r;
  }
  const n = e.prefix;
  if (!mt({
    provider: t,
    prefix: n,
    name: "a"
  }))
    return !1;
  const o = he(t, n);
  return !!wn(o, e);
}
function Hn(e) {
  return !!Ze(e);
}
function ei(e) {
  const t = Ze(e);
  return t ? {
    ...rt,
    ...t
  } : null;
}
function ti(e) {
  const t = {
    loaded: [],
    missing: [],
    pending: []
  }, n = /* @__PURE__ */ Object.create(null);
  e.sort((r, a) => r.provider !== a.provider ? r.provider.localeCompare(a.provider) : r.prefix !== a.prefix ? r.prefix.localeCompare(a.prefix) : r.name.localeCompare(a.name));
  let o = {
    provider: "",
    prefix: "",
    name: ""
  };
  return e.forEach((r) => {
    if (o.name === r.name && o.prefix === r.prefix && o.provider === r.provider)
      return;
    o = r;
    const a = r.provider, i = r.prefix, l = r.name, s = n[a] || (n[a] = /* @__PURE__ */ Object.create(null)), c = s[i] || (s[i] = he(a, i));
    let u;
    l in c.icons ? u = t.loaded : i === "" || c.missing.has(l) ? u = t.missing : u = t.pending;
    const f = {
      provider: a,
      prefix: i,
      name: l
    };
    u.push(f);
  }), t;
}
function zo(e, t) {
  e.forEach((n) => {
    const o = n.loaderCallbacks;
    o && (n.loaderCallbacks = o.filter((r) => r.id !== t));
  });
}
function ni(e) {
  e.pendingCallbacksFlag || (e.pendingCallbacksFlag = !0, setTimeout(() => {
    e.pendingCallbacksFlag = !1;
    const t = e.loaderCallbacks ? e.loaderCallbacks.slice(0) : [];
    if (!t.length)
      return;
    let n = !1;
    const o = e.provider, r = e.prefix;
    t.forEach((a) => {
      const i = a.icons, l = i.pending.length;
      i.pending = i.pending.filter((s) => {
        if (s.prefix !== r)
          return !0;
        const c = s.name;
        if (e.icons[c])
          i.loaded.push({
            provider: o,
            prefix: r,
            name: c
          });
        else if (e.missing.has(c))
          i.missing.push({
            provider: o,
            prefix: r,
            name: c
          });
        else
          return n = !0, !0;
        return !1;
      }), i.pending.length !== l && (n || zo([e], a.id), a.callback(
        i.loaded.slice(0),
        i.missing.slice(0),
        i.pending.slice(0),
        a.abort
      ));
    });
  }));
}
let oi = 0;
function ri(e, t, n) {
  const o = oi++, r = zo.bind(null, n, o);
  if (!t.pending.length)
    return r;
  const a = {
    id: o,
    icons: t,
    callback: e,
    abort: r
  };
  return n.forEach((i) => {
    (i.loaderCallbacks || (i.loaderCallbacks = [])).push(a);
  }), r;
}
const Qt = /* @__PURE__ */ Object.create(null);
function Vn(e, t) {
  Qt[e] = t;
}
function Yt(e) {
  return Qt[e] || Qt[""];
}
function ii(e, t = !0, n = !1) {
  const o = [];
  return e.forEach((r) => {
    const a = typeof r == "string" ? it(r, t, n) : r;
    a && o.push(a);
  }), o;
}
var ai = {
  resources: [],
  index: 0,
  timeout: 2e3,
  rotate: 750,
  random: !1,
  dataAfterTimeout: !1
};
function si(e, t, n, o) {
  const r = e.resources.length, a = e.random ? Math.floor(Math.random() * r) : e.index;
  let i;
  if (e.random) {
    let A = e.resources.slice(0);
    for (i = []; A.length > 1; ) {
      const E = Math.floor(Math.random() * A.length);
      i.push(A[E]), A = A.slice(0, E).concat(A.slice(E + 1));
    }
    i = i.concat(A);
  } else
    i = e.resources.slice(a).concat(e.resources.slice(0, a));
  const l = Date.now();
  let s = "pending", c = 0, u, f = null, d = [], h = [];
  typeof o == "function" && h.push(o);
  function v() {
    f && (clearTimeout(f), f = null);
  }
  function x() {
    s === "pending" && (s = "aborted"), v(), d.forEach((A) => {
      A.status === "pending" && (A.status = "aborted");
    }), d = [];
  }
  function w(A, E) {
    E && (h = []), typeof A == "function" && h.push(A);
  }
  function p() {
    return {
      startTime: l,
      payload: t,
      status: s,
      queriesSent: c,
      queriesPending: d.length,
      subscribe: w,
      abort: x
    };
  }
  function g() {
    s = "failed", h.forEach((A) => {
      A(void 0, u);
    });
  }
  function C() {
    d.forEach((A) => {
      A.status === "pending" && (A.status = "aborted");
    }), d = [];
  }
  function S(A, E, L) {
    const K = E !== "success";
    switch (d = d.filter((j) => j !== A), s) {
      case "pending":
        break;
      case "failed":
        if (K || !e.dataAfterTimeout)
          return;
        break;
      default:
        return;
    }
    if (E === "abort") {
      u = L, g();
      return;
    }
    if (K) {
      u = L, d.length || (i.length ? D() : g());
      return;
    }
    if (v(), C(), !e.random) {
      const j = e.resources.indexOf(A.resource);
      j !== -1 && j !== e.index && (e.index = j);
    }
    s = "completed", h.forEach((j) => {
      j(L);
    });
  }
  function D() {
    if (s !== "pending")
      return;
    v();
    const A = i.shift();
    if (A === void 0) {
      if (d.length) {
        f = setTimeout(() => {
          v(), s === "pending" && (C(), g());
        }, e.timeout);
        return;
      }
      g();
      return;
    }
    const E = {
      status: "pending",
      resource: A,
      callback: (L, K) => {
        S(E, L, K);
      }
    };
    d.push(E), c++, f = setTimeout(D, e.rotate), n(A, t, E.callback);
  }
  return setTimeout(D), p;
}
function Oo(e) {
  const t = {
    ...ai,
    ...e
  };
  let n = [];
  function o() {
    n = n.filter((l) => l().status === "pending");
  }
  function r(l, s, c) {
    const u = si(
      t,
      l,
      s,
      (f, d) => {
        o(), c && c(f, d);
      }
    );
    return n.push(u), u;
  }
  function a(l) {
    return n.find((s) => l(s)) || null;
  }
  return {
    query: r,
    find: a,
    setIndex: (l) => {
      t.index = l;
    },
    getIndex: () => t.index,
    cleanup: o
  };
}
function gn(e) {
  let t;
  if (typeof e.resources == "string")
    t = [e.resources];
  else if (t = e.resources, !(t instanceof Array) || !t.length)
    return null;
  return {
    // API hosts
    resources: t,
    // Root path
    path: e.path || "/",
    // URL length limit
    maxURL: e.maxURL || 500,
    // Timeout before next host is used.
    rotate: e.rotate || 750,
    // Timeout before failing query.
    timeout: e.timeout || 5e3,
    // Randomise default API end point.
    random: e.random === !0,
    // Start index
    index: e.index || 0,
    // Receive data after time out (used if time out kicks in first, then API module sends data anyway).
    dataAfterTimeout: e.dataAfterTimeout !== !1
  };
}
const Mt = /* @__PURE__ */ Object.create(null), Ue = [
  "https://api.simplesvg.com",
  "https://api.unisvg.com"
], vt = [];
for (; Ue.length > 0; )
  Ue.length === 1 || Math.random() > 0.5 ? vt.push(Ue.shift()) : vt.push(Ue.pop());
Mt[""] = gn({
  resources: ["https://api.iconify.design"].concat(vt)
});
function Bn(e, t) {
  const n = gn(t);
  return n === null ? !1 : (Mt[e] = n, !0);
}
function Ft(e) {
  return Mt[e];
}
function li() {
  return Object.keys(Mt);
}
function jn() {
}
const Rt = /* @__PURE__ */ Object.create(null);
function ci(e) {
  if (!Rt[e]) {
    const t = Ft(e);
    if (!t)
      return;
    const n = Oo(t), o = {
      config: t,
      redundancy: n
    };
    Rt[e] = o;
  }
  return Rt[e];
}
function No(e, t, n) {
  let o, r;
  if (typeof e == "string") {
    const a = Yt(e);
    if (!a)
      return n(void 0, 424), jn;
    r = a.send;
    const i = ci(e);
    i && (o = i.redundancy);
  } else {
    const a = gn(e);
    if (a) {
      o = Oo(a);
      const i = e.resources ? e.resources[0] : "", l = Yt(i);
      l && (r = l.send);
    }
  }
  return !o || !r ? (n(void 0, 424), jn) : o.query(t, r, n)().abort;
}
const Un = "iconify2", Je = "iconify", Do = Je + "-count", Wn = Je + "-version", Lo = 36e5, ui = 168, fi = 50;
function Xt(e, t) {
  try {
    return e.getItem(t);
  } catch {
  }
}
function yn(e, t, n) {
  try {
    return e.setItem(t, n), !0;
  } catch {
  }
}
function Kn(e, t) {
  try {
    e.removeItem(t);
  } catch {
  }
}
function Zt(e, t) {
  return yn(e, Do, t.toString());
}
function Jt(e) {
  return parseInt(Xt(e, Do)) || 0;
}
const ge = {
  local: !0,
  session: !0
}, $o = {
  local: /* @__PURE__ */ new Set(),
  session: /* @__PURE__ */ new Set()
};
let xn = !1;
function di(e) {
  xn = e;
}
let lt = typeof window > "u" ? {} : window;
function _o(e) {
  const t = e + "Storage";
  try {
    if (lt && lt[t] && typeof lt[t].length == "number")
      return lt[t];
  } catch {
  }
  ge[e] = !1;
}
function Ro(e, t) {
  const n = _o(e);
  if (!n)
    return;
  const o = Xt(n, Wn);
  if (o !== Un) {
    if (o) {
      const l = Jt(n);
      for (let s = 0; s < l; s++)
        Kn(n, Je + s.toString());
    }
    yn(n, Wn, Un), Zt(n, 0);
    return;
  }
  const r = Math.floor(Date.now() / Lo) - ui, a = (l) => {
    const s = Je + l.toString(), c = Xt(n, s);
    if (typeof c == "string") {
      try {
        const u = JSON.parse(c);
        if (typeof u == "object" && typeof u.cached == "number" && u.cached > r && typeof u.provider == "string" && typeof u.data == "object" && typeof u.data.prefix == "string" && // Valid item: run callback
        t(u, l))
          return !0;
      } catch {
      }
      Kn(n, s);
    }
  };
  let i = Jt(n);
  for (let l = i - 1; l >= 0; l--)
    a(l) || (l === i - 1 ? (i--, Zt(n, i)) : $o[e].add(l));
}
function Po() {
  if (!xn) {
    di(!0);
    for (const e in ge)
      Ro(e, (t) => {
        const n = t.data, o = t.provider, r = n.prefix, a = he(
          o,
          r
        );
        if (!wn(a, n).length)
          return !1;
        const i = n.lastModified || -1;
        return a.lastModifiedCached = a.lastModifiedCached ? Math.min(a.lastModifiedCached, i) : i, !0;
      });
  }
}
function hi(e, t) {
  const n = e.lastModifiedCached;
  if (
    // Matches or newer
    n && n >= t
  )
    return n === t;
  if (e.lastModifiedCached = t, n)
    for (const o in ge)
      Ro(o, (r) => {
        const a = r.data;
        return r.provider !== e.provider || a.prefix !== e.prefix || a.lastModified === t;
      });
  return !0;
}
function pi(e, t) {
  xn || Po();
  function n(o) {
    let r;
    if (!ge[o] || !(r = _o(o)))
      return;
    const a = $o[o];
    let i;
    if (a.size)
      a.delete(i = Array.from(a).shift());
    else if (i = Jt(r), i >= fi || !Zt(r, i + 1))
      return;
    const l = {
      cached: Math.floor(Date.now() / Lo),
      provider: e.provider,
      data: t
    };
    return yn(
      r,
      Je + i.toString(),
      JSON.stringify(l)
    );
  }
  t.lastModified && !hi(e, t.lastModified) || Object.keys(t.icons).length && (t.not_found && (t = Object.assign({}, t), delete t.not_found), n("local") || n("session"));
}
function qn() {
}
function mi(e) {
  e.iconsLoaderFlag || (e.iconsLoaderFlag = !0, setTimeout(() => {
    e.iconsLoaderFlag = !1, ni(e);
  }));
}
function vi(e, t) {
  e.iconsToLoad ? e.iconsToLoad = e.iconsToLoad.concat(t).sort() : e.iconsToLoad = t, e.iconsQueueFlag || (e.iconsQueueFlag = !0, setTimeout(() => {
    e.iconsQueueFlag = !1;
    const { provider: n, prefix: o } = e, r = e.iconsToLoad;
    delete e.iconsToLoad;
    let a;
    if (!r || !(a = Yt(n)))
      return;
    a.prepare(n, o, r).forEach((l) => {
      No(n, l, (s) => {
        if (typeof s != "object")
          l.icons.forEach((c) => {
            e.missing.add(c);
          });
        else
          try {
            const c = wn(
              e,
              s
            );
            if (!c.length)
              return;
            const u = e.pendingIcons;
            u && c.forEach((f) => {
              u.delete(f);
            }), pi(e, s);
          } catch (c) {
            console.error(c);
          }
        mi(e);
      });
    });
  }));
}
const Cn = (e, t) => {
  const n = ii(e, !0, Mo()), o = ti(n);
  if (!o.pending.length) {
    let s = !0;
    return t && setTimeout(() => {
      s && t(
        o.loaded,
        o.missing,
        o.pending,
        qn
      );
    }), () => {
      s = !1;
    };
  }
  const r = /* @__PURE__ */ Object.create(null), a = [];
  let i, l;
  return o.pending.forEach((s) => {
    const { provider: c, prefix: u } = s;
    if (u === l && c === i)
      return;
    i = c, l = u, a.push(he(c, u));
    const f = r[c] || (r[c] = /* @__PURE__ */ Object.create(null));
    f[u] || (f[u] = []);
  }), o.pending.forEach((s) => {
    const { provider: c, prefix: u, name: f } = s, d = he(c, u), h = d.pendingIcons || (d.pendingIcons = /* @__PURE__ */ new Set());
    h.has(f) || (h.add(f), r[c][u].push(f));
  }), a.forEach((s) => {
    const { provider: c, prefix: u } = s;
    r[c][u].length && vi(s, r[c][u]);
  }), t ? ri(t, o, a) : qn;
}, bi = (e) => new Promise((t, n) => {
  const o = typeof e == "string" ? it(e, !0) : e;
  if (!o) {
    n(e);
    return;
  }
  Cn([o || e], (r) => {
    if (r.length && o) {
      const a = Ze(o);
      if (a) {
        t({
          ...rt,
          ...a
        });
        return;
      }
    }
    n(e);
  });
});
function wi(e) {
  try {
    const t = typeof e == "string" ? JSON.parse(e) : e;
    if (typeof t.body == "string")
      return {
        ...t
      };
  } catch {
  }
}
function gi(e, t) {
  const n = typeof e == "string" ? it(e, !0, !0) : null;
  if (!n) {
    const a = wi(e);
    return {
      value: e,
      data: a
    };
  }
  const o = Ze(n);
  if (o !== void 0 || !n.prefix)
    return {
      value: e,
      name: n,
      data: o
      // could be 'null' -> icon is missing
    };
  const r = Cn([n], () => t(e, n, Ze(n)));
  return {
    value: e,
    name: n,
    loading: r
  };
}
let Ho = !1;
try {
  Ho = navigator.vendor.indexOf("Apple") === 0;
} catch {
}
function yi(e, t) {
  switch (t) {
    case "svg":
    case "bg":
    case "mask":
      return t;
  }
  return t !== "style" && (Ho || e.indexOf("<a") === -1) ? "svg" : e.indexOf("currentColor") === -1 ? "bg" : "mask";
}
const xi = /(-?[0-9.]*[0-9]+[0-9.]*)/g, Ci = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
function en(e, t, n) {
  if (t === 1)
    return e;
  if (n = n || 100, typeof e == "number")
    return Math.ceil(e * t * n) / n;
  if (typeof e != "string")
    return e;
  const o = e.split(xi);
  if (o === null || !o.length)
    return e;
  const r = [];
  let a = o.shift(), i = Ci.test(a);
  for (; ; ) {
    if (i) {
      const l = parseFloat(a);
      isNaN(l) ? r.push(a) : r.push(Math.ceil(l * t * n) / n);
    } else
      r.push(a);
    if (a = o.shift(), a === void 0)
      return r.join("");
    i = !i;
  }
}
function Ti(e, t = "defs") {
  let n = "";
  const o = e.indexOf("<" + t);
  for (; o >= 0; ) {
    const r = e.indexOf(">", o), a = e.indexOf("</" + t);
    if (r === -1 || a === -1)
      break;
    const i = e.indexOf(">", a);
    if (i === -1)
      break;
    n += e.slice(r + 1, a).trim(), e = e.slice(0, o).trim() + e.slice(i + 1);
  }
  return {
    defs: n,
    content: e
  };
}
function ki(e, t) {
  return e ? "<defs>" + e + "</defs>" + t : t;
}
function Si(e, t, n) {
  const o = Ti(e);
  return ki(o.defs, t + o.content + n);
}
const Ai = (e) => e === "unset" || e === "undefined" || e === "none";
function Vo(e, t) {
  const n = {
    ...rt,
    ...e
  }, o = {
    ...So,
    ...t
  }, r = {
    left: n.left,
    top: n.top,
    width: n.width,
    height: n.height
  };
  let a = n.body;
  [n, o].forEach((x) => {
    const w = [], p = x.hFlip, g = x.vFlip;
    let C = x.rotate;
    p ? g ? C += 2 : (w.push(
      "translate(" + (r.width + r.left).toString() + " " + (0 - r.top).toString() + ")"
    ), w.push("scale(-1 1)"), r.top = r.left = 0) : g && (w.push(
      "translate(" + (0 - r.left).toString() + " " + (r.height + r.top).toString() + ")"
    ), w.push("scale(1 -1)"), r.top = r.left = 0);
    let S;
    switch (C < 0 && (C -= Math.floor(C / 4) * 4), C = C % 4, C) {
      case 1:
        S = r.height / 2 + r.top, w.unshift(
          "rotate(90 " + S.toString() + " " + S.toString() + ")"
        );
        break;
      case 2:
        w.unshift(
          "rotate(180 " + (r.width / 2 + r.left).toString() + " " + (r.height / 2 + r.top).toString() + ")"
        );
        break;
      case 3:
        S = r.width / 2 + r.left, w.unshift(
          "rotate(-90 " + S.toString() + " " + S.toString() + ")"
        );
        break;
    }
    C % 2 === 1 && (r.left !== r.top && (S = r.left, r.left = r.top, r.top = S), r.width !== r.height && (S = r.width, r.width = r.height, r.height = S)), w.length && (a = Si(
      a,
      '<g transform="' + w.join(" ") + '">',
      "</g>"
    ));
  });
  const i = o.width, l = o.height, s = r.width, c = r.height;
  let u, f;
  i === null ? (f = l === null ? "1em" : l === "auto" ? c : l, u = en(f, s / c)) : (u = i === "auto" ? s : i, f = l === null ? en(u, c / s) : l === "auto" ? c : l);
  const d = {}, h = (x, w) => {
    Ai(w) || (d[x] = w.toString());
  };
  h("width", u), h("height", f);
  const v = [r.left, r.top, s, c];
  return d.viewBox = v.join(" "), {
    attributes: d,
    viewBox: v,
    body: a
  };
}
function Tn(e, t) {
  let n = e.indexOf("xlink:") === -1 ? "" : ' xmlns:xlink="http://www.w3.org/1999/xlink"';
  for (const o in t)
    n += " " + o + '="' + t[o] + '"';
  return '<svg xmlns="http://www.w3.org/2000/svg"' + n + ">" + e + "</svg>";
}
function Ii(e) {
  return e.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ");
}
function Ei(e) {
  return "data:image/svg+xml," + Ii(e);
}
function Bo(e) {
  return 'url("' + Ei(e) + '")';
}
const Mi = () => {
  let e;
  try {
    if (e = fetch, typeof e == "function")
      return e;
  } catch {
  }
};
let yt = Mi();
function Fi(e) {
  yt = e;
}
function zi() {
  return yt;
}
function Oi(e, t) {
  const n = Ft(e);
  if (!n)
    return 0;
  let o;
  if (!n.maxURL)
    o = 0;
  else {
    let r = 0;
    n.resources.forEach((i) => {
      r = Math.max(r, i.length);
    });
    const a = t + ".json?icons=";
    o = n.maxURL - r - n.path.length - a.length;
  }
  return o;
}
function Ni(e) {
  return e === 404;
}
const Di = (e, t, n) => {
  const o = [], r = Oi(e, t), a = "icons";
  let i = {
    type: a,
    provider: e,
    prefix: t,
    icons: []
  }, l = 0;
  return n.forEach((s, c) => {
    l += s.length + 1, l >= r && c > 0 && (o.push(i), i = {
      type: a,
      provider: e,
      prefix: t,
      icons: []
    }, l = s.length), i.icons.push(s);
  }), o.push(i), o;
};
function Li(e) {
  if (typeof e == "string") {
    const t = Ft(e);
    if (t)
      return t.path;
  }
  return "/";
}
const $i = (e, t, n) => {
  if (!yt) {
    n("abort", 424);
    return;
  }
  let o = Li(t.provider);
  switch (t.type) {
    case "icons": {
      const a = t.prefix, l = t.icons.join(","), s = new URLSearchParams({
        icons: l
      });
      o += a + ".json?" + s.toString();
      break;
    }
    case "custom": {
      const a = t.uri;
      o += a.slice(0, 1) === "/" ? a.slice(1) : a;
      break;
    }
    default:
      n("abort", 400);
      return;
  }
  let r = 503;
  yt(e + o).then((a) => {
    const i = a.status;
    if (i !== 200) {
      setTimeout(() => {
        n(Ni(i) ? "abort" : "next", i);
      });
      return;
    }
    return r = 501, a.json();
  }).then((a) => {
    if (typeof a != "object" || a === null) {
      setTimeout(() => {
        a === 404 ? n("abort", a) : n("next", r);
      });
      return;
    }
    setTimeout(() => {
      n("success", a);
    });
  }).catch(() => {
    n("next", r);
  });
}, _i = {
  prepare: Di,
  send: $i
};
function Gn(e, t) {
  switch (e) {
    case "local":
    case "session":
      ge[e] = t;
      break;
    case "all":
      for (const n in ge)
        ge[n] = t;
      break;
  }
}
const Pt = "data-style";
let jo = "";
function Uo(e) {
  jo = e;
}
function Qn(e, t) {
  let n = Array.from(e.childNodes).find((o) => o.hasAttribute && o.hasAttribute(Pt));
  n || (n = document.createElement("style"), n.setAttribute(Pt, Pt), e.appendChild(n)), n.textContent = ":host{display:inline-block;vertical-align:" + (t ? "-0.125em" : "0") + "}span,svg{display:block}" + jo;
}
function Wo() {
  Vn("", _i), Mo(!0);
  let e;
  try {
    e = window;
  } catch {
  }
  if (e) {
    if (Po(), e.IconifyPreload !== void 0) {
      const n = e.IconifyPreload, o = "Invalid IconifyPreload syntax.";
      typeof n == "object" && n !== null && (n instanceof Array ? n : [n]).forEach((r) => {
        try {
          // Check if item is an object and not null/array
          (typeof r != "object" || r === null || r instanceof Array || // Check for 'icons' and 'prefix'
          typeof r.icons != "object" || typeof r.prefix != "string" || // Add icon set
          !Pn(r)) && console.error(o);
        } catch {
          console.error(o);
        }
      });
    }
    if (e.IconifyProviders !== void 0) {
      const n = e.IconifyProviders;
      if (typeof n == "object" && n !== null)
        for (const o in n) {
          const r = "IconifyProviders[" + o + "] is invalid.";
          try {
            const a = n[o];
            if (typeof a != "object" || !a || a.resources === void 0)
              continue;
            Bn(o, a) || console.error(r);
          } catch {
            console.error(r);
          }
        }
    }
  }
  return {
    enableCache: (n) => Gn(n, !0),
    disableCache: (n) => Gn(n, !1),
    iconLoaded: Hn,
    iconExists: Hn,
    // deprecated, kept to avoid breaking changes
    getIcon: ei,
    listIcons: Jr,
    addIcon: Fo,
    addCollection: Pn,
    calculateSize: en,
    buildIcon: Vo,
    iconToHTML: Tn,
    svgToURL: Bo,
    loadIcons: Cn,
    loadIcon: bi,
    addAPIProvider: Bn,
    appendCustomStyle: Uo,
    _api: {
      getAPIConfig: Ft,
      setAPIModule: Vn,
      sendAPIQuery: No,
      setFetch: Fi,
      getFetch: zi,
      listAPIProviders: li
    }
  };
}
const tn = {
  "background-color": "currentColor"
}, Ko = {
  "background-color": "transparent"
}, Yn = {
  image: "var(--svg)",
  repeat: "no-repeat",
  size: "100% 100%"
}, Xn = {
  "-webkit-mask": tn,
  mask: tn,
  background: Ko
};
for (const e in Xn) {
  const t = Xn[e];
  for (const n in Yn)
    t[e + "-" + n] = Yn[n];
}
function Zn(e) {
  return e ? e + (e.match(/^[-0-9.]+$/) ? "px" : "") : "inherit";
}
function Ri(e, t, n) {
  const o = document.createElement("span");
  let r = e.body;
  r.indexOf("<a") !== -1 && (r += "<!-- " + Date.now() + " -->");
  const a = e.attributes, i = Tn(r, {
    ...a,
    width: t.width + "",
    height: t.height + ""
  }), l = Bo(i), s = o.style, c = {
    "--svg": l,
    width: Zn(a.width),
    height: Zn(a.height),
    ...n ? tn : Ko
  };
  for (const u in c)
    s.setProperty(u, c[u]);
  return o;
}
let Qe;
function Pi() {
  try {
    Qe = window.trustedTypes.createPolicy("iconify", {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      createHTML: (e) => e
    });
  } catch {
    Qe = null;
  }
}
function Hi(e) {
  return Qe === void 0 && Pi(), Qe ? Qe.createHTML(e) : e;
}
function Vi(e) {
  const t = document.createElement("span"), n = e.attributes;
  let o = "";
  n.width || (o = "width: inherit;"), n.height || (o += "height: inherit;"), o && (n.style = o);
  const r = Tn(e.body, n);
  return t.innerHTML = Hi(r), t.firstChild;
}
function nn(e) {
  return Array.from(e.childNodes).find((t) => {
    const n = t.tagName && t.tagName.toUpperCase();
    return n === "SPAN" || n === "SVG";
  });
}
function Jn(e, t) {
  const n = t.icon.data, o = t.customisations, r = Vo(n, o);
  o.preserveAspectRatio && (r.attributes.preserveAspectRatio = o.preserveAspectRatio);
  const a = t.renderedMode;
  let i;
  switch (a) {
    case "svg":
      i = Vi(r);
      break;
    default:
      i = Ri(r, {
        ...rt,
        ...n
      }, a === "mask");
  }
  const l = nn(e);
  l ? i.tagName === "SPAN" && l.tagName === i.tagName ? l.setAttribute("style", i.getAttribute("style")) : e.replaceChild(i, l) : e.appendChild(i);
}
function eo(e, t, n) {
  const o = n && (n.rendered ? n : n.lastRender);
  return {
    rendered: !1,
    inline: t,
    icon: e,
    lastRender: o
  };
}
function Bi(e = "iconify-icon") {
  let t, n;
  try {
    t = window.customElements, n = window.HTMLElement;
  } catch {
    return;
  }
  if (!t || !n)
    return;
  const o = t.get(e);
  if (o)
    return o;
  const r = [
    // Icon
    "icon",
    // Mode
    "mode",
    "inline",
    "noobserver",
    // Customisations
    "width",
    "height",
    "rotate",
    "flip"
  ], a = class extends n {
    /**
     * Constructor
     */
    constructor() {
      super();
      // Root
      de(this, "_shadowRoot");
      // Initialised
      de(this, "_initialised", !1);
      // Icon state
      de(this, "_state");
      // Attributes check queued
      de(this, "_checkQueued", !1);
      // Connected
      de(this, "_connected", !1);
      // Observer
      de(this, "_observer", null);
      de(this, "_visible", !0);
      const s = this._shadowRoot = this.attachShadow({
        mode: "open"
      }), c = this.hasAttribute("inline");
      Qn(s, c), this._state = eo({
        value: ""
      }, c), this._queueCheck();
    }
    /**
     * Connected to DOM
     */
    connectedCallback() {
      this._connected = !0, this.startObserver();
    }
    /**
     * Disconnected from DOM
     */
    disconnectedCallback() {
      this._connected = !1, this.stopObserver();
    }
    /**
     * Observed attributes
     */
    static get observedAttributes() {
      return r.slice(0);
    }
    /**
     * Observed properties that are different from attributes
     *
     * Experimental! Need to test with various frameworks that support it
     */
    /*
    static get properties() {
        return {
            inline: {
                type: Boolean,
                reflect: true,
            },
            // Not listing other attributes because they are strings or combination
            // of string and another type. Cannot have multiple types
        };
    }
    */
    /**
     * Attribute has changed
     */
    attributeChangedCallback(s) {
      switch (s) {
        case "inline": {
          const c = this.hasAttribute("inline"), u = this._state;
          c !== u.inline && (u.inline = c, Qn(this._shadowRoot, c));
          break;
        }
        case "noobserver": {
          this.hasAttribute("noobserver") ? this.startObserver() : this.stopObserver();
          break;
        }
        default:
          this._queueCheck();
      }
    }
    /**
     * Get/set icon
     */
    get icon() {
      const s = this.getAttribute("icon");
      if (s && s.slice(0, 1) === "{")
        try {
          return JSON.parse(s);
        } catch {
        }
      return s;
    }
    set icon(s) {
      typeof s == "object" && (s = JSON.stringify(s)), this.setAttribute("icon", s);
    }
    /**
     * Get/set inline
     */
    get inline() {
      return this.hasAttribute("inline");
    }
    set inline(s) {
      s ? this.setAttribute("inline", "true") : this.removeAttribute("inline");
    }
    /**
     * Get/set observer
     */
    get observer() {
      return this.hasAttribute("observer");
    }
    set observer(s) {
      s ? this.setAttribute("observer", "true") : this.removeAttribute("observer");
    }
    /**
     * Restart animation
     */
    restartAnimation() {
      const s = this._state;
      if (s.rendered) {
        const c = this._shadowRoot;
        if (s.renderedMode === "svg")
          try {
            c.lastChild.setCurrentTime(0);
            return;
          } catch {
          }
        Jn(c, s);
      }
    }
    /**
     * Get status
     */
    get status() {
      const s = this._state;
      return s.rendered ? "rendered" : s.icon.data === null ? "failed" : "loading";
    }
    /**
     * Queue attributes re-check
     */
    _queueCheck() {
      this._checkQueued || (this._checkQueued = !0, setTimeout(() => {
        this._check();
      }));
    }
    /**
     * Check for changes
     */
    _check() {
      if (!this._checkQueued)
        return;
      this._checkQueued = !1;
      const s = this._state, c = this.getAttribute("icon");
      if (c !== s.icon.value) {
        this._iconChanged(c);
        return;
      }
      if (!s.rendered || !this._visible)
        return;
      const u = this.getAttribute("mode"), f = _n(this);
      (s.attrMode !== u || Kr(s.customisations, f) || !nn(this._shadowRoot)) && this._renderIcon(s.icon, f, u);
    }
    /**
     * Icon value has changed
     */
    _iconChanged(s) {
      const c = gi(s, (u, f, d) => {
        const h = this._state;
        if (h.rendered || this.getAttribute("icon") !== u)
          return;
        const v = {
          value: u,
          name: f,
          data: d
        };
        v.data ? this._gotIconData(v) : h.icon = v;
      });
      c.data ? this._gotIconData(c) : this._state = eo(c, this._state.inline, this._state);
    }
    /**
     * Force render icon on state change
     */
    _forceRender() {
      if (!this._visible) {
        const s = nn(this._shadowRoot);
        s && this._shadowRoot.removeChild(s);
        return;
      }
      this._queueCheck();
    }
    /**
     * Got new icon data, icon is ready to (re)render
     */
    _gotIconData(s) {
      this._checkQueued = !1, this._renderIcon(s, _n(this), this.getAttribute("mode"));
    }
    /**
     * Re-render based on icon data
     */
    _renderIcon(s, c, u) {
      const f = yi(s.data.body, u), d = this._state.inline;
      Jn(this._shadowRoot, this._state = {
        rendered: !0,
        icon: s,
        inline: d,
        customisations: c,
        attrMode: u,
        renderedMode: f
      });
    }
    /**
     * Start observer
     */
    startObserver() {
      if (!this._observer && !this.hasAttribute("noobserver"))
        try {
          this._observer = new IntersectionObserver((s) => {
            const c = s.some((u) => u.isIntersecting);
            c !== this._visible && (this._visible = c, this._forceRender());
          }), this._observer.observe(this);
        } catch {
          if (this._observer) {
            try {
              this._observer.disconnect();
            } catch {
            }
            this._observer = null;
          }
        }
    }
    /**
     * Stop observer
     */
    stopObserver() {
      this._observer && (this._observer.disconnect(), this._observer = null, this._visible = !0, this._connected && this._forceRender());
    }
  };
  r.forEach((l) => {
    l in a.prototype || Object.defineProperty(a.prototype, l, {
      get: function() {
        return this.getAttribute(l);
      },
      set: function(s) {
        s !== null ? this.setAttribute(l, s) : this.removeAttribute(l);
      }
    });
  });
  const i = Wo();
  for (const l in i)
    a[l] = a.prototype[l] = i[l];
  return t.define(e, a), a;
}
const qo = Bi() || Wo(), {
  enableCache: ji,
  disableCache: Ui,
  iconLoaded: Wi,
  iconExists: Ki,
  // deprecated, kept to avoid breaking changes
  getIcon: qi,
  listIcons: Gi,
  addIcon: Qi,
  addCollection: Go,
  calculateSize: Yi,
  buildIcon: Xi,
  iconToHTML: Zi,
  svgToURL: Ji,
  loadIcons: ea,
  loadIcon: ta,
  addAPIProvider: na,
  _api: oa
} = qo, c0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  IconifyIconComponent: qo,
  _api: oa,
  addAPIProvider: na,
  addCollection: Go,
  addIcon: Qi,
  appendCustomStyle: Uo,
  buildIcon: Xi,
  calculateSize: Yi,
  disableCache: Ui,
  enableCache: ji,
  getIcon: qi,
  iconExists: Ki,
  iconLoaded: Wi,
  iconToHTML: Zi,
  listIcons: Gi,
  loadIcon: ta,
  loadIcons: ea,
  svgToURL: Ji
}, Symbol.toStringTag, { value: "Module" }));
function ra(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Qo = {}, Yo = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return n;
    }
  });
  function t(o, r) {
    return {
      handler: o,
      config: r
    };
  }
  t.withOptions = function(o, r = () => ({})) {
    const a = function(i) {
      return {
        __options: i,
        handler: o(i),
        config: r(i)
      };
    };
    return a.__isOptionsFunction = !0, a.__pluginFunction = o, a.__configFunction = r, a;
  };
  const n = t;
})(Yo);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return o;
    }
  });
  const t = /* @__PURE__ */ n(Yo);
  function n(r) {
    return r && r.__esModule ? r : {
      default: r
    };
  }
  const o = t.default;
})(Qo);
let Ht = Qo;
var ia = (Ht.__esModule ? Ht : { default: Ht }).default;
const aa = /* @__PURE__ */ ra(ia), ee = {
  white: "#FFFFFF",
  lin: "#F7F6F0",
  charcoal: "#2B2B2B",
  black: "#131313"
}, J = {
  700: "#BA5225",
  600: "#CD4D16",
  500: "#EB512F",
  // Corale
  450: "#F9885E",
  400: "#F5B1A2",
  300: "#FCE2DD",
  200: "#FDEFEC",
  100: "#FEF7F5"
}, X = {
  750: "#1D1D1D",
  600: "#525252",
  500: "#737373",
  400: "#A3A3A3",
  300: "#D4D4D4",
  200: "#E5E5E5",
  150: "#EEEEEE",
  100: "#F5F5F5"
}, Ne = {
  500: "#1C6BB8",
  // Lapis-lazuli
  450: "#528BDD",
  300: "#71B9FF",
  100: "#EAEFF8"
}, ct = {
  700: "#247A5E",
  200: "#EBF8F3"
}, ut = {
  600: "#C83844",
  500: "#EB4452",
  200: "#F8EFF0"
}, ft = {
  800: "#95672B",
  500: "#FBBA66",
  200: "#FFF8F0"
}, ie = {
  "orange-600-25": "#CD4D1640",
  "neutral-800-15": "#17171726",
  "neutral-800-25": "#17171740",
  "lin-25": "#F7F6F040",
  transparent: "#00000000"
}, Vt = {
  DEFAULT: Ne[450],
  focus: Ne[450],
  "focus-inverse": Ne[300]
}, on = [
  "Circular",
  '"system-ui"',
  "-apple-system",
  "BlinkMacSystemFont",
  '"Segoe UI"',
  "Roboto",
  '"Helvetica Neue"',
  "Arial",
  '"Noto Sans"',
  "sans-serif",
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
  '"Noto Color Emoji"'
], sa = ["neue-haas-display", ...on], dt = {
  background: {
    default: X[150],
    surface: ee.white,
    "surface-hover": X[100],
    "surface-neutral": X[100],
    fill: ee.lin,
    "fill-alt": ee.charcoal,
    "fill-alt-hover": X[750],
    "fill-brand": J[100],
    "fill-hover": X[150],
    "fill-hover-primary": J[200],
    "fill-alt-disabled": ie["neutral-800-15"],
    "fill-primary": J[600],
    "fill-primary-disabled": ie["orange-600-25"],
    "fill-primary-hover": J[700],
    "fill-tip": Ne[100],
    "fill-error": ut[200],
    "fill-success": ct[200],
    "fill-caution": ft[200],
    "fill-discrete": X[300],
    "fill-discrete2": X[200],
    "fill-discrete3": X[150],
    "fill-primary-discrete": J[300],
    "fill-primary-discrete2": J[200],
    "fill-primary-discrete1": J[100],
    transparent: ie.transparent
  },
  text: {
    // adding this to make sure there's always a way to access the default color
    "default-color": ee.charcoal,
    inverse: ee.lin,
    "inverse-disabled": ee.lin,
    abovePrimary: ee.lin,
    "abovePrimary-disabled": ie["lin-25"],
    primary: J[600],
    "primary-disabled": ie["orange-600-25"],
    "primary-discrete": J[400],
    discrete: X[600],
    discrete2: X[500],
    discrete3: X[400],
    disabled: ie["neutral-800-25"],
    success: ct[700],
    error: ut[600],
    caution: ft[800],
    link: J[600],
    "link-inverse": J[450]
  },
  border: {
    default: ee.charcoal,
    // adding this to make sure there's always a way to access the default color
    "default-color": ee.charcoal,
    primary: J[600],
    "primary-disabled": ie["orange-600-25"],
    error: ut[500],
    success: ct[700],
    tip: Ne[500],
    caution: ft[500],
    discrete: X[500],
    discrete2: X[400],
    discrete3: X[300],
    disabled: ie["neutral-800-25"],
    brand: J[400],
    transparent: ie.transparent
  },
  icon: {
    icon: ee.charcoal,
    // default
    "icon-inverse": ee.lin,
    "icon-primary": J[600],
    "icon-brand": J[500],
    "icon-abovePrimary": ee.lin,
    "icon-abovePrimary-disabled": ee.lin,
    "icon-primary-disabled": ie["orange-600-25"],
    "icon-discrete": X[600],
    "icon-discrete2": X[500],
    "icon-discrete3": X[400],
    "icon-disabled": ie["neutral-800-25"],
    "icon-success": ct[700],
    "icon-error": ut[600],
    "icon-tip": Ne[500],
    "icon-caution": ft[500]
  }
}, la = {
  screens: {
    sm: "320px",
    md: "768px",
    lg: "1024px"
  },
  fontFamily: {
    DEFAULT: on,
    sans: on,
    title: sa
  },
  fontSize: {
    DEFAULT: "1rem",
    // 16px
    "2xs": "0.75rem",
    // 12px
    xs: "0.8125rem",
    // 13px
    sm: "0.875rem",
    // 14px
    base: "1rem",
    // 16px
    lg: "1.125rem",
    // 18px
    xl: "1.25rem",
    // 20px
    "2xl": "1.5rem",
    // 24px
    "3xl": "1.75rem",
    // 28px
    "4xl": "2.25rem",
    // 36px
    "5xl": "3rem",
    // 48px
    "6xl": "3.75rem"
    // 60px
  },
  lineHeight: {
    DEFAULT: "1.5rem",
    // 24px
    sm: "1.25rem",
    // 20px
    "3xl": "2rem",
    // 32px
    "4xl": "3rem",
    // 40px
    "5xl": "3.5rem",
    // 64px
    "6xl": "4.5rem"
    // 72px
  },
  fontWeight: {
    DEFAULT: "450",
    normal: "450",
    medium: "500",
    bold: "700",
    black: "900"
  },
  spacing: {
    zero: "0px",
    "4xs": "1px",
    "3xs": "2px",
    "2xs": "4px",
    xs: "6px",
    sm: "8px",
    md: "12px",
    lg: "16px",
    xl: "20px",
    "2xl": "24px",
    "3xl": "32px",
    "4xl": "40px",
    "5xl": "48px",
    "6xl": "64px",
    "7xl": "80px",
    "8xl": "120px",
    "9xl": "150px",
    "10xl": "256px"
  },
  borderRadius: {
    DEFAULT: "4px",
    none: "0",
    xs: "2px",
    sm: "4px",
    md: "6px",
    lg: "8px",
    xl: "12px",
    "2xl": "16px",
    "3xl": "24px",
    "4xl": "40px",
    full: "9999px"
  },
  boxShadow: {
    DEFAULT: "0 1px 3px 0 rgb(0 0 0 / 0.1)",
    base: "0 1px 3px 0 rgb(0 0 0 / 0.1)",
    sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
    md: "0 4px 6px -1px rgb(0 0 0 / 0.1)",
    lg: "0 10px 15px -3px rgb(0 0 0 / 0.1)",
    xl: "0 20px 25px -5px rgb(0 0 0 / 0.1)",
    "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
    reverse: "0 -10px 15px -3 rgb(0 0 0 / 0.05)"
  },
  color: {
    transparent: "transparent",
    black: ee.black,
    white: ee.white
  },
  borderColor: {
    ...dt.border
  },
  outlineColor: () => Vt,
  ringColor: () => Vt,
  ringOffsetColor: () => Vt,
  backgroundColor: {
    ...dt.background
  },
  textColor: {
    ...dt.text,
    ...dt.icon
  },
  transitionTimingFunction: {
    "slow-down": "cubic-bezier(0, 0.35, 0, 1)",
    smooth: "cubic-bezier(0.35, 0.1, 0, 1)"
  }
}, ca = {
  theme: {
    ...la
  }
}, u0 = aa(
  function({ addBase: e, addComponents: t, theme: n }) {
    const o = {
      fontSize: n("fontSize.6xl"),
      fontFamily: n("fontFamily.title"),
      fontWeight: n("fontWeight.black"),
      lineHeight: n("lineHeight.6xl"),
      "@media (max-width: 767px)": {
        fontSize: n("fontSize.5xl"),
        lineHeight: n("lineHeight.5xl")
      }
    }, r = {
      fontSize: n("fontSize.5xl"),
      fontWeight: n("fontWeight.black"),
      lineHeight: n("lineHeight.5xl"),
      fontFamily: n("fontFamily.title"),
      "@media (max-width: 767px)": {
        fontSize: n("fontSize.4xl"),
        lineHeight: n("lineHeight.4xl")
      }
    }, a = {
      fontSize: n("fontSize.4xl"),
      fontWeight: n("fontWeight.black"),
      fontFamily: n("fontFamily.title"),
      lineHeight: n("lineHeight.4xl"),
      "@media (max-width: 767px)": {
        fontSize: n("fontSize.3xl"),
        lineHeight: n("lineHeight.3xl")
      }
    }, i = {
      fontSize: n("fontSize.3xl"),
      fontWeight: n("fontWeight.black"),
      lineHeight: n("lineHeight.3xl"),
      fontFamily: n("fontFamily.title"),
      "@media (max-width: 767px)": {
        fontSize: n("fontSize.2xl"),
        lineHeight: n("lineHeight.2xl")
      }
    }, l = {
      fontSize: n("fontSize.2xl"),
      lineHeight: n("lineHeight.3xl"),
      fontWeight: n("fontWeight.black"),
      fontFamily: n("fontFamily.title"),
      "@media (max-width: 767px)": {
        fontSize: n("fontSize.xl"),
        lineHeight: n("lineHeight.xl")
      }
    }, s = {
      fontSize: n("fontSize.xl"),
      fontWeight: n("fontWeight.black"),
      lineHeight: n("lineHeight.DEFAULT"),
      fontFamily: n("fontFamily.title")
    };
    t({
      ".text-h1": o,
      ".text-h2": r,
      ".text-h3": a,
      ".text-h4": i,
      ".text-h5": l,
      ".text-h6": s,
      ".text-body": {
        fontSize: n("fontSize.DEFAULT"),
        lineHeight: n("lineHeight.DEFAULT")
      },
      ".text-body-lg": {
        fontSize: n("fontSize.lg"),
        lineHeight: n("lineHeight.DEFAULT")
      },
      ".text-body-sm": {
        fontSize: n("fontSize.sm"),
        lineHeight: n("lineHeight.sm")
      },
      ".text-body-xs": {
        fontSize: n("fontSize.xs"),
        lineHeight: n("lineHeight.sm")
      },
      ".text-form-error": {
        color: n("textColor.error"),
        fontSize: n("fontSize.sm"),
        fontWeight: n("fontWeight.medium"),
        lineHeight: n("lineHeight.sm")
      },
      ".text-heading-uppercase": {
        fontSize: n("fontSize.2xs"),
        fontWeight: n("fontWeight.medium"),
        lineHeight: n("lineHeight.sm"),
        textTransform: "uppercase"
      }
    });
  },
  {
    theme: {
      ...ca.theme
    }
  }
), ua = ["icon", "aria-label"], fa = {}, q = /* @__PURE__ */ Q({
  ...fa,
  __name: "UIIcon",
  props: {
    name: {},
    size: { default: "base" }
  },
  setup(e) {
    let t;
    ((r) => {
      r.sm = "16", r.base = "20", r.lg = "24", r.xl = "32", r["2xl"] = "40";
    })(t || (t = {}));
    const n = e, o = B({
      height: `${t[n.size]}px`,
      width: `${t[n.size]}px`,
      style: {
        height: `${t[n.size]}px`,
        width: `${t[n.size]}px`
      },
      class: "tw-inline-block",
      role: "img",
      "data-allow-mismatch": !0
    });
    return (r, a) => (y(), I("iconify-icon", Re({ icon: r.name }, o.value, { "aria-label": r.name }), null, 16, ua));
  }
});
function te(e, t = {}) {
  return !da(e, t);
}
function da(e, t = {}) {
  return ha(e == null ? void 0 : e(t));
}
function ha(e) {
  return !e || pa(e).every(
    (t) => {
      var n, o;
      return t.type === Tr || t.type === kr && !((n = t.children) != null && n.length) || t.type === bt && !((o = t.children) != null && o.length);
    }
  );
}
function pa(e) {
  return Array.isArray(e) ? e : e !== null ? [e] : [];
}
const ma = {
  key: 0,
  class: "tw-flex tw-flex-grow tw-flex-col tw-gap-3xs"
}, va = {
  key: 1,
  class: "tw-flex-grow tw-gap-3xs"
}, ba = {
  key: 2,
  class: "tw-flex tw-h-xl"
}, wa = /* @__PURE__ */ Q({
  __name: "UIBanner",
  props: {
    state: { default: "brand" },
    customIconName: { default: "" },
    isDismissible: { type: Boolean, default: !1 },
    isSplitInTwoLines: { type: Boolean, default: !0 },
    link: { default: "" },
    target: { default: "_blank" }
  },
  emits: ["dismiss", "previous", "next", "click"],
  setup(e, { emit: t }) {
    const n = t, o = Pe(), r = k(() => te(o.paginationText)), a = k(() => {
      if (e.customIconName) return e.customIconName;
      const u = {
        success: "mdi:check-circle",
        caution: "mdi:information-slab-circle",
        error: "mdi:alert-circle",
        brand: "groover:logo",
        tip: "mdi:lightbulb-on"
      };
      return u[e.state] || u.brand;
    }), i = k(() => {
      const u = {
        success: "tw-text-icon-success",
        caution: "tw-text-icon-caution",
        error: "tw-text-icon-error",
        brand: "tw-text-icon-brand",
        tip: "tw-text-icon-tip"
      };
      return u[e.state] || u.brand;
    }), l = k(() => {
      const u = {
        success: "tw-bg-fill-success tw-border-success",
        caution: "tw-bg-fill-caution tw-border-caution",
        error: "tw-bg-fill-error tw-border-error",
        brand: "tw-bg-fill-brand tw-border-brand",
        tip: "tw-bg-fill-tip tw-border-tip"
      };
      return u[e.state] || u.brand;
    }), s = k(() => {
      const u = {
        success: "tw-text-success",
        caution: "tw-text-caution",
        error: "tw-text-error",
        brand: "tw-text-primary",
        tip: "tw-text-black"
      };
      return "tw-font-bold " + (u[e.state] || u.brand);
    }), c = k(
      () => e.link ? {
        href: e.link,
        target: e.target,
        rel: "noopener"
      } : {}
    );
    return (u, f) => (y(), H(tt(u.link ? "a" : "div"), Re(c.value, {
      onClick: f[3] || (f[3] = (d) => n("click", d))
    }), {
      default: G(() => [
        V("div", {
          role: "note",
          class: P(["tw-text-body-sm tw-flex tw-gap-sm tw-rounded-sm tw-border-2 tw-p-md tw-text-sm tw-leading-sm", l.value])
        }, [
          oe(q, {
            name: a.value,
            class: P(i.value)
          }, null, 8, ["name", "class"]),
          u.isSplitInTwoLines ? (y(), I("p", ma, [
            F(te)(o.title) ? (y(), I("span", {
              key: 0,
              class: P(s.value)
            }, [
              R(u.$slots, "title")
            ], 2)) : z("", !0),
            V("span", null, [
              R(u.$slots, "content")
            ])
          ])) : (y(), I("p", va, [
            F(te)(o.title) ? (y(), I(bt, { key: 0 }, [
              V("span", {
                class: P(s.value)
              }, [
                R(u.$slots, "title")
              ], 2),
              f[4] || (f[4] = bo(" "))
            ], 64)) : z("", !0),
            R(u.$slots, "content")
          ])),
          r.value ? (y(), I("div", ba, [
            V("button", {
              type: "button",
              "aria-label": "previous-arrow",
              class: "tw-text-icon-discrete",
              onClick: f[0] || (f[0] = Dn((d) => n("previous"), ["stop"]))
            }, [
              oe(q, { name: "mdi:chevron-left" })
            ]),
            R(u.$slots, "paginationText"),
            V("button", {
              type: "button",
              class: "tw-text-icon-discrete",
              "aria-label": "next-arrow",
              onClick: f[1] || (f[1] = Dn((d) => n("next"), ["stop"]))
            }, [
              oe(q, { name: "mdi:chevron-right" })
            ])
          ])) : z("", !0),
          u.isDismissible ? (y(), I("button", {
            key: 3,
            type: "button",
            class: "tw-font-semibold tw-mb-auto tw-ml-auto tw-h-xl tw-cursor-pointer tw-text-sm tw-text-icon-discrete",
            onClick: f[2] || (f[2] = (d) => n("dismiss"))
          }, [
            oe(q, { name: "mdi:close" })
          ])) : z("", !0)
        ], 2)
      ]),
      _: 3
    }, 16));
  }
}), f0 = /* @__PURE__ */ Q({
  __name: "UIBannerMulti",
  props: {
    config: {},
    pageSeparatorText: { default: "-" },
    isDismissible: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = Pe(), n = B(0), o = k(() => e.config[n.value]);
    function r() {
      n.value === e.config.length - 1 ? n.value = 0 : n.value++;
    }
    function a() {
      n.value === 0 ? n.value = e.config.length - 1 : n.value--;
    }
    return e.config.length < 1 && console.error("UIBannerMulti requires at least one UIBanner component"), e.config.length !== Object.keys(t).filter((i) => i.startsWith("content")).length && console.error(
      "UIBannerMulti requires the same number of content slots and single UIBanner configs"
    ), (i, l) => (y(), H(wa, Re(o.value, {
      "is-dismissible": i.isDismissible,
      onNext: r,
      onPrevious: a
    }), {
      paginationText: G(() => [
        bo(Z(n.value + 1) + " " + Z(i.pageSeparatorText) + " " + Z(i.config.length), 1)
      ]),
      title: G(() => [
        R(i.$slots, `title${n.value + 1}`)
      ]),
      content: G(() => [
        R(i.$slots, `content${n.value + 1}`)
      ]),
      _: 3
    }, 16, ["is-dismissible"]));
  }
});
function kn() {
  const e = Sr("NuxtLink"), t = k(() => e === "NuxtLink" ? "a" : e);
  function n(r) {
    return r.startsWith("http");
  }
  function o(r) {
    return r;
  }
  return typeof useLocalePath == "function" && (o = useLocalePath()), {
    isExternalLink: n,
    linkComponent: t,
    localePath: o
  };
}
function zt(e) {
  return wo() ? (go(e), !0) : !1;
}
const Bt = /* @__PURE__ */ new WeakMap(), ga = (...e) => {
  var t;
  const n = e[0], o = (t = pn()) == null ? void 0 : t.proxy;
  if (o == null && !yo())
    throw new Error("injectLocal must be called in setup");
  return o && Bt.has(o) && n in Bt.get(o) ? Bt.get(o)[n] : Ir(...e);
}, Sn = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const ya = (e) => e != null, xa = Object.prototype.toString, Xo = (e) => xa.call(e) === "[object Object]", be = () => {
}, rn = /* @__PURE__ */ Ca();
function Ca() {
  var e, t;
  return Sn && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function to(e) {
  return e.endsWith("rem") ? Number.parseFloat(e) * 16 : Number.parseFloat(e);
}
function Ta(e) {
  return pn();
}
function ye(e) {
  return Array.isArray(e) ? e : [e];
}
function ka(...e) {
  if (e.length !== 1)
    return vn(...e);
  const t = e[0];
  return typeof t == "function" ? Mr(Fr(() => ({ get: t, set: be }))) : B(t);
}
function Sa(e, t = !0, n) {
  Ta() ? mn(e, n) : t ? e() : Ar(e);
}
function Aa(e = !1, t = {}) {
  const {
    truthyValue: n = !0,
    falsyValue: o = !1
  } = t, r = Er(e), a = B(e);
  function i(l) {
    if (arguments.length)
      return a.value = l, a.value;
    {
      const s = W(n);
      return a.value = a.value === s ? W(o) : s, a.value;
    }
  }
  return r ? i : [a, i];
}
function Zo(e, t, n) {
  return ae(
    e,
    t,
    {
      ...n,
      immediate: !0
    }
  );
}
const An = Sn ? window : void 0;
function Jo(e) {
  var t;
  const n = W(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
function an(...e) {
  const t = [], n = () => {
    t.forEach((l) => l()), t.length = 0;
  }, o = (l, s, c, u) => (l.addEventListener(s, c, u), () => l.removeEventListener(s, c, u)), r = k(() => {
    const l = ye(W(e[0])).filter((s) => s != null);
    return l.every((s) => typeof s != "string") ? l : void 0;
  }), a = Zo(
    () => {
      var l, s;
      return [
        (s = (l = r.value) == null ? void 0 : l.map((c) => Jo(c))) != null ? s : [An].filter((c) => c != null),
        ye(W(r.value ? e[1] : e[0])),
        ye(F(r.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        W(r.value ? e[3] : e[2])
      ];
    },
    ([l, s, c, u]) => {
      if (n(), !(l != null && l.length) || !(s != null && s.length) || !(c != null && c.length))
        return;
      const f = Xo(u) ? { ...u } : u;
      t.push(
        ...l.flatMap(
          (d) => s.flatMap(
            (h) => c.map((v) => o(d, h, v, f))
          )
        )
      );
    },
    { flush: "post" }
  ), i = () => {
    a(), n();
  };
  return zt(n), i;
}
function Ia() {
  const e = Ce(!1), t = pn();
  return t && mn(() => {
    e.value = !0;
  }, t), e;
}
function Ea(e) {
  const t = Ia();
  return k(() => (t.value, !!e()));
}
const Ma = Symbol("vueuse-ssr-width");
function Fa() {
  const e = yo() ? ga(Ma, null) : null;
  return typeof e == "number" ? e : void 0;
}
function za(e, t = {}) {
  const { window: n = An, ssrWidth: o = Fa() } = t, r = Ea(() => n && "matchMedia" in n && typeof n.matchMedia == "function"), a = B(typeof o == "number"), i = Ce(), l = Ce(!1), s = (c) => {
    l.value = c.matches;
  };
  return zr(() => {
    if (a.value) {
      a.value = !r.value;
      const c = W(e).split(",");
      l.value = c.some((u) => {
        const f = u.includes("not all"), d = u.match(/\(\s*min-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/), h = u.match(/\(\s*max-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/);
        let v = !!(d || h);
        return d && v && (v = o >= to(d[1])), h && v && (v = o <= to(h[1])), f ? !v : v;
      });
      return;
    }
    r.value && (i.value = n.matchMedia(W(e)), l.value = i.value.matches);
  }), an(i, "change", s, { passive: !0 }), k(() => l.value);
}
function Oa(e = {}) {
  const {
    window: t = An,
    initialWidth: n = Number.POSITIVE_INFINITY,
    initialHeight: o = Number.POSITIVE_INFINITY,
    listenOrientation: r = !0,
    includeScrollbar: a = !0,
    type: i = "inner"
  } = e, l = B(n), s = B(o), c = () => {
    if (t)
      if (i === "outer")
        l.value = t.outerWidth, s.value = t.outerHeight;
      else if (i === "visual" && t.visualViewport) {
        const { width: f, height: d, scale: h } = t.visualViewport;
        l.value = Math.round(f * h), s.value = Math.round(d * h);
      } else a ? (l.value = t.innerWidth, s.value = t.innerHeight) : (l.value = t.document.documentElement.clientWidth, s.value = t.document.documentElement.clientHeight);
  };
  c(), Sa(c);
  const u = { passive: !0 };
  if (an("resize", c, u), t && i === "visual" && t.visualViewport && an(t.visualViewport, "resize", c, u), r) {
    const f = za("(orientation: portrait)");
    ae(f, () => c());
  }
  return { width: l, height: s };
}
var Ke = /* @__PURE__ */ ((e) => (e[e.sm = 320] = "sm", e[e.md = 768] = "md", e[e.lg = 1024] = "lg", e))(Ke || {});
function Na() {
  const { width: e } = Oa(), t = k(() => e.value < Ke.md), n = k(
    () => e.value >= Ke.md && e.value < Ke.lg
  ), o = k(() => e.value >= Ke.lg);
  return {
    isSm: t,
    isMd: n,
    isLg: o
  };
}
function er(e) {
  const { isSm: t } = Na(), n = k(() => {
    const r = W(e);
    return r === "large" && t.value ? "medium" : r === "medium" && t.value ? "small" : r;
  }), o = k(
    () => n.value === "large" ? "lg" : "base"
  );
  return {
    scaledButtonSize: n,
    scaledIconSize: o
  };
}
const Da = { class: "tw-flex tw-items-center tw-justify-center tw-gap-x-2xs" }, La = {
  key: 1,
  class: "tw-whitespace-nowrap"
}, $a = {}, d0 = /* @__PURE__ */ Q({
  ...$a,
  __name: "UIButton",
  props: {
    color: { default: "default" },
    iconLeftName: { default: null },
    iconRightName: { default: null },
    size: { default: "medium" },
    text: { default: null },
    to: { default: void 0 },
    type: { default: "button" },
    variant: { default: "primary" }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, o = t, r = bn(), { linkComponent: a, localePath: i, isExternalLink: l } = kn(), { scaledButtonSize: s, scaledIconSize: c } = er(
      vn(() => n.size)
    ), u = "tw-p-3xs tw-text-sm tw-leading-sm tw-h-2xl", f = "tw-p-sm tw-text-sm tw-leading-sm tw-h-[36px]", d = "tw-p-md tw-text-base tw-leading tw-h-5xl", h = "tw-p-lg tw-text-lg tw-leading tw-h-[56px]", v = "tw-text-abovePrimary tw-bg-fill-primary tw-border-primary disabled:tw-bg-fill-primary-disabled hover:tw-bg-fill-primary-hover hover:tw-shadow-md", x = "tw-bg-fill-alt tw-text-inverse disabled:tw-bg-fill-alt-disabled hover:tw-bg-fill-alt-hover hover:tw-shadow-md", w = "tw-border tw-border-primary tw-text-primary disabled:tw-border-primary-disabled disabled:tw-text-primary-disabled hover:tw-bg-fill-hover-primary hover:tw-shadow-md", p = "tw-border tw-text disabled:tw-bg-fill disabled:tw-border-disabled disabled:tw-text-disabled hover:tw-bg-fill-hover hover:tw-shadow-md", g = "tw-text-primary disabled:tw-text-primary-disabled hover:tw-bg-fill-hover-primary hover:tw-shadow-md", C = "tw-text disabled:tw-text-disabled hover:tw-bg-fill-hover hover:tw-shadow-md", S = k(() => [
      n.variant === "primary" && n.color === "default" && v,
      n.variant === "primary" && n.color === "neutral" && x,
      n.variant === "outlined" && n.color === "default" && w,
      n.variant === "outlined" && n.color === "neutral" && p,
      n.variant === "transparent" && n.color === "default" && g,
      n.variant === "transparent" && n.color === "neutral" && C
    ].join(" ").replaceAll("false", "")), D = k(() => [
      s.value === "xsmall" && u,
      s.value === "small" && f,
      s.value === "medium" && d,
      s.value === "large" && h
    ].join(" ").replaceAll("false", "")), A = k(() => n.to || r.href ? a.value : "button"), E = k(() => {
      const L = n.to ?? r.href ?? "";
      return A.value === "button" ? {
        type: n.type
      } : { href: l(L) ? L : i(L) };
    });
    return (L, K) => (y(), H(tt(A.value), Re({
      class: ["tw-font-base tw-ease-linear tw-inline-block tw-rounded-sm tw-transition-all tw-duration-100 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-focus disabled:tw-pointer-events-none", [S.value, D.value]],
      "data-allow-mismatch": "class"
    }, E.value, {
      onClick: K[0] || (K[0] = (j) => o("click"))
    }), {
      default: G(() => [
        V("span", Da, [
          L.iconLeftName ? (y(), H(q, {
            key: 0,
            name: L.iconLeftName,
            size: F(c)
          }, null, 8, ["name", "size"])) : z("", !0),
          L.text ? (y(), I("span", La, Z(L.text), 1)) : z("", !0),
          L.iconRightName ? (y(), H(q, {
            key: 2,
            name: L.iconRightName,
            size: F(c)
          }, null, 8, ["name", "size"])) : z("", !0)
        ])
      ]),
      _: 1
    }, 16, ["class"]));
  }
}), _a = { class: "tw-relative" }, Ra = { class: "link-text tw-inline-block tw-w-full tw-transform tw-transition-transform tw-duration-[650ms] tw-ease-smooth" }, Pa = {}, Ha = /* @__PURE__ */ Q({
  ...Pa,
  __name: "UIButtonLink",
  props: {
    color: { default: "default" },
    iconLeftName: { default: null },
    iconRightName: { default: null },
    to: {},
    size: { default: "medium" },
    isExternal: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, { linkComponent: n, localePath: o, isExternalLink: r } = kn(), a = bn(), { scaledButtonSize: i, scaledIconSize: l } = er(
      vn(() => t.size)
    ), s = "tw-text-sm tw-leading-sm", c = "tw-text-base tw-leading", u = "tw-text-base tw-leading", f = "tw-text-primary tw-bg-gradient-to-r tw-from-bg-primary tw-to-bg-primary", d = "tw-bg-gradient-to-r tw-from-bg-fill-alt", h = "tw-text-primary-disabled tw-pointer-events-none", v = "tw-text-disabled tw-pointer-events-none", x = k(() => [
      t.color === "default" && f,
      t.color === "neutral" && d,
      a.disabled !== void 0 && t.color === "default" && h,
      a.disabled !== void 0 && t.color === "neutral" && v
    ].join(" ").replaceAll("false", "")), w = k(() => [
      i.value === "small" && s,
      i.value === "medium" && c,
      i.value === "large" && u
    ].join(" ").replaceAll("false", ""));
    return (p, g) => (y(), H(tt(F(n)), {
      class: P(["link tw-ease-linear tw-flex tw-w-fit tw-items-center tw-gap-x-2xs tw-rounded-sm tw-transition-all tw-duration-100 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-focus", [x.value, w.value]]),
      href: p.isExternal || F(r)(p.to) ? p.to : F(o)(p.to),
      external: p.isExternal === !0 ? !0 : void 0,
      "data-allow-mismatch": "class"
    }, {
      default: G(() => [
        p.iconLeftName ? (y(), H(q, {
          key: 0,
          name: p.iconLeftName,
          size: F(l)
        }, null, 8, ["name", "size"])) : z("", !0),
        V("span", _a, [
          V("span", Ra, [
            R(p.$slots, "default", {}, void 0, !0)
          ]),
          g[0] || (g[0] = V("span", { class: "link-underline tw-absolute tw-bottom-zero tw-left-zero tw-h-4xs tw-w-full tw-ease-slow-down motion-safe:tw-transform motion-safe:tw-transition-transform motion-safe:tw-duration-[650ms]" }, null, -1))
        ]),
        p.iconRightName ? (y(), H(q, {
          key: 1,
          name: p.iconRightName,
          size: F(l)
        }, null, 8, ["name", "size"])) : z("", !0)
      ]),
      _: 3
    }, 8, ["class", "href", "external"]));
  }
}), tr = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, r] of t)
    n[o] = r;
  return n;
}, h0 = /* @__PURE__ */ tr(Ha, [["__scopeId", "data-v-9063abc5"]]), Va = ["top", "right", "bottom", "left"], Le = Math.min, xe = Math.max, xt = Math.round, ht = Math.floor, pe = (e) => ({
  x: e,
  y: e
}), Ba = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, ja = {
  start: "end",
  end: "start"
};
function sn(e, t, n) {
  return xe(e, Le(t, n));
}
function Ve(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ke(e) {
  return e.split("-")[0];
}
function at(e) {
  return e.split("-")[1];
}
function nr(e) {
  return e === "x" ? "y" : "x";
}
function In(e) {
  return e === "y" ? "height" : "width";
}
function $e(e) {
  return ["top", "bottom"].includes(ke(e)) ? "y" : "x";
}
function En(e) {
  return nr($e(e));
}
function Ua(e, t, n) {
  n === void 0 && (n = !1);
  const o = at(e), r = En(e), a = In(r);
  let i = r === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (i = Ct(i)), [i, Ct(i)];
}
function Wa(e) {
  const t = Ct(e);
  return [ln(e), t, ln(t)];
}
function ln(e) {
  return e.replace(/start|end/g, (t) => ja[t]);
}
function Ka(e, t, n) {
  const o = ["left", "right"], r = ["right", "left"], a = ["top", "bottom"], i = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? r : o : t ? o : r;
    case "left":
    case "right":
      return t ? a : i;
    default:
      return [];
  }
}
function qa(e, t, n, o) {
  const r = at(e);
  let a = Ka(ke(e), n === "start", o);
  return r && (a = a.map((i) => i + "-" + r), t && (a = a.concat(a.map(ln)))), a;
}
function Ct(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Ba[t]);
}
function Ga(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function or(e) {
  return typeof e != "number" ? Ga(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Tt(e) {
  const {
    x: t,
    y: n,
    width: o,
    height: r
  } = e;
  return {
    width: o,
    height: r,
    top: n,
    left: t,
    right: t + o,
    bottom: n + r,
    x: t,
    y: n
  };
}
function no(e, t, n) {
  let {
    reference: o,
    floating: r
  } = e;
  const a = $e(t), i = En(t), l = In(i), s = ke(t), c = a === "y", u = o.x + o.width / 2 - r.width / 2, f = o.y + o.height / 2 - r.height / 2, d = o[l] / 2 - r[l] / 2;
  let h;
  switch (s) {
    case "top":
      h = {
        x: u,
        y: o.y - r.height
      };
      break;
    case "bottom":
      h = {
        x: u,
        y: o.y + o.height
      };
      break;
    case "right":
      h = {
        x: o.x + o.width,
        y: f
      };
      break;
    case "left":
      h = {
        x: o.x - r.width,
        y: f
      };
      break;
    default:
      h = {
        x: o.x,
        y: o.y
      };
  }
  switch (at(t)) {
    case "start":
      h[i] -= d * (n && c ? -1 : 1);
      break;
    case "end":
      h[i] += d * (n && c ? -1 : 1);
      break;
  }
  return h;
}
const Qa = async (e, t, n) => {
  const {
    placement: o = "bottom",
    strategy: r = "absolute",
    middleware: a = [],
    platform: i
  } = n, l = a.filter(Boolean), s = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let c = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: r
  }), {
    x: u,
    y: f
  } = no(c, o, s), d = o, h = {}, v = 0;
  for (let x = 0; x < l.length; x++) {
    const {
      name: w,
      fn: p
    } = l[x], {
      x: g,
      y: C,
      data: S,
      reset: D
    } = await p({
      x: u,
      y: f,
      initialPlacement: o,
      placement: d,
      strategy: r,
      middlewareData: h,
      rects: c,
      platform: i,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = g ?? u, f = C ?? f, h = {
      ...h,
      [w]: {
        ...h[w],
        ...S
      }
    }, D && v <= 50 && (v++, typeof D == "object" && (D.placement && (d = D.placement), D.rects && (c = D.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: r
    }) : D.rects), {
      x: u,
      y: f
    } = no(c, d, s)), x = -1);
  }
  return {
    x: u,
    y: f,
    placement: d,
    strategy: r,
    middlewareData: h
  };
};
async function kt(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: o,
    y: r,
    platform: a,
    rects: i,
    elements: l,
    strategy: s
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: f = "floating",
    altBoundary: d = !1,
    padding: h = 0
  } = Ve(t, e), v = or(h), w = l[d ? f === "floating" ? "reference" : "floating" : f], p = Tt(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(w))) == null || n ? w : w.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(l.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: s
  })), g = f === "floating" ? {
    x: o,
    y: r,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, C = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(l.floating)), S = await (a.isElement == null ? void 0 : a.isElement(C)) ? await (a.getScale == null ? void 0 : a.getScale(C)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, D = Tt(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: l,
    rect: g,
    offsetParent: C,
    strategy: s
  }) : g);
  return {
    top: (p.top - D.top + v.top) / S.y,
    bottom: (D.bottom - p.bottom + v.bottom) / S.y,
    left: (p.left - D.left + v.left) / S.x,
    right: (D.right - p.right + v.right) / S.x
  };
}
const Ya = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: o,
      placement: r,
      rects: a,
      platform: i,
      elements: l,
      middlewareData: s
    } = t, {
      element: c,
      padding: u = 0
    } = Ve(e, t) || {};
    if (c == null)
      return {};
    const f = or(u), d = {
      x: n,
      y: o
    }, h = En(r), v = In(h), x = await i.getDimensions(c), w = h === "y", p = w ? "top" : "left", g = w ? "bottom" : "right", C = w ? "clientHeight" : "clientWidth", S = a.reference[v] + a.reference[h] - d[h] - a.floating[v], D = d[h] - a.reference[h], A = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(c));
    let E = A ? A[C] : 0;
    (!E || !await (i.isElement == null ? void 0 : i.isElement(A))) && (E = l.floating[C] || a.floating[v]);
    const L = S / 2 - D / 2, K = E / 2 - x[v] / 2 - 1, j = Le(f[p], K), re = Le(f[g], K), $ = j, m = E - x[v] - re, b = E / 2 - x[v] / 2 + L, T = sn($, b, m), O = !s.arrow && at(r) != null && b !== T && a.reference[v] / 2 - (b < $ ? j : re) - x[v] / 2 < 0, N = O ? b < $ ? b - $ : b - m : 0;
    return {
      [h]: d[h] + N,
      data: {
        [h]: T,
        centerOffset: b - T - N,
        ...O && {
          alignmentOffset: N
        }
      },
      reset: O
    };
  }
}), Xa = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, o;
      const {
        placement: r,
        middlewareData: a,
        rects: i,
        initialPlacement: l,
        platform: s,
        elements: c
      } = t, {
        mainAxis: u = !0,
        crossAxis: f = !0,
        fallbackPlacements: d,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: v = "none",
        flipAlignment: x = !0,
        ...w
      } = Ve(e, t);
      if ((n = a.arrow) != null && n.alignmentOffset)
        return {};
      const p = ke(r), g = $e(l), C = ke(l) === l, S = await (s.isRTL == null ? void 0 : s.isRTL(c.floating)), D = d || (C || !x ? [Ct(l)] : Wa(l)), A = v !== "none";
      !d && A && D.push(...qa(l, x, v, S));
      const E = [l, ...D], L = await kt(t, w), K = [];
      let j = ((o = a.flip) == null ? void 0 : o.overflows) || [];
      if (u && K.push(L[p]), f) {
        const b = Ua(r, i, S);
        K.push(L[b[0]], L[b[1]]);
      }
      if (j = [...j, {
        placement: r,
        overflows: K
      }], !K.every((b) => b <= 0)) {
        var re, $;
        const b = (((re = a.flip) == null ? void 0 : re.index) || 0) + 1, T = E[b];
        if (T)
          return {
            data: {
              index: b,
              overflows: j
            },
            reset: {
              placement: T
            }
          };
        let O = ($ = j.filter((N) => N.overflows[0] <= 0).sort((N, _) => N.overflows[1] - _.overflows[1])[0]) == null ? void 0 : $.placement;
        if (!O)
          switch (h) {
            case "bestFit": {
              var m;
              const N = (m = j.filter((_) => {
                if (A) {
                  const M = $e(_.placement);
                  return M === g || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  M === "y";
                }
                return !0;
              }).map((_) => [_.placement, _.overflows.filter((M) => M > 0).reduce((M, U) => M + U, 0)]).sort((_, M) => _[1] - M[1])[0]) == null ? void 0 : m[0];
              N && (O = N);
              break;
            }
            case "initialPlacement":
              O = l;
              break;
          }
        if (r !== O)
          return {
            reset: {
              placement: O
            }
          };
      }
      return {};
    }
  };
};
function oo(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function ro(e) {
  return Va.some((t) => e[t] >= 0);
}
const Za = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: o = "referenceHidden",
        ...r
      } = Ve(e, t);
      switch (o) {
        case "referenceHidden": {
          const a = await kt(t, {
            ...r,
            elementContext: "reference"
          }), i = oo(a, n.reference);
          return {
            data: {
              referenceHiddenOffsets: i,
              referenceHidden: ro(i)
            }
          };
        }
        case "escaped": {
          const a = await kt(t, {
            ...r,
            altBoundary: !0
          }), i = oo(a, n.floating);
          return {
            data: {
              escapedOffsets: i,
              escaped: ro(i)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function Ja(e, t) {
  const {
    placement: n,
    platform: o,
    elements: r
  } = e, a = await (o.isRTL == null ? void 0 : o.isRTL(r.floating)), i = ke(n), l = at(n), s = $e(n) === "y", c = ["left", "top"].includes(i) ? -1 : 1, u = a && s ? -1 : 1, f = Ve(t, e);
  let {
    mainAxis: d,
    crossAxis: h,
    alignmentAxis: v
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return l && typeof v == "number" && (h = l === "end" ? v * -1 : v), s ? {
    x: h * u,
    y: d * c
  } : {
    x: d * c,
    y: h * u
  };
}
const es = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, o;
      const {
        x: r,
        y: a,
        placement: i,
        middlewareData: l
      } = t, s = await Ja(t, e);
      return i === ((n = l.offset) == null ? void 0 : n.placement) && (o = l.arrow) != null && o.alignmentOffset ? {} : {
        x: r + s.x,
        y: a + s.y,
        data: {
          ...s,
          placement: i
        }
      };
    }
  };
}, ts = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: o,
        placement: r
      } = t, {
        mainAxis: a = !0,
        crossAxis: i = !1,
        limiter: l = {
          fn: (w) => {
            let {
              x: p,
              y: g
            } = w;
            return {
              x: p,
              y: g
            };
          }
        },
        ...s
      } = Ve(e, t), c = {
        x: n,
        y: o
      }, u = await kt(t, s), f = $e(ke(r)), d = nr(f);
      let h = c[d], v = c[f];
      if (a) {
        const w = d === "y" ? "top" : "left", p = d === "y" ? "bottom" : "right", g = h + u[w], C = h - u[p];
        h = sn(g, h, C);
      }
      if (i) {
        const w = f === "y" ? "top" : "left", p = f === "y" ? "bottom" : "right", g = v + u[w], C = v - u[p];
        v = sn(g, v, C);
      }
      const x = l.fn({
        ...t,
        [d]: h,
        [f]: v
      });
      return {
        ...x,
        data: {
          x: x.x - n,
          y: x.y - o,
          enabled: {
            [d]: a,
            [f]: i
          }
        }
      };
    }
  };
};
function Ot() {
  return typeof window < "u";
}
function Ie(e) {
  return Mn(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function ne(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function ue(e) {
  var t;
  return (t = (Mn(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Mn(e) {
  return Ot() ? e instanceof Node || e instanceof ne(e).Node : !1;
}
function se(e) {
  return Ot() ? e instanceof Element || e instanceof ne(e).Element : !1;
}
function ce(e) {
  return Ot() ? e instanceof HTMLElement || e instanceof ne(e).HTMLElement : !1;
}
function io(e) {
  return !Ot() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof ne(e).ShadowRoot;
}
function st(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: o,
    display: r
  } = le(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && !["inline", "contents"].includes(r);
}
function ns(e) {
  return ["table", "td", "th"].includes(Ie(e));
}
function Nt(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function Fn(e) {
  const t = zn(), n = se(e) ? le(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((o) => n[o] ? n[o] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((o) => (n.willChange || "").includes(o)) || ["paint", "layout", "strict", "content"].some((o) => (n.contain || "").includes(o));
}
function os(e) {
  let t = me(e);
  for (; ce(t) && !_e(t); ) {
    if (Fn(t))
      return t;
    if (Nt(t))
      return null;
    t = me(t);
  }
  return null;
}
function zn() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function _e(e) {
  return ["html", "body", "#document"].includes(Ie(e));
}
function le(e) {
  return ne(e).getComputedStyle(e);
}
function Dt(e) {
  return se(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function me(e) {
  if (Ie(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    io(e) && e.host || // Fallback.
    ue(e)
  );
  return io(t) ? t.host : t;
}
function rr(e) {
  const t = me(e);
  return _e(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : ce(t) && st(t) ? t : rr(t);
}
function et(e, t, n) {
  var o;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const r = rr(e), a = r === ((o = e.ownerDocument) == null ? void 0 : o.body), i = ne(r);
  if (a) {
    const l = cn(i);
    return t.concat(i, i.visualViewport || [], st(r) ? r : [], l && n ? et(l) : []);
  }
  return t.concat(r, et(r, [], n));
}
function cn(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function ir(e) {
  const t = le(e);
  let n = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const r = ce(e), a = r ? e.offsetWidth : n, i = r ? e.offsetHeight : o, l = xt(n) !== a || xt(o) !== i;
  return l && (n = a, o = i), {
    width: n,
    height: o,
    $: l
  };
}
function On(e) {
  return se(e) ? e : e.contextElement;
}
function De(e) {
  const t = On(e);
  if (!ce(t))
    return pe(1);
  const n = t.getBoundingClientRect(), {
    width: o,
    height: r,
    $: a
  } = ir(t);
  let i = (a ? xt(n.width) : n.width) / o, l = (a ? xt(n.height) : n.height) / r;
  return (!i || !Number.isFinite(i)) && (i = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: i,
    y: l
  };
}
const rs = /* @__PURE__ */ pe(0);
function ar(e) {
  const t = ne(e);
  return !zn() || !t.visualViewport ? rs : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function is(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== ne(e) ? !1 : t;
}
function Se(e, t, n, o) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), a = On(e);
  let i = pe(1);
  t && (o ? se(o) && (i = De(o)) : i = De(e));
  const l = is(a, n, o) ? ar(a) : pe(0);
  let s = (r.left + l.x) / i.x, c = (r.top + l.y) / i.y, u = r.width / i.x, f = r.height / i.y;
  if (a) {
    const d = ne(a), h = o && se(o) ? ne(o) : o;
    let v = d, x = cn(v);
    for (; x && o && h !== v; ) {
      const w = De(x), p = x.getBoundingClientRect(), g = le(x), C = p.left + (x.clientLeft + parseFloat(g.paddingLeft)) * w.x, S = p.top + (x.clientTop + parseFloat(g.paddingTop)) * w.y;
      s *= w.x, c *= w.y, u *= w.x, f *= w.y, s += C, c += S, v = ne(x), x = cn(v);
    }
  }
  return Tt({
    width: u,
    height: f,
    x: s,
    y: c
  });
}
function as(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: o,
    strategy: r
  } = e;
  const a = r === "fixed", i = ue(o), l = t ? Nt(t.floating) : !1;
  if (o === i || l && a)
    return n;
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = pe(1);
  const u = pe(0), f = ce(o);
  if ((f || !f && !a) && ((Ie(o) !== "body" || st(i)) && (s = Dt(o)), ce(o))) {
    const d = Se(o);
    c = De(o), u.x = d.x + o.clientLeft, u.y = d.y + o.clientTop;
  }
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - s.scrollLeft * c.x + u.x,
    y: n.y * c.y - s.scrollTop * c.y + u.y
  };
}
function ss(e) {
  return Array.from(e.getClientRects());
}
function un(e, t) {
  const n = Dt(e).scrollLeft;
  return t ? t.left + n : Se(ue(e)).left + n;
}
function ls(e) {
  const t = ue(e), n = Dt(e), o = e.ownerDocument.body, r = xe(t.scrollWidth, t.clientWidth, o.scrollWidth, o.clientWidth), a = xe(t.scrollHeight, t.clientHeight, o.scrollHeight, o.clientHeight);
  let i = -n.scrollLeft + un(e);
  const l = -n.scrollTop;
  return le(o).direction === "rtl" && (i += xe(t.clientWidth, o.clientWidth) - r), {
    width: r,
    height: a,
    x: i,
    y: l
  };
}
function cs(e, t) {
  const n = ne(e), o = ue(e), r = n.visualViewport;
  let a = o.clientWidth, i = o.clientHeight, l = 0, s = 0;
  if (r) {
    a = r.width, i = r.height;
    const c = zn();
    (!c || c && t === "fixed") && (l = r.offsetLeft, s = r.offsetTop);
  }
  return {
    width: a,
    height: i,
    x: l,
    y: s
  };
}
function us(e, t) {
  const n = Se(e, !0, t === "fixed"), o = n.top + e.clientTop, r = n.left + e.clientLeft, a = ce(e) ? De(e) : pe(1), i = e.clientWidth * a.x, l = e.clientHeight * a.y, s = r * a.x, c = o * a.y;
  return {
    width: i,
    height: l,
    x: s,
    y: c
  };
}
function ao(e, t, n) {
  let o;
  if (t === "viewport")
    o = cs(e, n);
  else if (t === "document")
    o = ls(ue(e));
  else if (se(t))
    o = us(t, n);
  else {
    const r = ar(e);
    o = {
      ...t,
      x: t.x - r.x,
      y: t.y - r.y
    };
  }
  return Tt(o);
}
function sr(e, t) {
  const n = me(e);
  return n === t || !se(n) || _e(n) ? !1 : le(n).position === "fixed" || sr(n, t);
}
function fs(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let o = et(e, [], !1).filter((l) => se(l) && Ie(l) !== "body"), r = null;
  const a = le(e).position === "fixed";
  let i = a ? me(e) : e;
  for (; se(i) && !_e(i); ) {
    const l = le(i), s = Fn(i);
    !s && l.position === "fixed" && (r = null), (a ? !s && !r : !s && l.position === "static" && !!r && ["absolute", "fixed"].includes(r.position) || st(i) && !s && sr(e, i)) ? o = o.filter((u) => u !== i) : r = l, i = me(i);
  }
  return t.set(e, o), o;
}
function ds(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: o,
    strategy: r
  } = e;
  const i = [...n === "clippingAncestors" ? Nt(t) ? [] : fs(t, this._c) : [].concat(n), o], l = i[0], s = i.reduce((c, u) => {
    const f = ao(t, u, r);
    return c.top = xe(f.top, c.top), c.right = Le(f.right, c.right), c.bottom = Le(f.bottom, c.bottom), c.left = xe(f.left, c.left), c;
  }, ao(t, l, r));
  return {
    width: s.right - s.left,
    height: s.bottom - s.top,
    x: s.left,
    y: s.top
  };
}
function hs(e) {
  const {
    width: t,
    height: n
  } = ir(e);
  return {
    width: t,
    height: n
  };
}
function ps(e, t, n) {
  const o = ce(t), r = ue(t), a = n === "fixed", i = Se(e, !0, a, t);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const s = pe(0);
  if (o || !o && !a)
    if ((Ie(t) !== "body" || st(r)) && (l = Dt(t)), o) {
      const h = Se(t, !0, a, t);
      s.x = h.x + t.clientLeft, s.y = h.y + t.clientTop;
    } else r && (s.x = un(r));
  let c = 0, u = 0;
  if (r && !o && !a) {
    const h = r.getBoundingClientRect();
    u = h.top + l.scrollTop, c = h.left + l.scrollLeft - // RTL <body> scrollbar.
    un(r, h);
  }
  const f = i.left + l.scrollLeft - s.x - c, d = i.top + l.scrollTop - s.y - u;
  return {
    x: f,
    y: d,
    width: i.width,
    height: i.height
  };
}
function jt(e) {
  return le(e).position === "static";
}
function so(e, t) {
  if (!ce(e) || le(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return ue(e) === n && (n = n.ownerDocument.body), n;
}
function lr(e, t) {
  const n = ne(e);
  if (Nt(e))
    return n;
  if (!ce(e)) {
    let r = me(e);
    for (; r && !_e(r); ) {
      if (se(r) && !jt(r))
        return r;
      r = me(r);
    }
    return n;
  }
  let o = so(e, t);
  for (; o && ns(o) && jt(o); )
    o = so(o, t);
  return o && _e(o) && jt(o) && !Fn(o) ? n : o || os(e) || n;
}
const ms = async function(e) {
  const t = this.getOffsetParent || lr, n = this.getDimensions, o = await n(e.floating);
  return {
    reference: ps(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function vs(e) {
  return le(e).direction === "rtl";
}
const bs = {
  convertOffsetParentRelativeRectToViewportRelativeRect: as,
  getDocumentElement: ue,
  getClippingRect: ds,
  getOffsetParent: lr,
  getElementRects: ms,
  getClientRects: ss,
  getDimensions: hs,
  getScale: De,
  isElement: se,
  isRTL: vs
};
function ws(e, t) {
  let n = null, o;
  const r = ue(e);
  function a() {
    var l;
    clearTimeout(o), (l = n) == null || l.disconnect(), n = null;
  }
  function i(l, s) {
    l === void 0 && (l = !1), s === void 0 && (s = 1), a();
    const {
      left: c,
      top: u,
      width: f,
      height: d
    } = e.getBoundingClientRect();
    if (l || t(), !f || !d)
      return;
    const h = ht(u), v = ht(r.clientWidth - (c + f)), x = ht(r.clientHeight - (u + d)), w = ht(c), g = {
      rootMargin: -h + "px " + -v + "px " + -x + "px " + -w + "px",
      threshold: xe(0, Le(1, s)) || 1
    };
    let C = !0;
    function S(D) {
      const A = D[0].intersectionRatio;
      if (A !== s) {
        if (!C)
          return i();
        A ? i(!1, A) : o = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      C = !1;
    }
    try {
      n = new IntersectionObserver(S, {
        ...g,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(S, g);
    }
    n.observe(e);
  }
  return i(!0), a;
}
function gs(e, t, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: a = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: s = !1
  } = o, c = On(e), u = r || a ? [...c ? et(c) : [], ...et(t)] : [];
  u.forEach((p) => {
    r && p.addEventListener("scroll", n, {
      passive: !0
    }), a && p.addEventListener("resize", n);
  });
  const f = c && l ? ws(c, n) : null;
  let d = -1, h = null;
  i && (h = new ResizeObserver((p) => {
    let [g] = p;
    g && g.target === c && h && (h.unobserve(t), cancelAnimationFrame(d), d = requestAnimationFrame(() => {
      var C;
      (C = h) == null || C.observe(t);
    })), n();
  }), c && !s && h.observe(c), h.observe(t));
  let v, x = s ? Se(e) : null;
  s && w();
  function w() {
    const p = Se(e);
    x && (p.x !== x.x || p.y !== x.y || p.width !== x.width || p.height !== x.height) && n(), x = p, v = requestAnimationFrame(w);
  }
  return n(), () => {
    var p;
    u.forEach((g) => {
      r && g.removeEventListener("scroll", n), a && g.removeEventListener("resize", n);
    }), f == null || f(), (p = h) == null || p.disconnect(), h = null, s && cancelAnimationFrame(v);
  };
}
const ys = es, xs = ts, Cs = Xa, Ts = Za, ks = Ya, Ss = (e, t, n) => {
  const o = /* @__PURE__ */ new Map(), r = {
    platform: bs,
    ...n
  }, a = {
    ...r.platform,
    _c: o
  };
  return Qa(e, t, {
    ...r,
    platform: a
  });
};
function As(e) {
  return e != null && typeof e == "object" && "$el" in e;
}
function fn(e) {
  if (As(e)) {
    const t = e.$el;
    return Mn(t) && Ie(t) === "#comment" ? null : t;
  }
  return e;
}
function Fe(e) {
  return typeof e == "function" ? e() : F(e);
}
function Is(e) {
  return {
    name: "arrow",
    options: e,
    fn(t) {
      const n = fn(Fe(e.element));
      return n == null ? {} : ks({
        element: n,
        padding: e.padding
      }).fn(t);
    }
  };
}
function cr(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function lo(e, t) {
  const n = cr(e);
  return Math.round(t * n) / n;
}
function Es(e, t, n) {
  n === void 0 && (n = {});
  const o = n.whileElementsMounted, r = k(() => {
    var E;
    return (E = Fe(n.open)) != null ? E : !0;
  }), a = k(() => Fe(n.middleware)), i = k(() => {
    var E;
    return (E = Fe(n.placement)) != null ? E : "bottom";
  }), l = k(() => {
    var E;
    return (E = Fe(n.strategy)) != null ? E : "absolute";
  }), s = k(() => {
    var E;
    return (E = Fe(n.transform)) != null ? E : !0;
  }), c = k(() => fn(e.value)), u = k(() => fn(t.value)), f = B(0), d = B(0), h = B(l.value), v = B(i.value), x = Ce({}), w = B(!1), p = k(() => {
    const E = {
      position: h.value,
      left: "0",
      top: "0"
    };
    if (!u.value)
      return E;
    const L = lo(u.value, f.value), K = lo(u.value, d.value);
    return s.value ? {
      ...E,
      transform: "translate(" + L + "px, " + K + "px)",
      ...cr(u.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: h.value,
      left: L + "px",
      top: K + "px"
    };
  });
  let g;
  function C() {
    if (c.value == null || u.value == null)
      return;
    const E = r.value;
    Ss(c.value, u.value, {
      middleware: a.value,
      placement: i.value,
      strategy: l.value
    }).then((L) => {
      f.value = L.x, d.value = L.y, h.value = L.strategy, v.value = L.placement, x.value = L.middlewareData, w.value = E !== !1;
    });
  }
  function S() {
    typeof g == "function" && (g(), g = void 0);
  }
  function D() {
    if (S(), o === void 0) {
      C();
      return;
    }
    if (c.value != null && u.value != null) {
      g = o(c.value, u.value, C);
      return;
    }
  }
  function A() {
    r.value || (w.value = !1);
  }
  return ae([a, i, l, r], C, {
    flush: "sync"
  }), ae([c, u], D, {
    flush: "sync"
  }), ae(r, A, {
    flush: "sync"
  }), wo() && go(S), {
    x: Ee(f),
    y: Ee(d),
    strategy: Ee(h),
    placement: Ee(v),
    middlewareData: Ee(x),
    isPositioned: Ee(w),
    floatingStyles: p,
    update: C
  };
}
const ur = Sn ? window : void 0;
function qe(e) {
  var t;
  const n = W(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
function ze(...e) {
  const t = [], n = () => {
    t.forEach((l) => l()), t.length = 0;
  }, o = (l, s, c, u) => (l.addEventListener(s, c, u), () => l.removeEventListener(s, c, u)), r = k(() => {
    const l = ye(W(e[0])).filter((s) => s != null);
    return l.every((s) => typeof s != "string") ? l : void 0;
  }), a = Zo(
    () => {
      var l, s;
      return [
        (s = (l = r.value) == null ? void 0 : l.map((c) => qe(c))) != null ? s : [ur].filter((c) => c != null),
        ye(W(r.value ? e[1] : e[0])),
        ye(F(r.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        W(r.value ? e[3] : e[2])
      ];
    },
    ([l, s, c, u]) => {
      if (n(), !(l != null && l.length) || !(s != null && s.length) || !(c != null && c.length))
        return;
      const f = Xo(u) ? { ...u } : u;
      t.push(
        ...l.flatMap(
          (d) => s.flatMap(
            (h) => c.map((v) => o(d, h, v, f))
          )
        )
      );
    },
    { flush: "post" }
  ), i = () => {
    a(), n();
  };
  return zt(n), i;
}
let co = !1;
function uo(e, t, n = {}) {
  const { window: o = ur, ignore: r = [], capture: a = !0, detectIframe: i = !1, controls: l = !1 } = n;
  if (!o)
    return l ? { stop: be, cancel: be, trigger: be } : be;
  if (rn && !co) {
    co = !0;
    const w = { passive: !0 };
    Array.from(o.document.body.children).forEach((p) => ze(p, "click", be, w)), ze(o.document.documentElement, "click", be, w);
  }
  let s = !0;
  const c = (w) => W(r).some((p) => {
    if (typeof p == "string")
      return Array.from(o.document.querySelectorAll(p)).some((g) => g === w.target || w.composedPath().includes(g));
    {
      const g = qe(p);
      return g && (w.target === g || w.composedPath().includes(g));
    }
  });
  function u(w) {
    const p = W(w);
    return p && p.$.subTree.shapeFlag === 16;
  }
  function f(w, p) {
    const g = W(w), C = g.$.subTree && g.$.subTree.children;
    return C == null || !Array.isArray(C) ? !1 : C.some((S) => S.el === p.target || p.composedPath().includes(S.el));
  }
  const d = (w) => {
    const p = qe(e);
    if (w.target != null && !(!(p instanceof Element) && u(e) && f(e, w)) && !(!p || p === w.target || w.composedPath().includes(p))) {
      if ("detail" in w && w.detail === 0 && (s = !c(w)), !s) {
        s = !0;
        return;
      }
      t(w);
    }
  };
  let h = !1;
  const v = [
    ze(o, "click", (w) => {
      h || (h = !0, setTimeout(() => {
        h = !1;
      }, 0), d(w));
    }, { passive: !0, capture: a }),
    ze(o, "pointerdown", (w) => {
      const p = qe(e);
      s = !c(w) && !!(p && !w.composedPath().includes(p));
    }, { passive: !0 }),
    i && ze(o, "blur", (w) => {
      setTimeout(() => {
        var p;
        const g = qe(e);
        ((p = o.document.activeElement) == null ? void 0 : p.tagName) === "IFRAME" && !(g != null && g.contains(o.document.activeElement)) && t(w);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean), x = () => v.forEach((w) => w());
  return l ? {
    stop: x,
    cancel: () => {
      s = !1;
    },
    trigger: (w) => {
      s = !0, d(w), s = !1;
    }
  } : x;
}
const Ms = {
  mounted(e, t) {
    const n = !t.modifiers.bubble;
    if (typeof t.value == "function")
      e.__onClickOutside_stop = uo(e, t.value, { capture: n });
    else {
      const [o, r] = t.value;
      e.__onClickOutside_stop = uo(e, o, Object.assign({ capture: n }, r));
    }
  },
  unmounted(e) {
    e.__onClickOutside_stop();
  }
};
function Ut(e) {
  return typeof Window < "u" && e instanceof Window ? e.document.documentElement : typeof Document < "u" && e instanceof Document ? e.documentElement : e;
}
function fr(e) {
  const t = window.getComputedStyle(e);
  if (t.overflowX === "scroll" || t.overflowY === "scroll" || t.overflowX === "auto" && e.clientWidth < e.scrollWidth || t.overflowY === "auto" && e.clientHeight < e.scrollHeight)
    return !0;
  {
    const n = e.parentNode;
    return !n || n.tagName === "BODY" ? !1 : fr(n);
  }
}
function Fs(e) {
  const t = e || window.event, n = t.target;
  return fr(n) ? !1 : t.touches.length > 1 ? !0 : (t.preventDefault && t.preventDefault(), !1);
}
const Wt = /* @__PURE__ */ new WeakMap();
function zs(e, t = !1) {
  const n = B(t);
  let o = null, r = "";
  ae(ka(e), (l) => {
    const s = Ut(W(l));
    if (s) {
      const c = s;
      if (Wt.get(c) || Wt.set(c, c.style.overflow), c.style.overflow !== "hidden" && (r = c.style.overflow), c.style.overflow === "hidden")
        return n.value = !0;
      if (n.value)
        return c.style.overflow = "hidden";
    }
  }, {
    immediate: !0
  });
  const a = () => {
    const l = Ut(W(e));
    !l || n.value || (rn && (o = ze(
      l,
      "touchmove",
      (s) => {
        Fs(s);
      },
      { passive: !1 }
    )), l.style.overflow = "hidden", n.value = !0);
  }, i = () => {
    const l = Ut(W(e));
    !l || !n.value || (rn && (o == null || o()), l.style.overflow = r, Wt.delete(l), n.value = !1);
  };
  return zt(i), k({
    get() {
      return n.value;
    },
    set(l) {
      l ? a() : i();
    }
  });
}
function Os() {
  let e = !1;
  const t = Ce(!1);
  return (n, o) => {
    if (t.value = o.value, e)
      return;
    e = !0;
    const r = zs(n, o.value);
    ae(t, (a) => r.value = a);
  };
}
Os();
const Ns = { class: "tw-w-fit" }, Ds = {
  ref: "referenceEl",
  class: "tw-w-fit"
}, Ls = {}, dr = /* @__PURE__ */ Q({
  ...Ls,
  __name: "BaseFloating",
  props: {
    forceShowFloatingEl: { type: Boolean, default: void 0 },
    hasArrow: { type: Boolean, default: !1 },
    isStatic: { type: Boolean, default: !1 },
    offset: { default: 8 },
    placement: { default: "bottom-start" }
  },
  emits: ["click-outside", "show-floating", "hide-floating"],
  setup(e, { emit: t }) {
    const n = e, o = t, [r, a] = Aa(!1), i = Oe("referenceEl"), l = Oe("floatingEl"), s = Oe("floatingArrowEl"), c = 8, u = n.isStatic ? [] : [
      Cs({ padding: c }),
      xs({ padding: c })
    ], f = [
      ys(n.offset),
      ...u,
      Is({
        element: s,
        // the distance in px the arrow can show up against the side of the floating element itself.
        // Use to avoid overlapping rounded corners
        padding: 8
      }),
      Ts()
    ], {
      floatingStyles: d,
      middlewareData: h,
      placement: v
    } = Es(i, l, {
      middleware: f,
      /**
       * Update the floating element's position when the reference element's size or scroll position changes.
       *
       * @param referenceEl - The reference element.
       * @param floatingEl - The floating element.
       * @param update - The update function.
       * @returns - The cleanup function.
       */
      whileElementsMounted(p, g, C) {
        return gs(p, g, C, {
          ancestorScroll: !0,
          elementResize: !0
        });
      },
      placement: n.placement,
      strategy: "fixed"
    }), x = k(() => {
      var A;
      const { x: p, y: g } = ((A = h.value) == null ? void 0 : A.arrow) ?? {}, C = {
        top: "bottom",
        right: "left",
        bottom: "top",
        left: "right"
      }[v.value.split("-")[0]], D = typeof n.offset == "number" ? n.offset : 8;
      return {
        left: p != null ? `${p}px` : "",
        top: g != null ? `${g}px` : "",
        right: "",
        bottom: "",
        [C]: `-${D / 2}px`
      };
    });
    ae(r, (p) => {
      o(p ? "show-floating" : "hide-floating");
    }), ae(
      () => n.forceShowFloatingEl,
      (p) => {
        p !== void 0 && a(p);
      },
      { immediate: !0 }
    );
    function w() {
      o("click-outside"), n.forceShowFloatingEl !== !0 && a(!1);
    }
    return (p, g) => nt((y(), I("div", Ns, [
      V("div", Ds, [
        R(p.$slots, "reference", {
          isFloatingElDisplayed: F(r),
          toggleContentDisplay: F(a)
        })
      ], 512),
      oe(xo, {
        name: "fade",
        mode: "out-in",
        appear: ""
      }, {
        default: G(() => {
          var C;
          return [
            F(r) ? (y(), I("div", {
              key: 0,
              ref: "floatingEl",
              style: Ln({
                ...F(d),
                visibility: (C = F(h).hide) != null && C.referenceHidden ? "hidden" : "visible"
              }),
              class: "tw-z-50"
            }, [
              p.hasArrow ? (y(), I("span", {
                key: 0,
                ref: "floatingArrowEl",
                "data-testid": "floating-arrow",
                class: "tw-absolute tw-size-sm tw-rotate-45 tw-transform tw-bg-fill-alt",
                style: Ln(x.value)
              }, null, 4)) : z("", !0),
              R(p.$slots, "floating", { toggleContentDisplay: F(a) })
            ], 4)) : z("", !0)
          ];
        }),
        _: 3
      })
    ])), [
      [F(Ms), w]
    ]);
  }
}), $s = ["aria-controlledby", "onMouseleave", "onClick"], _s = {}, p0 = /* @__PURE__ */ Q({
  ..._s,
  __name: "UIDropdownMenu",
  props: {
    displayMenuOnHover: { type: Boolean, default: !1 },
    hideDelay: { default: 500 },
    referenceComponent: {},
    referenceComponentAttrs: { default: () => ({}) }
  },
  setup(e) {
    const t = e, n = Pe(), o = B(), r = ot();
    function a(s) {
      t.displayMenuOnHover && (clearTimeout(o.value), o.value = setTimeout(() => s(!1), t.hideDelay));
    }
    function i() {
      clearTimeout(o.value);
    }
    function l(s) {
      t.displayMenuOnHover && (clearTimeout(o.value), s(!0));
    }
    return te(n.menuLists) || console.error('UIDropdownMenu requires a slot named "menuLists"'), (s, c) => (y(), H(dr, null, {
      reference: G(({ toggleContentDisplay: u, isFloatingElDisplayed: f }) => [
        s.referenceComponent ? (y(), H(tt(s.referenceComponent), Re({ key: 0 }, s.referenceComponentAttrs, {
          id: F(r),
          "aria-expanded": f,
          onClick: (d) => u(),
          onMouseover: (d) => l(u),
          onMouseleave: (d) => a(u)
        }), {
          default: G(() => [
            R(s.$slots, "referenceText")
          ]),
          _: 2
        }, 1040, ["id", "aria-expanded", "onClick", "onMouseover", "onMouseleave"])) : z("", !0)
      ]),
      floating: G(({ toggleContentDisplay: u }) => [
        F(te)(n.menuLists) ? (y(), I("div", {
          key: 0,
          class: "tw-flex tw-min-w-[160px] tw-flex-col tw-gap-y-3xs tw-rounded-lg tw-bg-surface tw-p-2xs tw-shadow-lg",
          "aria-controlledby": F(r),
          onMouseover: i,
          onMouseleave: (f) => a(u),
          onClick: (f) => u(!1)
        }, [
          R(s.$slots, "menuLists")
        ], 40, $s)) : z("", !0)
      ]),
      _: 3
    }));
  }
}), Rs = {
  key: 0,
  class: "tw-text-body tw-rounded tw-px-md tw-py-sm tw-text-discrete"
}, Ps = {}, m0 = /* @__PURE__ */ Q({
  ...Ps,
  __name: "UIDropdownMenuList",
  props: {
    title: { default: "" }
  },
  setup(e) {
    return (t, n) => (y(), I("ul", null, [
      t.title ? (y(), I("li", Rs, Z(t.title), 1)) : z("", !0),
      R(t.$slots, "default")
    ]));
  }
}), Hs = { class: "tw-flex tw-flex-1 tw-flex-col tw-items-start tw-gap-y-3xs" }, Vs = { class: "tw-text-body" }, Bs = {
  key: 0,
  class: "tw-text-body-xs tw-text-discrete"
}, js = {
  key: 1,
  class: "tw-text-body tw-text-discrete"
}, Us = {}, v0 = /* @__PURE__ */ Q({
  ...Us,
  inheritAttrs: !1,
  __name: "UIDropdownMenuListItem",
  props: {
    href: { default: "" },
    isActive: { type: Boolean, default: !1 },
    leftIconName: { default: "" },
    rightIconName: { default: "" },
    rightSideText: { default: "" },
    size: { default: "base" },
    subText: { default: "" },
    text: {}
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, o = t, r = bn(), { linkComponent: a } = kn(), i = k(() => n.href || r.to ? a.value : "button"), l = k(() => n.href || r.to ? {
      href: n.href || r.to,
      "aria-current": n.isActive ? "page" : void 0,
      ...r
    } : {
      type: "button",
      "aria-checked": n.isActive ? n.isActive : void 0,
      ...r
    });
    return (s, c) => (y(), I("li", null, [
      (y(), H(tt(i.value), Re(l.value, {
        class: ["tw-flex tw-w-full tw-min-w-[160px] tw-items-center tw-gap-x-md tw-rounded tw-px-md hover:tw-bg-surface-hover", [
          {
            "tw-bg-fill-discrete3": s.isActive
          },
          s.size === "lg" ? "tw-py-md" : "tw-py-sm"
        ]],
        onClick: c[0] || (c[0] = (u) => o("click"))
      }), {
        default: G(() => [
          s.leftIconName ? (y(), H(q, {
            key: 0,
            name: s.leftIconName,
            class: "tw-text-icon-discrete2"
          }, null, 8, ["name"])) : z("", !0),
          V("span", Hs, [
            V("span", Vs, Z(s.text), 1),
            s.subText ? (y(), I("span", Bs, Z(s.subText), 1)) : z("", !0)
          ]),
          s.rightSideText ? (y(), I("span", js, Z(s.rightSideText), 1)) : z("", !0),
          s.rightIconName && s.isActive ? (y(), H(q, {
            key: 2,
            name: s.rightIconName,
            class: "tw-text-icon"
          }, null, 8, ["name"])) : z("", !0)
        ]),
        _: 1
      }, 16, ["class"]))
    ]));
  }
}), Ws = ["id", "name", "checked", "disabled", "valid", "readonly"], Ks = ["for"], qs = {}, Gs = /* @__PURE__ */ Q({
  ...qs,
  __name: "UIInputCheckbox",
  props: /* @__PURE__ */ Te({
    isDisabled: { type: Boolean, default: !1 },
    isIndeterminate: { type: Boolean, default: !1 },
    hasError: { type: Boolean, default: !1 }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = ot(), n = He(e, "modelValue");
    return (o, r) => (y(), I("span", {
      class: P(["tw-flex tw-h-full tw-items-center tw-justify-center tw-gap-md", {
        "tw-pointer-events-none": o.isDisabled
      }])
    }, [
      V("span", {
        class: P(["tw-relative tw-flex tw-h-xl tw-w-xl tw-flex-col tw-items-center tw-justify-center tw-rounded tw-border tw-border-discrete2 tw-bg-surface hover:tw-border-default-color disabled:tw-pointer-events-none", {
          "!tw-border-default-color !tw-bg-fill-alt": n.value && !o.isDisabled,
          "tw-border-2 !tw-border-error": o.hasError && !o.isDisabled,
          "!tw-bg-fill-error": o.hasError && !n.value && !o.isDisabled,
          "!tw-border-disabled !tw-bg-fill-alt-disabled": o.isDisabled
        }])
      }, [
        nt(V("input", {
          id: F(t),
          "onUpdate:modelValue": r[0] || (r[0] = (a) => n.value = a),
          type: "checkbox",
          name: F(t),
          checked: n.value,
          disabled: o.isDisabled,
          valid: o.hasError ? !1 : void 0,
          readonly: o.isDisabled,
          class: "tw-absolute tw-flex tw-h-full tw-w-full tw-appearance-none tw-rounded focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-focus"
        }, null, 8, Ws), [
          [Or, n.value]
        ]),
        n.value ? (y(), H(q, {
          key: 0,
          name: o.isIndeterminate ? "material-symbols:remove" : "material-symbols:check",
          size: "sm",
          class: P(["tw-text-inverse", {
            "!tw-text-disabled": o.isDisabled
          }])
        }, null, 8, ["name", "class"])) : z("", !0)
      ], 2),
      F(te)(o.$slots.label) ? (y(), I("label", {
        key: 0,
        for: F(t),
        class: "tw-flex-1 tw-items-center tw-justify-center"
      }, [
        R(o.$slots, "label")
      ], 8, Ks)) : z("", !0)
    ], 2));
  }
}), Qs = ["for"], Ys = {
  key: 0,
  class: "tw-ml-sm tw-font-normal tw-text-discrete2"
}, Xs = {}, hr = /* @__PURE__ */ Q({
  ...Xs,
  __name: "UIInputLabel",
  props: {
    htmlFor: {},
    optionalText: { default: "" }
  },
  setup(e) {
    return (t, n) => (y(), I("label", {
      for: t.htmlFor,
      class: "tw-block tw-text-base tw-font-bold"
    }, [
      R(t.$slots, "default"),
      t.optionalText ? (y(), I("span", Ys, Z(t.optionalText), 1)) : z("", !0)
    ], 8, Qs));
  }
}), Zs = ["id", "type", "placeholder", "name", "disabled"], Js = {
  key: 1,
  class: "tw-text-form-error tw-mt-2xs tw-inline-block"
}, el = {}, pr = /* @__PURE__ */ Q({
  ...el,
  __name: "BaseInput",
  props: /* @__PURE__ */ Te({
    errorText: { default: "" },
    helperText: { default: "" },
    inputSize: { default: "normal" },
    isDisabled: { type: Boolean, default: !1 },
    name: {},
    placeholder: { default: "" },
    iconLeftName: { default: null },
    type: { default: "text" },
    optionalLabelText: { default: "" }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Te(["focus", "blur"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = e, o = t, r = ot(), a = He(e, "modelValue"), i = k(() => [
      n.errorText && "tw-border-2 tw-border-error tw-bg-fill-error",
      n.isDisabled && "tw-pointer-events-none tw-bg-fill-alt-disabled tw-border-disabled",
      n.inputSize === "large" ? "tw-h-5xl tw-py-md" : "tw-h-4xl tw-py-sm"
    ].join(" ").replaceAll("false", "")), l = k(() => a.value && n.type === "password" ? "tw-text-success" : "tw-text-discrete2");
    return (s, c) => (y(), I("div", null, [
      F(te)(s.$slots.label) ? (y(), H(hr, {
        key: 0,
        "optional-text": s.optionalLabelText,
        "html-for": F(r),
        class: "tw-mb-2xs"
      }, {
        default: G(() => [
          R(s.$slots, "label")
        ]),
        _: 3
      }, 8, ["optional-text", "html-for"])) : z("", !0),
      V("div", {
        class: P(["tw-bg tw-relative tw-flex tw-w-full tw-items-center tw-gap-sm tw-rounded tw-border tw-border-discrete2 tw-px-md focus-within:tw-bg-surface focus-within:tw-outline focus-within:tw-outline-2 focus-within:tw-outline-focus hover:tw-border-default-color", i.value])
      }, [
        s.iconLeftName ? (y(), H(q, {
          key: 0,
          name: s.iconLeftName,
          size: "lg",
          class: "tw-text-icon-discrete2"
        }, null, 8, ["name"])) : z("", !0),
        nt(V("input", {
          id: F(r),
          "onUpdate:modelValue": c[0] || (c[0] = (u) => a.value = u),
          type: s.type,
          placeholder: s.placeholder,
          name: s.name,
          disabled: s.isDisabled,
          class: "tw-h-2xl tw-w-full tw-rounded tw-bg-transparent tw-outline-none placeholder:tw-text-discrete2",
          onFocus: c[1] || (c[1] = (u) => o("focus")),
          onBlur: c[2] || (c[2] = (u) => o("blur"))
        }, null, 40, Zs), [
          [Co, a.value]
        ]),
        R(s.$slots, "icon-button-right")
      ], 2),
      s.errorText ? (y(), I("span", Js, Z(s.errorText), 1)) : s.helperText ? (y(), I("span", {
        key: 2,
        class: P(["tw-mt-2xs tw-inline-block tw-text-sm", l.value])
      }, Z(s.helperText), 3)) : z("", !0)
    ]));
  }
}), tl = ["aria-label"], nl = {}, b0 = /* @__PURE__ */ Q({
  ...nl,
  __name: "UIInputPassword",
  props: /* @__PURE__ */ Te({
    errorText: { default: "" },
    helperText: { default: "" },
    inputSize: { default: "normal" },
    isDisabled: { type: Boolean, default: !1 },
    name: { default: "password" },
    placeholder: { default: "" },
    toggleVisibilityAriaText: { default: "" }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = He(e, "modelValue"), n = B("material-symbols:visibility-outline"), o = B("password");
    function r() {
      o.value === "password" ? (n.value = "material-symbols:visibility-off-outline", o.value = "text") : (n.value = "material-symbols:visibility-outline", o.value = "password");
    }
    return (a, i) => (y(), H(pr, {
      modelValue: t.value,
      "onUpdate:modelValue": i[0] || (i[0] = (l) => t.value = l),
      "icon-left-name": "material-symbols:lock-outline",
      type: o.value,
      placeholder: a.placeholder,
      name: a.name,
      "helper-text": a.helperText,
      "error-text": a.errorText,
      "input-size": a.inputSize,
      "is-disabled": a.isDisabled
    }, To({
      "icon-button-right": G(() => [
        V("button", {
          class: "tw-h-xl",
          type: "button",
          "aria-label": a.toggleVisibilityAriaText,
          onClick: r
        }, [
          oe(q, {
            name: n.value,
            class: "tw-text-icon-discrete2"
          }, null, 8, ["name"])
        ], 8, tl)
      ]),
      _: 2
    }, [
      F(te)(a.$slots.label) ? {
        name: "label",
        fn: G(() => [
          R(a.$slots, "label")
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["modelValue", "type", "placeholder", "name", "helper-text", "error-text", "input-size", "is-disabled"]));
  }
}), ol = ["aria-label"], rl = {}, w0 = /* @__PURE__ */ Q({
  ...rl,
  __name: "UIInputText",
  props: /* @__PURE__ */ Te({
    clearInputAriaText: { default: "" },
    errorText: { default: "" },
    helperText: { default: "" },
    iconLeftName: { default: null },
    inputSize: { default: "normal" },
    isDisabled: { type: Boolean, default: !1 },
    isIconRightVisible: { type: Boolean, default: !0 },
    isValidating: { type: Boolean, default: !1 },
    name: {},
    optionalLabelText: { default: "" },
    placeholder: { default: "" },
    type: { default: "text" }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, n = He(e, "modelValue"), o = B(!1), r = B(!1), a = k(() => o.value || r.value), i = k(() => !!(t.isIconRightVisible && a.value && n.value && l.value !== "eos-icons:loading" || t.errorText && !t.isValidating)), l = k(() => t.isValidating ? "eos-icons:loading" : t.errorText || i.value ? "mdi:close" : n.value && !t.errorText ? "material-symbols:check" : ""), s = k(() => n.value && !t.errorText && !i.value && !t.isValidating ? "tw-text-icon-success" : "tw-text-icon-discrete2"), c = k(() => t.isIconRightVisible && !i.value && l.value);
    ae(l, () => {
    });
    function u() {
      n.value = "";
    }
    function f() {
      setTimeout(() => {
        o.value = !1;
      }, 10);
    }
    return (d, h) => (y(), H(pr, {
      ref: "input",
      modelValue: n.value,
      "onUpdate:modelValue": h[2] || (h[2] = (v) => n.value = v),
      "icon-left-name": d.iconLeftName,
      type: d.type,
      placeholder: d.placeholder,
      name: d.name,
      "helper-text": d.helperText,
      "error-text": d.errorText,
      "input-size": d.inputSize,
      "optional-label-text": d.optionalLabelText,
      "is-disabled": d.isDisabled,
      onFocus: h[3] || (h[3] = (v) => o.value = !0),
      onBlur: f
    }, To({
      "icon-button-right": G(() => [
        i.value && !d.isDisabled ? (y(), I("button", {
          key: 0,
          type: "button",
          class: "tw-h-xl",
          "aria-label": d.clearInputAriaText,
          onClick: u,
          onFocus: h[0] || (h[0] = (v) => r.value = !0),
          onBlur: h[1] || (h[1] = (v) => r.value = !1)
        }, [
          oe(q, {
            name: l.value,
            class: P(s.value)
          }, null, 8, ["name", "class"])
        ], 40, ol)) : c.value && !d.isDisabled ? (y(), H(q, {
          key: 1,
          name: l.value,
          class: P(s.value)
        }, null, 8, ["name", "class"])) : z("", !0)
      ]),
      _: 2
    }, [
      F(te)(d.$slots.label) ? {
        name: "label",
        fn: G(() => [
          R(d.$slots, "label")
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["modelValue", "icon-left-name", "type", "placeholder", "name", "helper-text", "error-text", "input-size", "optional-label-text", "is-disabled"]));
  }
}), il = {
  key: 0,
  class: "tw-mb-2xl tw-mt-sm"
}, al = ["id", "placeholder", "name", "disabled"], sl = {
  key: 1,
  class: "tw-text-form-error tw-mt-2xs tw-inline-block"
}, ll = {
  key: 2,
  class: "tw-mt-2xs tw-inline-block tw-text-sm tw-text-discrete2"
}, g0 = /* @__PURE__ */ Q({
  __name: "UIInputTextarea",
  props: /* @__PURE__ */ Te({
    errorText: { default: "" },
    helperText: { default: "" },
    isDisabled: { type: Boolean, default: !1 },
    name: {},
    placeholder: { default: "" },
    optionalLabelText: { default: "" }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, n = ot(), o = He(e, "modelValue"), r = k(() => [
      t.errorText && "tw-border-2 tw-border-error tw-bg-fill-error",
      t.isDisabled && "tw-pointer-events-none tw-bg-fill-alt-disabled tw-border-disabled"
    ].join(" ").replaceAll("false", ""));
    return (a, i) => (y(), I("div", null, [
      oe(hr, {
        "optional-text": a.optionalLabelText,
        "html-for": F(n)
      }, {
        default: G(() => [
          R(a.$slots, "label")
        ]),
        _: 3
      }, 8, ["optional-text", "html-for"]),
      F(te)(a.$slots.tip) ? (y(), I("div", il, [
        R(a.$slots, "tip")
      ])) : z("", !0),
      nt(V("textarea", {
        id: F(n),
        "onUpdate:modelValue": i[0] || (i[0] = (l) => o.value = l),
        class: P(["tw-text-body tw-relative tw-flex tw-max-h-[50vh] tw-min-h-[88px] tw-w-full tw-items-center tw-gap-sm tw-rounded tw-border tw-border-discrete2 tw-bg-transparent tw-p-md placeholder:tw-text-discrete2 focus-within:tw-bg-surface focus-within:tw-outline focus-within:tw-outline-2 focus-within:tw-outline-focus hover:tw-border-default-color", r.value]),
        placeholder: a.placeholder,
        name: a.name,
        disabled: a.isDisabled
      }, null, 10, al), [
        [Co, o.value]
      ]),
      a.errorText ? (y(), I("span", sl, Z(a.errorText), 1)) : a.helperText ? (y(), I("span", ll, Z(a.helperText), 1)) : z("", !0)
    ]));
  }
});
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var mr = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], St = /* @__PURE__ */ mr.join(","), vr = typeof Element > "u", Ae = vr ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, At = !vr && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e == null ? void 0 : e.ownerDocument;
}, It = function e(t, n) {
  var o;
  n === void 0 && (n = !0);
  var r = t == null || (o = t.getAttribute) === null || o === void 0 ? void 0 : o.call(t, "inert"), a = r === "" || r === "true", i = a || n && t && e(t.parentNode);
  return i;
}, cl = function(t) {
  var n, o = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return o === "" || o === "true";
}, br = function(t, n, o) {
  if (It(t))
    return [];
  var r = Array.prototype.slice.apply(t.querySelectorAll(St));
  return n && Ae.call(t, St) && r.unshift(t), r = r.filter(o), r;
}, wr = function e(t, n, o) {
  for (var r = [], a = Array.from(t); a.length; ) {
    var i = a.shift();
    if (!It(i, !1))
      if (i.tagName === "SLOT") {
        var l = i.assignedElements(), s = l.length ? l : i.children, c = e(s, !0, o);
        o.flatten ? r.push.apply(r, c) : r.push({
          scopeParent: i,
          candidates: c
        });
      } else {
        var u = Ae.call(i, St);
        u && o.filter(i) && (n || !t.includes(i)) && r.push(i);
        var f = i.shadowRoot || // check for an undisclosed shadow
        typeof o.getShadowRoot == "function" && o.getShadowRoot(i), d = !It(f, !1) && (!o.shadowRootFilter || o.shadowRootFilter(i));
        if (f && d) {
          var h = e(f === !0 ? i.children : f.children, !0, o);
          o.flatten ? r.push.apply(r, h) : r.push({
            scopeParent: i,
            candidates: h
          });
        } else
          a.unshift.apply(a, i.children);
      }
  }
  return r;
}, gr = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, we = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || cl(t)) && !gr(t) ? 0 : t.tabIndex;
}, ul = function(t, n) {
  var o = we(t);
  return o < 0 && n && !gr(t) ? 0 : o;
}, fl = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, yr = function(t) {
  return t.tagName === "INPUT";
}, dl = function(t) {
  return yr(t) && t.type === "hidden";
}, hl = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(o) {
    return o.tagName === "SUMMARY";
  });
  return n;
}, pl = function(t, n) {
  for (var o = 0; o < t.length; o++)
    if (t[o].checked && t[o].form === n)
      return t[o];
}, ml = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || At(t), o = function(l) {
    return n.querySelectorAll('input[type="radio"][name="' + l + '"]');
  }, r;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    r = o(window.CSS.escape(t.name));
  else
    try {
      r = o(t.name);
    } catch (i) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", i.message), !1;
    }
  var a = pl(r, t.form);
  return !a || a === t;
}, vl = function(t) {
  return yr(t) && t.type === "radio";
}, bl = function(t) {
  return vl(t) && !ml(t);
}, wl = function(t) {
  var n, o = t && At(t), r = (n = o) === null || n === void 0 ? void 0 : n.host, a = !1;
  if (o && o !== t) {
    var i, l, s;
    for (a = !!((i = r) !== null && i !== void 0 && (l = i.ownerDocument) !== null && l !== void 0 && l.contains(r) || t != null && (s = t.ownerDocument) !== null && s !== void 0 && s.contains(t)); !a && r; ) {
      var c, u, f;
      o = At(r), r = (c = o) === null || c === void 0 ? void 0 : c.host, a = !!((u = r) !== null && u !== void 0 && (f = u.ownerDocument) !== null && f !== void 0 && f.contains(r));
    }
  }
  return a;
}, fo = function(t) {
  var n = t.getBoundingClientRect(), o = n.width, r = n.height;
  return o === 0 && r === 0;
}, gl = function(t, n) {
  var o = n.displayCheck, r = n.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var a = Ae.call(t, "details>summary:first-of-type"), i = a ? t.parentElement : t;
  if (Ae.call(i, "details:not([open]) *"))
    return !0;
  if (!o || o === "full" || o === "legacy-full") {
    if (typeof r == "function") {
      for (var l = t; t; ) {
        var s = t.parentElement, c = At(t);
        if (s && !s.shadowRoot && r(s) === !0)
          return fo(t);
        t.assignedSlot ? t = t.assignedSlot : !s && c !== t.ownerDocument ? t = c.host : t = s;
      }
      t = l;
    }
    if (wl(t))
      return !t.getClientRects().length;
    if (o !== "legacy-full")
      return !0;
  } else if (o === "non-zero-area")
    return fo(t);
  return !1;
}, yl = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var o = 0; o < n.children.length; o++) {
          var r = n.children.item(o);
          if (r.tagName === "LEGEND")
            return Ae.call(n, "fieldset[disabled] *") ? !0 : !r.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, Et = function(t, n) {
  return !(n.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  It(n) || dl(n) || gl(n, t) || // For a details element with a summary, the summary element gets the focus
  hl(n) || yl(n));
}, dn = function(t, n) {
  return !(bl(n) || we(n) < 0 || !Et(t, n));
}, xl = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, Cl = function e(t) {
  var n = [], o = [];
  return t.forEach(function(r, a) {
    var i = !!r.scopeParent, l = i ? r.scopeParent : r, s = ul(l, i), c = i ? e(r.candidates) : l;
    s === 0 ? i ? n.push.apply(n, c) : n.push(l) : o.push({
      documentOrder: a,
      tabIndex: s,
      item: r,
      isScope: i,
      content: c
    });
  }), o.sort(fl).reduce(function(r, a) {
    return a.isScope ? r.push.apply(r, a.content) : r.push(a.content), r;
  }, []).concat(n);
}, Tl = function(t, n) {
  n = n || {};
  var o;
  return n.getShadowRoot ? o = wr([t], n.includeContainer, {
    filter: dn.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: xl
  }) : o = br(t, n.includeContainer, dn.bind(null, n)), Cl(o);
}, kl = function(t, n) {
  n = n || {};
  var o;
  return n.getShadowRoot ? o = wr([t], n.includeContainer, {
    filter: Et.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : o = br(t, n.includeContainer, Et.bind(null, n)), o;
}, Me = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return Ae.call(t, St) === !1 ? !1 : dn(n, t);
}, Sl = /* @__PURE__ */ mr.concat("iframe").join(","), Kt = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return Ae.call(t, Sl) === !1 ? !1 : Et(n, t);
};
/*!
* focus-trap 7.6.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function hn(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function Al(e) {
  if (Array.isArray(e)) return hn(e);
}
function Il(e, t, n) {
  return (t = Ol(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function El(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Ml() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ho(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function po(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ho(Object(n), !0).forEach(function(o) {
      Il(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ho(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function Fl(e) {
  return Al(e) || El(e) || Nl(e) || Ml();
}
function zl(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t || "default");
    if (typeof o != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Ol(e) {
  var t = zl(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Nl(e, t) {
  if (e) {
    if (typeof e == "string") return hn(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? hn(e, t) : void 0;
  }
}
var mo = {
  activateTrap: function(t, n) {
    if (t.length > 0) {
      var o = t[t.length - 1];
      o !== n && o._setPausedState(!0);
    }
    var r = t.indexOf(n);
    r === -1 || t.splice(r, 1), t.push(n);
  },
  deactivateTrap: function(t, n) {
    var o = t.indexOf(n);
    o !== -1 && t.splice(o, 1), t.length > 0 && !t[t.length - 1]._isManuallyPaused() && t[t.length - 1]._setPausedState(!1);
  }
}, Dl = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, Ll = function(t) {
  return (t == null ? void 0 : t.key) === "Escape" || (t == null ? void 0 : t.key) === "Esc" || (t == null ? void 0 : t.keyCode) === 27;
}, Ye = function(t) {
  return (t == null ? void 0 : t.key) === "Tab" || (t == null ? void 0 : t.keyCode) === 9;
}, $l = function(t) {
  return Ye(t) && !t.shiftKey;
}, _l = function(t) {
  return Ye(t) && t.shiftKey;
}, vo = function(t) {
  return setTimeout(t, 0);
}, We = function(t) {
  for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++)
    o[r - 1] = arguments[r];
  return typeof t == "function" ? t.apply(void 0, o) : t;
}, pt = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, Rl = [], Pl = function(t, n) {
  var o = (n == null ? void 0 : n.document) || document, r = (n == null ? void 0 : n.trapStack) || Rl, a = po({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: $l,
    isKeyBackward: _l
  }, n), i = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, l, s = function(m, b, T) {
    return m && m[b] !== void 0 ? m[b] : a[T || b];
  }, c = function(m, b) {
    var T = typeof (b == null ? void 0 : b.composedPath) == "function" ? b.composedPath() : void 0;
    return i.containerGroups.findIndex(function(O) {
      var N = O.container, _ = O.tabbableNodes;
      return N.contains(m) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      (T == null ? void 0 : T.includes(N)) || _.find(function(M) {
        return M === m;
      });
    });
  }, u = function(m) {
    var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, T = b.hasFallback, O = T === void 0 ? !1 : T, N = b.params, _ = N === void 0 ? [] : N, M = a[m];
    if (typeof M == "function" && (M = M.apply(void 0, Fl(_))), M === !0 && (M = void 0), !M) {
      if (M === void 0 || M === !1)
        return M;
      throw new Error("`".concat(m, "` was specified but was not a node, or did not return a node"));
    }
    var U = M;
    if (typeof M == "string") {
      try {
        U = o.querySelector(M);
      } catch (Y) {
        throw new Error("`".concat(m, '` appears to be an invalid selector; error="').concat(Y.message, '"'));
      }
      if (!U && !O)
        throw new Error("`".concat(m, "` as selector refers to no known node"));
    }
    return U;
  }, f = function() {
    var m = u("initialFocus", {
      hasFallback: !0
    });
    if (m === !1)
      return !1;
    if (m === void 0 || m && !Kt(m, a.tabbableOptions))
      if (c(o.activeElement) >= 0)
        m = o.activeElement;
      else {
        var b = i.tabbableGroups[0], T = b && b.firstTabbableNode;
        m = T || u("fallbackFocus");
      }
    else m === null && (m = u("fallbackFocus"));
    if (!m)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return m;
  }, d = function() {
    if (i.containerGroups = i.containers.map(function(m) {
      var b = Tl(m, a.tabbableOptions), T = kl(m, a.tabbableOptions), O = b.length > 0 ? b[0] : void 0, N = b.length > 0 ? b[b.length - 1] : void 0, _ = T.find(function(Y) {
        return Me(Y);
      }), M = T.slice().reverse().find(function(Y) {
        return Me(Y);
      }), U = !!b.find(function(Y) {
        return we(Y) > 0;
      });
      return {
        container: m,
        tabbableNodes: b,
        focusableNodes: T,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: U,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: O,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: N,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: _,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: M,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(ve) {
          var Be = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, fe = b.indexOf(ve);
          return fe < 0 ? Be ? T.slice(T.indexOf(ve) + 1).find(function(je) {
            return Me(je);
          }) : T.slice(0, T.indexOf(ve)).reverse().find(function(je) {
            return Me(je);
          }) : b[fe + (Be ? 1 : -1)];
        }
      };
    }), i.tabbableGroups = i.containerGroups.filter(function(m) {
      return m.tabbableNodes.length > 0;
    }), i.tabbableGroups.length <= 0 && !u("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (i.containerGroups.find(function(m) {
      return m.posTabIndexesFound;
    }) && i.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, h = function(m) {
    var b = m.activeElement;
    if (b)
      return b.shadowRoot && b.shadowRoot.activeElement !== null ? h(b.shadowRoot) : b;
  }, v = function(m) {
    if (m !== !1 && m !== h(document)) {
      if (!m || !m.focus) {
        v(f());
        return;
      }
      m.focus({
        preventScroll: !!a.preventScroll
      }), i.mostRecentlyFocusedNode = m, Dl(m) && m.select();
    }
  }, x = function(m) {
    var b = u("setReturnFocus", {
      params: [m]
    });
    return b || (b === !1 ? !1 : m);
  }, w = function(m) {
    var b = m.target, T = m.event, O = m.isBackward, N = O === void 0 ? !1 : O;
    b = b || pt(T), d();
    var _ = null;
    if (i.tabbableGroups.length > 0) {
      var M = c(b, T), U = M >= 0 ? i.containerGroups[M] : void 0;
      if (M < 0)
        N ? _ = i.tabbableGroups[i.tabbableGroups.length - 1].lastTabbableNode : _ = i.tabbableGroups[0].firstTabbableNode;
      else if (N) {
        var Y = i.tabbableGroups.findIndex(function(Lt) {
          var $t = Lt.firstTabbableNode;
          return b === $t;
        });
        if (Y < 0 && (U.container === b || Kt(b, a.tabbableOptions) && !Me(b, a.tabbableOptions) && !U.nextTabbableNode(b, !1)) && (Y = M), Y >= 0) {
          var ve = Y === 0 ? i.tabbableGroups.length - 1 : Y - 1, Be = i.tabbableGroups[ve];
          _ = we(b) >= 0 ? Be.lastTabbableNode : Be.lastDomTabbableNode;
        } else Ye(T) || (_ = U.nextTabbableNode(b, !1));
      } else {
        var fe = i.tabbableGroups.findIndex(function(Lt) {
          var $t = Lt.lastTabbableNode;
          return b === $t;
        });
        if (fe < 0 && (U.container === b || Kt(b, a.tabbableOptions) && !Me(b, a.tabbableOptions) && !U.nextTabbableNode(b)) && (fe = M), fe >= 0) {
          var je = fe === i.tabbableGroups.length - 1 ? 0 : fe + 1, Nn = i.tabbableGroups[je];
          _ = we(b) >= 0 ? Nn.firstTabbableNode : Nn.firstDomTabbableNode;
        } else Ye(T) || (_ = U.nextTabbableNode(b));
      }
    } else
      _ = u("fallbackFocus");
    return _;
  }, p = function(m) {
    var b = pt(m);
    if (!(c(b, m) >= 0)) {
      if (We(a.clickOutsideDeactivates, m)) {
        l.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: a.returnFocusOnDeactivate
        });
        return;
      }
      We(a.allowOutsideClick, m) || m.preventDefault();
    }
  }, g = function(m) {
    var b = pt(m), T = c(b, m) >= 0;
    if (T || b instanceof Document)
      T && (i.mostRecentlyFocusedNode = b);
    else {
      m.stopImmediatePropagation();
      var O, N = !0;
      if (i.mostRecentlyFocusedNode)
        if (we(i.mostRecentlyFocusedNode) > 0) {
          var _ = c(i.mostRecentlyFocusedNode), M = i.containerGroups[_].tabbableNodes;
          if (M.length > 0) {
            var U = M.findIndex(function(Y) {
              return Y === i.mostRecentlyFocusedNode;
            });
            U >= 0 && (a.isKeyForward(i.recentNavEvent) ? U + 1 < M.length && (O = M[U + 1], N = !1) : U - 1 >= 0 && (O = M[U - 1], N = !1));
          }
        } else
          i.containerGroups.some(function(Y) {
            return Y.tabbableNodes.some(function(ve) {
              return we(ve) > 0;
            });
          }) || (N = !1);
      else
        N = !1;
      N && (O = w({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: i.mostRecentlyFocusedNode,
        isBackward: a.isKeyBackward(i.recentNavEvent)
      })), v(O || i.mostRecentlyFocusedNode || f());
    }
    i.recentNavEvent = void 0;
  }, C = function(m) {
    var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    i.recentNavEvent = m;
    var T = w({
      event: m,
      isBackward: b
    });
    T && (Ye(m) && m.preventDefault(), v(T));
  }, S = function(m) {
    (a.isKeyForward(m) || a.isKeyBackward(m)) && C(m, a.isKeyBackward(m));
  }, D = function(m) {
    Ll(m) && We(a.escapeDeactivates, m) !== !1 && (m.preventDefault(), l.deactivate());
  }, A = function(m) {
    var b = pt(m);
    c(b, m) >= 0 || We(a.clickOutsideDeactivates, m) || We(a.allowOutsideClick, m) || (m.preventDefault(), m.stopImmediatePropagation());
  }, E = function() {
    if (i.active)
      return mo.activateTrap(r, l), i.delayInitialFocusTimer = a.delayInitialFocus ? vo(function() {
        v(f());
      }) : v(f()), o.addEventListener("focusin", g, !0), o.addEventListener("mousedown", p, {
        capture: !0,
        passive: !1
      }), o.addEventListener("touchstart", p, {
        capture: !0,
        passive: !1
      }), o.addEventListener("click", A, {
        capture: !0,
        passive: !1
      }), o.addEventListener("keydown", S, {
        capture: !0,
        passive: !1
      }), o.addEventListener("keydown", D), l;
  }, L = function() {
    if (i.active)
      return o.removeEventListener("focusin", g, !0), o.removeEventListener("mousedown", p, !0), o.removeEventListener("touchstart", p, !0), o.removeEventListener("click", A, !0), o.removeEventListener("keydown", S, !0), o.removeEventListener("keydown", D), l;
  }, K = function(m) {
    var b = m.some(function(T) {
      var O = Array.from(T.removedNodes);
      return O.some(function(N) {
        return N === i.mostRecentlyFocusedNode;
      });
    });
    b && v(f());
  }, j = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(K) : void 0, re = function() {
    j && (j.disconnect(), i.active && !i.paused && i.containers.map(function(m) {
      j.observe(m, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return l = {
    get active() {
      return i.active;
    },
    get paused() {
      return i.paused;
    },
    activate: function(m) {
      if (i.active)
        return this;
      var b = s(m, "onActivate"), T = s(m, "onPostActivate"), O = s(m, "checkCanFocusTrap");
      O || d(), i.active = !0, i.paused = !1, i.nodeFocusedBeforeActivation = o.activeElement, b == null || b();
      var N = function() {
        O && d(), E(), re(), T == null || T();
      };
      return O ? (O(i.containers.concat()).then(N, N), this) : (N(), this);
    },
    deactivate: function(m) {
      if (!i.active)
        return this;
      var b = po({
        onDeactivate: a.onDeactivate,
        onPostDeactivate: a.onPostDeactivate,
        checkCanReturnFocus: a.checkCanReturnFocus
      }, m);
      clearTimeout(i.delayInitialFocusTimer), i.delayInitialFocusTimer = void 0, L(), i.active = !1, i.paused = !1, re(), mo.deactivateTrap(r, l);
      var T = s(b, "onDeactivate"), O = s(b, "onPostDeactivate"), N = s(b, "checkCanReturnFocus"), _ = s(b, "returnFocus", "returnFocusOnDeactivate");
      T == null || T();
      var M = function() {
        vo(function() {
          _ && v(x(i.nodeFocusedBeforeActivation)), O == null || O();
        });
      };
      return _ && N ? (N(x(i.nodeFocusedBeforeActivation)).then(M, M), this) : (M(), this);
    },
    pause: function(m) {
      return i.active ? (i.manuallyPaused = !0, this._setPausedState(!0, m)) : this;
    },
    unpause: function(m) {
      return i.active ? (i.manuallyPaused = !1, r[r.length - 1] !== this ? this : this._setPausedState(!1, m)) : this;
    },
    updateContainerElements: function(m) {
      var b = [].concat(m).filter(Boolean);
      return i.containers = b.map(function(T) {
        return typeof T == "string" ? o.querySelector(T) : T;
      }), i.active && d(), re(), this;
    }
  }, Object.defineProperties(l, {
    _isManuallyPaused: {
      value: function() {
        return i.manuallyPaused;
      }
    },
    _setPausedState: {
      value: function(m, b) {
        if (i.paused === m)
          return this;
        if (i.paused = m, m) {
          var T = s(b, "onPause"), O = s(b, "onPostPause");
          T == null || T(), L(), re(), O == null || O();
        } else {
          var N = s(b, "onUnpause"), _ = s(b, "onPostUnpause");
          N == null || N(), d(), E(), re(), _ == null || _();
        }
        return this;
      }
    }
  }), l.updateContainerElements(t), l;
};
function Hl(e, t = {}) {
  let n;
  const { immediate: o, ...r } = t, a = Ce(!1), i = Ce(!1), l = (d) => n && n.activate(d), s = (d) => n && n.deactivate(d), c = () => {
    n && (n.pause(), i.value = !0);
  }, u = () => {
    n && (n.unpause(), i.value = !1);
  }, f = k(() => {
    const d = W(e);
    return ye(d).map((h) => {
      const v = W(h);
      return typeof v == "string" ? v : Jo(v);
    }).filter(ya);
  });
  return ae(
    f,
    (d) => {
      d.length && (n = Pl(d, {
        ...r,
        onActivate() {
          a.value = !0, t.onActivate && t.onActivate();
        },
        onDeactivate() {
          a.value = !1, t.onDeactivate && t.onDeactivate();
        }
      }), o && l());
    },
    { flush: "post" }
  ), zt(() => s()), {
    hasFocus: a,
    isPaused: i,
    activate: l,
    deactivate: s,
    pause: c,
    unpause: u
  };
}
const Vl = {
  key: 0,
  class: "tw-absolute tw-bottom-zero tw-left-zero tw-right-zero tw-top-zero tw-z-[999999] tw-flex tw-items-end tw-bg-fill-alt tw-bg-opacity-70 md:tw-items-center md:tw-justify-center"
}, Bl = {
  key: 1,
  id: "modalTitle"
}, jl = { key: 3 }, Ul = {
  key: 0,
  id: "modalContent",
  class: "tw-p-lg"
}, Wl = {
  key: 1,
  class: "tw-w-full tw-p-lg"
}, Kl = {}, y0 = /* @__PURE__ */ Q({
  ...Kl,
  __name: "UIModal",
  props: {
    hasBackButton: { type: Boolean, default: !1 },
    isDismissable: { type: Boolean, default: !0 },
    size: { default: "base" }
  },
  emits: ["close", "previous"],
  setup(e, { emit: t }) {
    const n = t, o = Pe(), r = Oe("modal"), { activate: a, deactivate: i } = Hl(r, { immediate: !0 }), l = B(!1);
    mn(() => {
      l.value = !0, a(), s();
    }), Nr(() => {
      l.value = !1, i(), c();
    });
    function s() {
      document && document.body && (document.body.style.overflow = "hidden");
    }
    function c() {
      document && document.body && (document.body.style.overflow = "auto");
    }
    return (u, f) => (y(), H(Dr, { to: "body" }, [
      oe(xo, {
        name: "fade",
        mode: "out-in"
      }, {
        default: G(() => [
          l.value ? (y(), I("div", Vl, [
            V("article", {
              ref: "modal",
              "aria-modal": "true",
              role: "dialog",
              "aria-labelledby": "modalTitle",
              "aria-describedby": "modalContent",
              class: P(["tw-flex tw-w-full tw-flex-col tw-rounded-t-xl tw-bg-surface tw-p-sm md:tw-rounded-md", {
                "md:tw-w-[400px]": u.size === "sm",
                "md:tw-w-[640px]": u.size === "base",
                "md:tw-w-[800px]": u.size === "lg"
              }]),
              onKeydown: f[2] || (f[2] = qt((d) => u.isDismissable && n("close"), ["escape"]))
            }, [
              V("div", {
                class: P(["tw-p-lg", {
                  "tw-flex tw-items-center tw-justify-between": u.hasBackButton || u.isDismissable,
                  "tw-text-center md:tw-text-left": !u.hasBackButton && !u.isDismissable
                }])
              }, [
                u.hasBackButton ? (y(), I("button", {
                  key: 0,
                  type: "button",
                  class: "tw-flex tw-size-2xl tw-cursor-pointer tw-items-center tw-justify-center",
                  onClick: f[0] || (f[0] = (d) => n("previous"))
                }, [
                  oe(q, {
                    name: "famicons:chevron-back-sharp",
                    size: "lg",
                    class: "tw-text-icon-discrete"
                  })
                ])) : z("", !0),
                F(te)(o.title) ? (y(), I("header", Bl, [
                  R(u.$slots, "title")
                ])) : z("", !0),
                u.isDismissable ? (y(), I("button", {
                  key: 2,
                  type: "button",
                  class: "tw-flex tw-size-xl tw-cursor-pointer tw-items-center tw-justify-center",
                  onClick: f[1] || (f[1] = (d) => n("close"))
                }, [
                  oe(q, {
                    name: "material-symbols:close",
                    size: "lg",
                    class: "tw-text-icon-discrete"
                  })
                ])) : (y(), I("span", jl))
              ], 2),
              F(te)(o.content) ? (y(), I("section", Ul, [
                R(u.$slots, "content")
              ])) : z("", !0),
              F(te)(o.cta) ? (y(), I("footer", Wl, [
                R(u.$slots, "cta")
              ])) : z("", !0)
            ], 34)
          ])) : z("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), ql = /* @__PURE__ */ Q({
  __name: "UITag",
  props: {
    color: { default: "default" },
    iconLeftName: { default: "" },
    iconRightName: { default: "" },
    size: { default: "base" },
    text: { default: "" },
    variant: { default: "filled" }
  },
  setup(e) {
    const t = e;
    t.variant === "transparent" && t.color === "alt" && console.error("Variant `transparent` cannot be used with color `alt`");
    const n = k(() => t.variant === "transparent" ? { "tw-bg-fill-transparent": t.variant === "transparent" } : {
      "tw-bg-fill-discrete3": t.color === "default" || t.color === "disabled",
      "tw-bg-fill-primary-discrete2": t.color === "primary",
      "tw-bg-fill-alt": t.color === "alt",
      "tw-bg-fill-success": t.color === "success",
      "tw-bg-fill-caution": t.color === "warning",
      "tw-bg-fill-error": t.color === "error"
    }), o = k(() => ({
      "tw-p-2xs": t.size === "base",
      "tw-py-3xs tw-px-2xs": t.size === "sm"
    })), r = k(() => [
      {
        // color
        "tw-text-discrete": t.color === "default",
        "tw-text-discrete3": t.color === "disabled",
        "tw-text-primary": t.color === "primary",
        "tw-text-inverse": t.color === "alt",
        "tw-text-success": t.color === "success",
        "tw-text-caution": t.color === "warning",
        "tw-text-error": t.color === "error",
        // size
        "tw-text-body-xs": t.size === "sm",
        "tw-text-body-sm": t.size === "base"
      }
    ]), a = k(() => ({
      "tw-text-icon-discrete": t.color === "default",
      "tw-text-icon-discrete3": t.color === "disabled",
      "tw-text-icon-primary": t.color === "primary",
      "tw-text-icon-inverse": t.color === "alt",
      "tw-text-icon-success": t.color === "success",
      "tw-text-icon-caution": t.color === "warning",
      "tw-text-icon-error": t.color === "error"
    }));
    return (i, l) => (y(), I("span", {
      class: P(["tw-flex tw-w-fit tw-items-center tw-rounded-lg", [n.value, o.value]])
    }, [
      i.iconLeftName ? (y(), H(q, {
        key: 0,
        name: i.iconLeftName,
        size: "sm",
        class: P(a.value)
      }, null, 8, ["name", "class"])) : z("", !0),
      i.text ? (y(), I("span", {
        key: 1,
        class: P(["tw-px-3xs", r.value])
      }, Z(i.text), 3)) : z("", !0),
      i.iconRightName ? (y(), H(q, {
        key: 2,
        name: i.iconRightName,
        size: "sm",
        class: P(a.value)
      }, null, 8, ["name", "class"])) : z("", !0)
    ], 2));
  }
}), Gl = { class: "tw-flex tw-w-full tw-items-center tw-gap-x-md" }, Ql = { class: "tw-flex tw-flex-1 tw-items-center tw-gap-x-2xs" }, Yl = { class: "tw-flex tw-flex-col tw-items-start tw-gap-y-3xs" }, Xl = {
  key: 0,
  class: "tw-text-body tw-font-medium"
}, Zl = {}, x0 = /* @__PURE__ */ Q({
  ...Zl,
  __name: "UISelectionCard",
  props: /* @__PURE__ */ Te({
    displayCheckbox: { type: Boolean, default: !0 },
    isDisabled: { type: Boolean, default: !1 },
    hasError: { type: Boolean, default: !1 },
    iconName: { default: "" },
    size: { default: "base" },
    subText: { default: "" },
    tagText: { default: "" },
    text: { default: "" }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = He(e, "modelValue");
    return (n, o) => (y(), I("label", {
      class: P(["tw-flex tw-w-full tw-min-w-[176px] tw-cursor-pointer tw-items-center tw-justify-between tw-gap-x-md tw-rounded-lg tw-border tw-border-discrete2 tw-bg-surface focus-within:tw-outline hover:tw-bg-fill-hover", [
        {
          "!tw-border-default tw-shadow-[inset_0px_0px_0px_1px] tw-shadow-text-default-color": t.value && !n.isDisabled,
          "tw-pointer-events-none tw-text-discrete3": n.isDisabled,
          "!tw-border-error": n.hasError
        },
        n.size === "sm" ? "tw-p-sm tw-pl-md" : "tw-p-lg"
      ]])
    }, [
      V("span", Gl, [
        oe(Gs, {
          modelValue: t.value,
          "onUpdate:modelValue": o[0] || (o[0] = (r) => t.value = r),
          "has-error": n.hasError,
          "is-disabled": n.isDisabled,
          class: P(["tw-pointer-events-none", {
            "tw-sr-only": !n.displayCheckbox
          }])
        }, null, 8, ["modelValue", "has-error", "is-disabled", "class"]),
        V("span", Ql, [
          V("span", Yl, [
            n.text ? (y(), I("span", Xl, Z(n.text), 1)) : z("", !0),
            n.subText ? (y(), I("span", {
              key: 1,
              class: P(n.text ? "tw-text-body-sm" : "tw-text-body")
            }, Z(n.subText), 3)) : z("", !0)
          ]),
          n.tagText ? (y(), H(ql, {
            key: 0,
            text: n.tagText,
            color: n.isDisabled ? "disabled" : "default",
            class: P({
              "!tw-bg-fill-discrete2": t.value
            })
          }, null, 8, ["text", "color", "class"])) : z("", !0)
        ]),
        n.iconName ? (y(), H(q, {
          key: 0,
          name: n.iconName,
          size: n.size === "sm" ? "xl" : "2xl",
          class: "tw-text-icon"
        }, null, 8, ["name", "size"])) : z("", !0)
      ])
    ], 2));
  }
}), Jl = { class: "tabs" }, e0 = {
  role: "tablist",
  class: "tw-flex tw-gap-x-2xl"
}, t0 = ["aria-selected", "aria-controls", "disabled", "tabindex", "onClick", "onKeydown"], n0 = ["id", "aria-labelledby"], o0 = {}, C0 = /* @__PURE__ */ Q({
  ...o0,
  __name: "UITab",
  props: {
    tabsTitles: {},
    disabledTabsTitles: { default: () => [] },
    isTextColorInverse: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, o = Pe(), r = t, a = B(0), i = Oe("tabRefs"), l = Object.keys(o), s = k(() => n.tabsTitles.map((f, d) => l.includes(`tab-${d}`) ? d : null).filter((f) => f !== null));
    function c(f) {
      n.disabledTabsTitles.includes(n.tabsTitles[f]) || (a.value = f, r("click"));
    }
    function u(f, d) {
      var h, v;
      if (d.key === "ArrowRight") {
        const x = f === n.tabsTitles.length - 1 ? f : f + 1;
        (h = i.value[x]) == null || h.focus();
      } else if (d.key === "ArrowLeft") {
        const x = f === 0 ? f : f - 1;
        (v = i.value[x]) == null || v.focus();
      }
    }
    return (f, d) => (y(), I("div", Jl, [
      V("div", e0, [
        (y(!0), I(bt, null, $n(f.tabsTitles, (h, v) => (y(), I("button", {
          key: h,
          ref_for: !0,
          ref_key: "tabRefs",
          ref: i,
          role: "tab",
          "aria-selected": a.value === v,
          "aria-controls": `tab-${v}`,
          disabled: f.disabledTabsTitles.includes(h),
          tabindex: a.value === v ? 0 : -1,
          class: P(["tw-border-b-4 tw-border-b-transparent tw-pb-sm tw-font-bold", {
            "!tw-border-b-primary": a.value === v,
            "tw-text-inverse": f.isTextColorInverse,
            "!tw-text-discrete3": f.disabledTabsTitles.includes(h),
            "hover:!tw-border-b-discrete3": !f.disabledTabsTitles.includes(h)
          }]),
          onClick: (x) => c(v),
          onKeydown: (x) => u(v, x)
        }, Z(h), 43, t0))), 128))
      ]),
      (y(!0), I(bt, null, $n(s.value, (h) => nt((y(), I("section", {
        id: `tab-${h}`,
        key: h,
        role: "tabpanel",
        "aria-labelledby": f.tabsTitles[h]
      }, [
        R(f.$slots, `tab-${h}`)
      ], 8, n0)), [
        [Lr, a.value === h]
      ])), 128))
    ]));
  }
}), r0 = ["aria-controlledby", "onMouseleave", "onKeydown"], i0 = {}, a0 = /* @__PURE__ */ Q({
  ...i0,
  __name: "UITooltip",
  props: {
    forceHidden: { type: Boolean, default: !1 },
    forceShown: { type: Boolean, default: !1 },
    hideArrow: { type: Boolean, default: !1 },
    hideDelay: { default: 0 },
    placement: { default: "bottom" },
    showWhenClicked: { type: Boolean, default: !1 }
  },
  emits: ["show", "hide"],
  setup(e, { emit: t }) {
    const n = e, o = t, r = Pe(), a = B(), i = ot(), l = `${i}-tooltip-content`, s = Oe("tooltipContentRef"), c = B(!1), u = k(() => c.value ? "" : n.placement.includes("top") ? "emptyHoverAreaBottom" : n.placement.includes("bottom") ? "emptyHoverAreaTop" : n.placement.includes("left") ? "emptyHoverAreaRight" : n.placement.includes("right") ? "emptyHoverAreaLeft" : "");
    function f(p, g = !0) {
      !g || c.value || n.forceShown || (clearTimeout(a.value), a.value = setTimeout(() => p(!1), n.hideDelay));
    }
    function d() {
      clearTimeout(a.value);
    }
    function h(p) {
      var g;
      n.forceHidden || n.forceShown || (clearTimeout(a.value), p(!0), (g = s.value) == null || g.focus());
    }
    function v(p, g) {
      var C;
      if (!(!n.showWhenClicked || n.forceHidden || n.forceShown)) {
        if (!c.value) {
          c.value = !0, p(!0), (C = s.value) == null || C.focus();
          return;
        }
        c.value = !c.value, g && p(!1);
      }
    }
    function x(p) {
      p(!1), c.value = !1;
    }
    function w() {
      c.value = !1;
    }
    return (p, g) => (y(), H(dr, {
      placement: p.placement,
      "has-arrow": !p.hideArrow,
      "force-show-floating-el": p.forceShown,
      onClickOutside: w,
      onHideFloating: g[0] || (g[0] = (C) => o("hide")),
      onShowFloating: g[1] || (g[1] = (C) => o("show"))
    }, {
      reference: G(({ toggleContentDisplay: C, isFloatingElDisplayed: S }) => [
        F(te)(r.referenceEl) ? R(p.$slots, "referenceEl", {
          key: 0,
          id: F(i),
          ariaDescribedby: l,
          ariaExpanded: S,
          onClick: (D) => v(C, S),
          onMouseenter: (D) => h(C),
          onMouseleave: (D) => f(C, S),
          onKeydown: qt((D) => x(C), ["escape"])
        }, void 0, !0) : z("", !0)
      ]),
      floating: G(({ toggleContentDisplay: C }) => [
        F(te)(r.tooltipContent) ? (y(), I("div", {
          key: 0,
          id: l,
          ref: "tooltipContentRef",
          class: P(["tw-text-body-xs tw-relative tw-z-[999999] tw-flex tw-max-w-[224px] tw-flex-col tw-gap-y-sm tw-rounded-sm tw-bg-fill-alt tw-p-sm tw-text-inverse focus:tw-outline-none", u.value]),
          "aria-controlledby": F(i),
          tabindex: "-1",
          role: "tooltip",
          onMouseenter: d,
          onMouseleave: (S) => f(C),
          onKeydown: qt((S) => x(C), ["escape"])
        }, [
          R(p.$slots, "tooltipContent", {}, void 0, !0)
        ], 42, r0)) : z("", !0)
      ]),
      _: 3
    }, 8, ["placement", "has-arrow", "force-show-floating-el"]));
  }
}), T0 = /* @__PURE__ */ tr(a0, [["__scopeId", "data-v-5ddfca42"]]);
Go(Vr);
export {
  c0 as Iconify,
  wa as UIBanner,
  f0 as UIBannerMulti,
  d0 as UIButton,
  h0 as UIButtonLink,
  p0 as UIDropdownMenu,
  m0 as UIDropdownMenuList,
  v0 as UIDropdownMenuListItem,
  q as UIIcon,
  Gs as UIInputCheckbox,
  b0 as UIInputPassword,
  w0 as UIInputText,
  g0 as UIInputTextarea,
  y0 as UIModal,
  x0 as UISelectionCard,
  C0 as UITab,
  ql as UITag,
  T0 as UITooltip,
  u0 as grooverUITailwindPlugin
};
